!(function (e, t) {
    "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(((e = "undefined" != typeof globalThis ? globalThis : e || self).FloatingUIT4sCore = {}));
})(this, function (e) {
    "use strict";
    function t(e) {
        return e.split("-")[0];
    }
    function n(e) {
        return e.split("-")[1];
    }
    function i(e) {
        return ["top", "bottom"].includes(t(e)) ? "x" : "y";
    }
    function o(e) {
        return "y" === e ? "height" : "width";
    }
    function a(e, a, s) {
        let { reference: r, floating: l } = e;
        const c = r.x + r.width / 2 - l.width / 2,
            d = r.y + r.height / 2 - l.height / 2,
            u = i(a),
            p = o(u),
            m = r[p] / 2 - l[p] / 2,
            f = "x" === u;
        let h;
        switch (t(a)) {
            case "top":
                h = { x: c, y: r.y - l.height };
                break;
            case "bottom":
                h = { x: c, y: r.y + r.height };
                break;
            case "right":
                h = { x: r.x + r.width, y: d };
                break;
            case "left":
                h = { x: r.x - l.width, y: d };
                break;
            default:
                h = { x: r.x, y: r.y };
        }
        switch (n(a)) {
            case "start":
                h[u] -= m * (s && f ? -1 : 1);
                break;
            case "end":
                h[u] += m * (s && f ? -1 : 1);
        }
        return h;
    }
    function s(e) {
        return "number" != typeof e
            ? (function (e) {
                  return { top: 0, right: 0, bottom: 0, left: 0, ...e };
              })(e)
            : { top: e, right: e, bottom: e, left: e };
    }
    function r(e) {
        return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
    }
    async function l(e, t) {
        var n;
        void 0 === t && (t = {});
        const { x: i, y: o, platform: a, rects: l, elements: c, strategy: d } = e,
            { boundary: u = "clippingAncestors", rootBoundary: p = "viewport", elementContext: m = "floating", altBoundary: f = !1, padding: h = 0 } = t,
            g = s(h),
            v = c[f ? ("floating" === m ? "reference" : "floating") : m],
            T = r(
                await a.getClippingRect({
                    element: null == (n = await (null == a.isElement ? void 0 : a.isElement(v))) || n ? v : v.contextElement || (await (null == a.getDocumentElement ? void 0 : a.getDocumentElement(c.floating))),
                    boundary: u,
                    rootBoundary: p,
                })
            ),
            y = r(
                a.convertOffsetParentRelativeRectToViewportRelativeRect
                    ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
                          rect: "floating" === m ? { ...l.floating, x: i, y: o } : l.reference,
                          offsetParent: await (null == a.getOffsetParent ? void 0 : a.getOffsetParent(c.floating)),
                          strategy: d,
                      })
                    : l[m]
            );
        return { top: T.top - y.top + g.top, bottom: y.bottom - T.bottom + g.bottom, left: T.left - y.left + g.left, right: y.right - T.right + g.right };
    }
    function c(e, t, n) {
        return v(e, g(t, n));
    }
    function d(e) {
        return e.replace(/left|right|bottom|top/g, (e) => T[e]);
    }
    function u(e, t, a) {
        void 0 === a && (a = !1);
        const s = n(e),
            r = i(e),
            l = o(r);
        let c = "x" === r ? (s === (a ? "end" : "start") ? "right" : "left") : "start" === s ? "bottom" : "top";
        return t.reference[l] > t.floating[l] && (c = d(c)), { main: c, cross: d(c) };
    }
    function p(e) {
        return e.replace(/start|end/g, (e) => y[e]);
    }
    function m(e, t) {
        return { top: e.top - t.height, right: e.right - t.width, bottom: e.bottom - t.height, left: e.left - t.width };
    }
    function f(e) {
        return S.some((t) => e[t] >= 0);
    }
    function h(e) {
        return "x" === e ? "y" : "x";
    }
    const g = Math.min,
        v = Math.max,
        T = { left: "right", right: "left", bottom: "top", top: "bottom" },
        y = { start: "end", end: "start" },
        S = ["top", "right", "bottom", "left"],
        w = S.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
    (e.arrow = (e) => ({
        name: "arrow",
        options: e,
        async fn(t) {
            const { element: n, padding: a = 0 } = null != e ? e : {},
                { x: r, y: l, placement: d, rects: u, platform: p } = t;
            if (null == n) return {};
            const m = s(a),
                f = { x: r, y: l },
                h = i(d),
                g = o(h),
                v = await p.getDimensions(n),
                T = "y" === h ? "top" : "left",
                y = "y" === h ? "bottom" : "right",
                S = u.reference[g] + u.reference[h] - f[h] - u.floating[g],
                w = f[h] - u.reference[h],
                b = await (null == p.getOffsetParent ? void 0 : p.getOffsetParent(n)),
                x = b ? ("y" === h ? b.clientHeight || 0 : b.clientWidth || 0) : 0,
                C = S / 2 - w / 2,
                _ = m[T],
                P = x - v[g] - m[y],
                k = x / 2 - v[g] / 2 + C,
                I = c(_, k, P);
            return { data: { [h]: I, centerOffset: k - I } };
        },
    })),
        (e.autoPlacement = function (e) {
            return (
                void 0 === e && (e = {}),
                {
                    name: "autoPlacement",
                    options: e,
                    async fn(i) {
                        var o, a, s, r, c;
                        const { x: d, y: m, rects: f, middlewareData: h, placement: g, platform: v, elements: T } = i,
                            { alignment: y = null, allowedPlacements: S = w, autoAlignment: b = !0, ...x } = e,
                            C = (function (e, i, o) {
                                return (e ? [...o.filter((t) => n(t) === e), ...o.filter((t) => n(t) !== e)] : o.filter((e) => t(e) === e)).filter((t) => !e || n(t) === e || (!!i && p(t) !== t));
                            })(y, b, S),
                            _ = await l(i, x),
                            P = null != (o = null == (a = h.autoPlacement) ? void 0 : a.index) ? o : 0,
                            k = C[P],
                            { main: I, cross: D } = u(k, f, await (null == v.isRTL ? void 0 : v.isRTL(T.floating)));
                        if (g !== k) return { x: d, y: m, reset: { skip: !1, placement: C[0] } };
                        const A = [_[t(k)], _[I], _[D]],
                            M = [...(null != (s = null == (r = h.autoPlacement) ? void 0 : r.overflows) ? s : []), { placement: k, overflows: A }],
                            E = C[P + 1];
                        if (E) return { data: { index: P + 1, overflows: M }, reset: { skip: !1, placement: E } };
                        const R = M.slice().sort((e, t) => e.overflows[0] - t.overflows[0]),
                            O =
                                null ==
                                (c = R.find((e) => {
                                    let { overflows: t } = e;
                                    return t.every((e) => e <= 0);
                                }))
                                    ? void 0
                                    : c.placement;
                        return { reset: { placement: null != O ? O : R[0].placement } };
                    },
                }
            );
        }),
        (e.computePosition = async (e, t, n) => {
            const { placement: i = "bottom", strategy: o = "absolute", middleware: s = [], platform: r } = n,
                l = await (null == r.isRTL ? void 0 : r.isRTL(t));
            let c = await r.getElementRects({ reference: e, floating: t, strategy: o }),
                { x: d, y: u } = a(c, i, l),
                p = i,
                m = {};
            const f = new Set();
            for (let n = 0; n < s.length; n++) {
                const { name: h, fn: g } = s[n];
                if (f.has(h)) continue;
                const { x: v, y: T, data: y, reset: S } = await g({ x: d, y: u, initialPlacement: i, placement: p, strategy: o, middlewareData: m, rects: c, platform: r, elements: { reference: e, floating: t } });
                (d = null != v ? v : d),
                    (u = null != T ? T : u),
                    (m = { ...m, [h]: { ...m[h], ...y } }),
                    S &&
                        ("object" == typeof S &&
                            (S.placement && (p = S.placement), S.rects && (c = !0 === S.rects ? await r.getElementRects({ reference: e, floating: t, strategy: o }) : S.rects), ({ x: d, y: u } = a(c, p, l)), !1 !== S.skip && f.add(h)),
                        (n = -1));
            }
            return { x: d, y: u, placement: p, strategy: o, middlewareData: m };
        }),
        (e.detectOverflow = l),
        (e.flip = function (e) {
            return (
                void 0 === e && (e = {}),
                {
                    name: "flip",
                    options: e,
                    async fn(n) {
                        var i;
                        const { placement: o, middlewareData: a, rects: s, initialPlacement: r, platform: c, elements: m } = n,
                            { mainAxis: f = !0, crossAxis: h = !0, fallbackPlacements: g, fallbackStrategy: v = "bestFit", flipAlignment: T = !0, ...y } = e,
                            S = t(o),
                            w = [
                                r,
                                ...(g ||
                                    (S !== r && T
                                        ? (function (e) {
                                              const t = d(e);
                                              return [p(e), t, p(t)];
                                          })(r)
                                        : [d(r)])),
                            ],
                            b = await l(n, y),
                            x = [];
                        let C = (null == (i = a.flip) ? void 0 : i.overflows) || [];
                        if ((f && x.push(b[S]), h)) {
                            const { main: e, cross: t } = u(o, s, await (null == c.isRTL ? void 0 : c.isRTL(m.floating)));
                            x.push(b[e], b[t]);
                        }
                        if (((C = [...C, { placement: o, overflows: x }]), !x.every((e) => e <= 0))) {
                            var _, P;
                            const e = (null != (_ = null == (P = a.flip) ? void 0 : P.index) ? _ : 0) + 1,
                                t = w[e];
                            if (t) return { data: { index: e, overflows: C }, reset: { skip: !1, placement: t } };
                            let n = "bottom";
                            switch (v) {
                                case "bestFit": {
                                    var k;
                                    const e = null == (k = C.slice().sort((e, t) => e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0) - t.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0))[0]) ? void 0 : k.placement;
                                    e && (n = e);
                                    break;
                                }
                                case "initialPlacement":
                                    n = r;
                            }
                            return { reset: { placement: n } };
                        }
                        return {};
                    },
                }
            );
        }),
        (e.hide = function (e) {
            let { strategy: t = "referenceHidden", ...n } = void 0 === e ? {} : e;
            return {
                name: "hide",
                async fn(e) {
                    const { rects: i } = e;
                    switch (t) {
                        case "referenceHidden": {
                            const t = m(await l(e, { ...n, elementContext: "reference" }), i.reference);
                            return { data: { referenceHiddenOffsets: t, referenceHidden: f(t) } };
                        }
                        case "escaped": {
                            const t = m(await l(e, { ...n, altBoundary: !0 }), i.floating);
                            return { data: { escapedOffsets: t, escaped: f(t) } };
                        }
                        default:
                            return {};
                    }
                },
            };
        }),
        (e.inline = function (e) {
            return (
                void 0 === e && (e = {}),
                {
                    name: "inline",
                    options: e,
                    async fn(n) {
                        var o;
                        const { placement: a, elements: l, rects: c, platform: d, strategy: u } = n,
                            { padding: p = 2, x: m, y: f } = e,
                            h = r(
                                d.convertOffsetParentRelativeRectToViewportRelativeRect
                                    ? await d.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: c.reference, offsetParent: await (null == d.getOffsetParent ? void 0 : d.getOffsetParent(l.floating)), strategy: u })
                                    : c.reference
                            ),
                            T = null != (o = await (null == d.getClientRects ? void 0 : d.getClientRects(l.reference))) ? o : [],
                            y = s(p);
                        return {
                            reset: {
                                rects: await d.getElementRects({
                                    reference: {
                                        getBoundingClientRect: function () {
                                            var e;
                                            if (2 === T.length && T[0].left > T[1].right && null != m && null != f)
                                                return null != (e = T.find((e) => m > e.left - y.left && m < e.right + y.right && f > e.top - y.top && f < e.bottom + y.bottom)) ? e : h;
                                            if (T.length >= 2) {
                                                if ("x" === i(a)) {
                                                    const e = T[0],
                                                        n = T[T.length - 1],
                                                        i = "top" === t(a),
                                                        o = e.top,
                                                        s = n.bottom,
                                                        r = i ? e.left : n.left,
                                                        l = i ? e.right : n.right;
                                                    return { top: o, bottom: s, left: r, right: l, width: l - r, height: s - o, x: r, y: o };
                                                }
                                                const e = "left" === t(a),
                                                    n = v(...T.map((e) => e.right)),
                                                    o = g(...T.map((e) => e.left)),
                                                    s = T.filter((t) => (e ? t.left === o : t.right === n)),
                                                    r = s[0].top,
                                                    l = s[s.length - 1].bottom;
                                                return { top: r, bottom: l, left: o, right: n, width: n - o, height: l - r, x: o, y: r };
                                            }
                                            return h;
                                        },
                                    },
                                    floating: l.floating,
                                    strategy: u,
                                }),
                            },
                        };
                    },
                }
            );
        }),
        (e.limitShift = function (e) {
            return (
                void 0 === e && (e = {}),
                {
                    options: e,
                    fn(n) {
                        const { x: o, y: a, placement: s, rects: r, middlewareData: l } = n,
                            { offset: c = 0, mainAxis: d = !0, crossAxis: u = !0 } = e,
                            p = { x: o, y: a },
                            m = i(s),
                            f = h(m);
                        let g = p[m],
                            v = p[f];
                        const T = "function" == typeof c ? c({ ...r, placement: s }) : c,
                            y = "number" == typeof T ? { mainAxis: T, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...T };
                        if (d) {
                            const e = "y" === m ? "height" : "width",
                                t = r.reference[m] - r.floating[e] + y.mainAxis,
                                n = r.reference[m] + r.reference[e] - y.mainAxis;
                            g < t ? (g = t) : g > n && (g = n);
                        }
                        if (u) {
                            var S, w, b, x;
                            const e = "y" === m ? "width" : "height",
                                n = ["top", "left"].includes(t(s)),
                                i = r.reference[f] - r.floating[e] + (n && null != (S = null == (w = l.offset) ? void 0 : w[f]) ? S : 0) + (n ? 0 : y.crossAxis),
                                o = r.reference[f] + r.reference[e] + (n ? 0 : null != (b = null == (x = l.offset) ? void 0 : x[f]) ? b : 0) - (n ? y.crossAxis : 0);
                            v < i ? (v = i) : v > o && (v = o);
                        }
                        return { [m]: g, [f]: v };
                    },
                }
            );
        }),
        (e.offset = function (e) {
            return (
                void 0 === e && (e = 0),
                {
                    name: "offset",
                    options: e,
                    async fn(o) {
                        const { x: a, y: s, placement: r, rects: l, platform: c, elements: d } = o,
                            u = (function (e, o, a, s) {
                                void 0 === s && (s = !1);
                                const r = t(e),
                                    l = n(e),
                                    c = "x" === i(e),
                                    d = ["left", "top"].includes(r) ? -1 : 1;
                                let u = 1;
                                "end" === l && (u = -1), s && c && (u *= -1);
                                const p = "function" == typeof a ? a({ ...o, placement: e }) : a,
                                    { mainAxis: m, crossAxis: f } = "number" == typeof p ? { mainAxis: p, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...p };
                                return c ? { x: f * u, y: m * d } : { x: m * d, y: f * u };
                            })(r, l, e, await (null == c.isRTL ? void 0 : c.isRTL(d.floating)));
                        return { x: a + u.x, y: s + u.y, data: u };
                    },
                }
            );
        }),
        (e.rectToClientRect = r),
        (e.shift = function (e) {
            return (
                void 0 === e && (e = {}),
                {
                    name: "shift",
                    options: e,
                    async fn(n) {
                        const { x: o, y: a, placement: s } = n,
                            {
                                mainAxis: r = !0,
                                crossAxis: d = !1,
                                limiter: u = {
                                    fn: (e) => {
                                        let { x: t, y: n } = e;
                                        return { x: t, y: n };
                                    },
                                },
                                ...p
                            } = e,
                            m = { x: o, y: a },
                            f = await l(n, p),
                            g = i(t(s)),
                            v = h(g);
                        let T = m[g],
                            y = m[v];
                        if (r) {
                            const e = "y" === g ? "bottom" : "right";
                            T = c(T + f["y" === g ? "top" : "left"], T, T - f[e]);
                        }
                        if (d) {
                            const e = "y" === v ? "bottom" : "right";
                            y = c(y + f["y" === v ? "top" : "left"], y, y - f[e]);
                        }
                        const S = u.fn({ ...n, [g]: T, [v]: y });
                        return { ...S, data: { x: S.x - o, y: S.y - a } };
                    },
                }
            );
        }),
        (e.size = function (e) {
            return (
                void 0 === e && (e = {}),
                {
                    name: "size",
                    options: e,
                    async fn(i) {
                        const { placement: o, rects: a, platform: s, elements: r } = i,
                            { apply: c, ...d } = e,
                            u = await l(i, d),
                            p = t(o),
                            m = n(o);
                        let f, h;
                        "top" === p || "bottom" === p ? ((f = p), (h = m === ((await (null == s.isRTL ? void 0 : s.isRTL(r.floating))) ? "start" : "end") ? "left" : "right")) : ((h = p), (f = "end" === m ? "top" : "bottom"));
                        const g = v(u.left, 0),
                            T = v(u.right, 0),
                            y = v(u.top, 0),
                            S = v(u.bottom, 0),
                            w = {
                                height: a.floating.height - (["left", "right"].includes(o) ? 2 * (0 !== y || 0 !== S ? y + S : v(u.top, u.bottom)) : u[f]),
                                width: a.floating.width - (["top", "bottom"].includes(o) ? 2 * (0 !== g || 0 !== T ? g + T : v(u.left, u.right)) : u[h]),
                            };
                        return null == c || c({ ...w, ...a }), { reset: { rects: !0 } };
                    },
                }
            );
        }),
        Object.defineProperty(e, "__esModule", { value: !0 });
}),
    (function (e, t) {
        "object" == typeof exports && "undefined" != typeof module
            ? t(exports, require("@floating-ui/core"))
            : "function" == typeof define && define.amd
            ? define(["exports", "@floating-ui/core"], t)
            : t(((e = "undefined" != typeof globalThis ? globalThis : e || self).FloatingUIT4sDOM = {}), e.FloatingUIT4sCore);
    })(this, function (e, t) {
        "use strict";
        function n(e) {
            return "[object Window]" === (null == e ? void 0 : e.toString());
        }
        function i(e) {
            if (null == e) return window;
            if (!n(e)) {
                const t = e.ownerDocument;
                return (t && t.defaultView) || window;
            }
            return e;
        }
        function o(e) {
            return i(e).getComputedStyle(e);
        }
        function a(e) {
            return n(e) ? "" : e ? (e.nodeName || "").toLowerCase() : "";
        }
        function s(e) {
            return e instanceof i(e).HTMLElement;
        }
        function r(e) {
            return e instanceof i(e).Element;
        }
        function l(e) {
            return e instanceof i(e).ShadowRoot || e instanceof ShadowRoot;
        }
        function c(e) {
            const { overflow: t, overflowX: n, overflowY: i } = o(e);
            return /auto|scroll|overlay|hidden/.test(t + i + n);
        }
        function d(e) {
            return ["table", "td", "th"].includes(a(e));
        }
        function u(e) {
            const t = navigator.userAgent.toLowerCase().includes("firefox"),
                n = o(e);
            return "none" !== n.transform || "none" !== n.perspective || "paint" === n.contain || ["transform", "perspective"].includes(n.willChange) || (t && "filter" === n.willChange) || (t && !!n.filter && "none" !== n.filter);
        }
        function p(e, t) {
            void 0 === t && (t = !1);
            const n = e.getBoundingClientRect();
            let i = 1,
                o = 1;
            return (
                t && s(e) && ((i = (e.offsetWidth > 0 && _(n.width) / e.offsetWidth) || 1), (o = (e.offsetHeight > 0 && _(n.height) / e.offsetHeight) || 1)),
                { width: n.width / i, height: n.height / o, top: n.top / o, right: n.right / i, bottom: n.bottom / o, left: n.left / i, x: n.left / i, y: n.top / o }
            );
        }
        function m(e) {
            return (((t = e) instanceof i(t).Node ? e.ownerDocument : e.document) || window.document).documentElement;
            var t;
        }
        function f(e) {
            return n(e) ? { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset } : { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop };
        }
        function h(e) {
            return p(m(e)).left + f(e).scrollLeft;
        }
        function g(e) {
            return "html" === a(e) ? e : e.assignedSlot || e.parentNode || (l(e) ? e.host : null) || m(e);
        }
        function v(e) {
            return s(e) && "fixed" !== getComputedStyle(e).position ? e.offsetParent : null;
        }
        function T(e) {
            const t = i(e);
            let n = v(e);
            for (; n && d(n) && "static" === getComputedStyle(n).position; ) n = v(n);
            return n && ("html" === a(n) || ("body" === a(n) && "static" === getComputedStyle(n).position && !u(n)))
                ? t
                : n ||
                      (function (e) {
                          let t = g(e);
                          for (l(t) && (t = t.host); s(t) && !["html", "body"].includes(a(t)); ) {
                              if (u(t)) return t;
                              t = t.parentNode;
                          }
                          return null;
                      })(e) ||
                      t;
        }
        function y(e) {
            if (s(e)) return { width: e.offsetWidth, height: e.offsetHeight };
            const t = p(e);
            return { width: t.width, height: t.height };
        }
        function S(e, t) {
            var n;
            void 0 === t && (t = []);
            const o = (function e(t) {
                    return ["html", "body", "#document"].includes(a(t)) ? t.ownerDocument.body : s(t) && c(t) ? t : e(g(t));
                })(e),
                r = o === (null == (n = e.ownerDocument) ? void 0 : n.body),
                l = i(o),
                d = r ? [l].concat(l.visualViewport || [], c(o) ? o : []) : o,
                u = t.concat(d);
            return r ? u : u.concat(S(g(d)));
        }
        function w(e, n) {
            return "viewport" === n
                ? t.rectToClientRect(
                      (function (e) {
                          const t = i(e),
                              n = m(e),
                              o = t.visualViewport;
                          let a = n.clientWidth,
                              s = n.clientHeight,
                              r = 0,
                              l = 0;
                          return o && ((a = o.width), (s = o.height), Math.abs(t.innerWidth / o.scale - o.width) < 0.01 && ((r = o.offsetLeft), (l = o.offsetTop))), { width: a, height: s, x: r, y: l };
                      })(e)
                  )
                : r(n)
                ? (function (e) {
                      const t = p(e),
                          n = t.top + e.clientTop,
                          i = t.left + e.clientLeft;
                      return { top: n, left: i, x: i, y: n, right: i + e.clientWidth, bottom: n + e.clientHeight, width: e.clientWidth, height: e.clientHeight };
                  })(n)
                : t.rectToClientRect(
                      (function (e) {
                          var t;
                          const n = m(e),
                              i = f(e),
                              a = null == (t = e.ownerDocument) ? void 0 : t.body,
                              s = C(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0),
                              r = C(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0);
                          let l = -i.scrollLeft + h(e);
                          const c = -i.scrollTop;
                          return "rtl" === o(a || n).direction && (l += C(n.clientWidth, a ? a.clientWidth : 0) - s), { width: s, height: r, x: l, y: c };
                      })(m(e))
                  );
        }
        function b(e) {
            const t = S(g(e)),
                n = ["absolute", "fixed"].includes(o(e).position) && s(e) ? T(e) : e;
            return r(n)
                ? t.filter(
                      (e) =>
                          r(e) &&
                          (function (e, t) {
                              const n = null == t.getRootNode ? void 0 : t.getRootNode();
                              if (e.contains(t)) return !0;
                              if (n && l(n)) {
                                  let n = t;
                                  do {
                                      if (n && e === n) return !0;
                                      n = n.parentNode || n.host;
                                  } while (n);
                              }
                              return !1;
                          })(e, n) &&
                          "body" !== a(e)
                  )
                : [];
        }
        const x = Math.min,
            C = Math.max,
            _ = Math.round,
            P = {
                getClippingRect: function (e) {
                    let { element: t, boundary: n, rootBoundary: i } = e;
                    const o = [...("clippingAncestors" === n ? b(t) : [].concat(n)), i],
                        a = o[0],
                        s = o.reduce((e, n) => {
                            const i = w(t, n);
                            return (e.top = C(i.top, e.top)), (e.right = x(i.right, e.right)), (e.bottom = x(i.bottom, e.bottom)), (e.left = C(i.left, e.left)), e;
                        }, w(t, a));
                    return { width: s.right - s.left, height: s.bottom - s.top, x: s.left, y: s.top };
                },
                convertOffsetParentRelativeRectToViewportRelativeRect: function (e) {
                    let { rect: t, offsetParent: n, strategy: i } = e;
                    const o = s(n),
                        r = m(n);
                    if (n === r) return t;
                    let l = { scrollLeft: 0, scrollTop: 0 };
                    const d = { x: 0, y: 0 };
                    if ((o || (!o && "fixed" !== i)) && (("body" !== a(n) || c(r)) && (l = f(n)), s(n))) {
                        const e = p(n, !0);
                        (d.x = e.x + n.clientLeft), (d.y = e.y + n.clientTop);
                    }
                    return { ...t, x: t.x - l.scrollLeft + d.x, y: t.y - l.scrollTop + d.y };
                },
                isElement: r,
                getDimensions: y,
                getOffsetParent: T,
                getDocumentElement: m,
                getElementRects: (e) => {
                    let { reference: t, floating: n, strategy: i } = e;
                    return {
                        reference: (function (e, t, n) {
                            const i = s(t),
                                o = m(t),
                                r = p(
                                    e,
                                    i &&
                                        (function (e) {
                                            const t = p(e);
                                            return _(t.width) !== e.offsetWidth || _(t.height) !== e.offsetHeight;
                                        })(t)
                                );
                            let l = { scrollLeft: 0, scrollTop: 0 };
                            const d = { x: 0, y: 0 };
                            if (i || (!i && "fixed" !== n))
                                if ((("body" !== a(t) || c(o)) && (l = f(t)), s(t))) {
                                    const e = p(t, !0);
                                    (d.x = e.x + t.clientLeft), (d.y = e.y + t.clientTop);
                                } else o && (d.x = h(o));
                            return { x: r.left + l.scrollLeft - d.x, y: r.top + l.scrollTop - d.y, width: r.width, height: r.height };
                        })(t, T(n), i),
                        floating: { ...y(n), x: 0, y: 0 },
                    };
                },
                getClientRects: (e) => Array.from(e.getClientRects()),
                isRTL: (e) => "rtl" === o(e).direction,
            };
        Object.defineProperty(e, "arrow", {
            enumerable: !0,
            get: function () {
                return t.arrow;
            },
        }),
            Object.defineProperty(e, "autoPlacement", {
                enumerable: !0,
                get: function () {
                    return t.autoPlacement;
                },
            }),
            Object.defineProperty(e, "detectOverflow", {
                enumerable: !0,
                get: function () {
                    return t.detectOverflow;
                },
            }),
            Object.defineProperty(e, "flip", {
                enumerable: !0,
                get: function () {
                    return t.flip;
                },
            }),
            Object.defineProperty(e, "hide", {
                enumerable: !0,
                get: function () {
                    return t.hide;
                },
            }),
            Object.defineProperty(e, "inline", {
                enumerable: !0,
                get: function () {
                    return t.inline;
                },
            }),
            Object.defineProperty(e, "limitShift", {
                enumerable: !0,
                get: function () {
                    return t.limitShift;
                },
            }),
            Object.defineProperty(e, "offset", {
                enumerable: !0,
                get: function () {
                    return t.offset;
                },
            }),
            Object.defineProperty(e, "shift", {
                enumerable: !0,
                get: function () {
                    return t.shift;
                },
            }),
            Object.defineProperty(e, "size", {
                enumerable: !0,
                get: function () {
                    return t.size;
                },
            }),
            (e.autoUpdate = function (e, t, n, i) {
                void 0 === i && (i = {});
                const { ancestorScroll: o = !0, ancestorResize: a = !0, elementResize: s = !0, animationFrame: l = !1 } = i;
                let c = !1;
                const d = o && !l,
                    u = a && !l,
                    m = s && !l,
                    f = d || u ? [...(r(e) ? S(e) : []), ...S(t)] : [];
                f.forEach((e) => {
                    d && e.addEventListener("scroll", n, { passive: !0 }), u && e.addEventListener("resize", n);
                });
                let h,
                    g = null;
                m && ((g = new ResizeObserver(n)), r(e) && g.observe(e), g.observe(t));
                let v = l ? p(e) : null;
                return (
                    l &&
                        (function t() {
                            if (c) return;
                            const i = p(e);
                            !v || (i.x === v.x && i.y === v.y && i.width === v.width && i.height === v.height) || n(), (v = i), (h = requestAnimationFrame(t));
                        })(),
                    () => {
                        var e;
                        (c = !0),
                            f.forEach((e) => {
                                d && e.removeEventListener("scroll", n), u && e.removeEventListener("resize", n);
                            }),
                            null == (e = g) || e.disconnect(),
                            (g = null),
                            l && cancelAnimationFrame(h);
                    }
                );
            }),
            (e.computePosition = (e, n, i) => t.computePosition(e, n, { platform: P, ...i })),
            (e.getOverflowAncestors = S),
            Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (function (e) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jQuery_T4NT"], e) : "object" == typeof module && module.exports ? (module.exports = e(require("jQuery_T4NT"))) : jQuery_T4NT && !jQuery_T4NT.fn.hoverIntent && e(jQuery_T4NT);
    })(function (e) {
        "use strict";
        function t(e) {
            (i = e.pageX), (o = e.pageY);
        }
        function n(e) {
            return "function" == typeof e;
        }
        var i,
            o,
            a = { interval: 100, sensitivity: 6, timeout: 0 },
            s = 0,
            r = function (e, n, a, s) {
                if (Math.sqrt((a.pX - i) * (a.pX - i) + (a.pY - o) * (a.pY - o)) < s.sensitivity)
                    return n.off(a.event, t), delete a.timeoutId, (a.isActive = !0), (e.pageX = i), (e.pageY = o), delete a.pX, delete a.pY, s.over.apply(n[0], [e]);
                (a.pX = i),
                    (a.pY = o),
                    (a.timeoutId = setTimeout(function () {
                        r(e, n, a, s);
                    }, s.interval));
            };
        e.fn.hoverIntent = function (i, o, l) {
            function c(n) {
                var i = e.extend({}, n),
                    o = e(this),
                    a = o.data("hoverIntent");
                a || o.data("hoverIntent", (a = {}));
                var s = a[d];
                s || (a[d] = s = { id: d }), s.timeoutId && (s.timeoutId = clearTimeout(s.timeoutId));
                var l = (s.event = "mousemove.hoverIntent.hoverIntent" + d);
                if ("mouseenter" === n.type) {
                    if (s.isActive) return;
                    (s.pX = i.pageX),
                        (s.pY = i.pageY),
                        o.off(l, t).on(l, t),
                        (s.timeoutId = setTimeout(function () {
                            r(i, o, s, u);
                        }, u.interval));
                } else {
                    if (!s.isActive) return;
                    o.off(l, t),
                        (s.timeoutId = setTimeout(function () {
                            !(function (e, t, n, i) {
                                var o = t.data("hoverIntent");
                                o && delete o[n.id], i.apply(t[0], [e]);
                            })(i, o, s, u.out);
                        }, u.timeout));
                }
            }
            var d = s++,
                u = e.extend({}, a);
            return (
                e.isPlainObject(i) ? ((u = e.extend(u, i)), n(u.out) || (u.out = u.over)) : (u = n(o) ? e.extend(u, { over: i, out: o, selector: l }) : e.extend(u, { over: i, out: i, selector: o })),
                this.on({ "mouseenter.hoverIntent": c, "mouseleave.hoverIntent": c }, u.selector)
            );
        };
    }),
    (function (e, t) {
        "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? (module.exports = t()) : (e.PhotoSwipe = t());
    })(this, function () {
        "use strict";
        return function (e, t, n, i) {
            var o = {
                features: null,
                bind: function (e, t, n, i) {
                    var o = (i ? "remove" : "add") + "EventListener";
                    t = t.split(" ");
                    for (var a = 0; a < t.length; a++) t[a] && e[o](t[a], n, !1);
                },
                isArray: function (e) {
                    return e instanceof Array;
                },
                createEl: function (e, t) {
                    var n = document.createElement(t || "div");
                    return e && (n.className = e), n;
                },
                getScrollY: function () {
                    var e = window.pageYOffset;
                    return void 0 !== e ? e : document.documentElement.scrollTop;
                },
                unbind: function (e, t, n) {
                    o.bind(e, t, n, !0);
                },
                removeClass: function (e, t) {
                    var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
                    e.className = e.className
                        .replace(n, " ")
                        .replace(/^\s\s*/, "")
                        .replace(/\s\s*$/, "");
                },
                addClass: function (e, t) {
                    o.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
                },
                hasClass: function (e, t) {
                    return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className);
                },
                getChildByClass: function (e, t) {
                    for (var n = e.firstChild; n; ) {
                        if (o.hasClass(n, t)) return n;
                        n = n.nextSibling;
                    }
                },
                arraySearch: function (e, t, n) {
                    for (var i = e.length; i--; ) if (e[i][n] === t) return i;
                    return -1;
                },
                extend: function (e, t, n) {
                    for (var i in t)
                        if (t.hasOwnProperty(i)) {
                            if (n && e.hasOwnProperty(i)) continue;
                            e[i] = t[i];
                        }
                },
                easing: {
                    sine: {
                        out: function (e) {
                            return Math.sin(e * (Math.PI / 2));
                        },
                        inOut: function (e) {
                            return -(Math.cos(Math.PI * e) - 1) / 2;
                        },
                    },
                    cubic: {
                        out: function (e) {
                            return --e * e * e + 1;
                        },
                    },
                },
                detectFeatures: function () {
                    if (o.features) return o.features;
                    var e = o.createEl().style,
                        t = "",
                        n = {};
                    if (
                        ((n.oldIE = document.all && !document.addEventListener),
                        (n.touch = "ontouchstart" in window),
                        window.requestAnimationFrame && ((n.raf = window.requestAnimationFrame), (n.caf = window.cancelAnimationFrame)),
                        (n.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled),
                        !n.pointerEvent)
                    ) {
                        var i = navigator.userAgent;
                        if (/iP(hone|od)/.test(navigator.platform)) {
                            var a = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            a && a.length > 0 && (a = parseInt(a[1], 10)) >= 1 && a < 8 && (n.isOldIOSPhone = !0);
                        }
                        var s = i.match(/Android\s([0-9\.]*)/),
                            r = s ? s[1] : 0;
                        (r = parseFloat(r)) >= 1 && (r < 4.4 && (n.isOldAndroid = !0), (n.androidVersion = r)), (n.isMobileOpera = /opera mini|opera mobi/i.test(i));
                    }
                    for (var l, c, d = ["transform", "perspective", "animationName"], u = ["", "webkit", "Moz", "ms", "O"], p = 0; p < 4; p++) {
                        t = u[p];
                        for (var m = 0; m < 3; m++) (l = d[m]), (c = t + (t ? l.charAt(0).toUpperCase() + l.slice(1) : l)), !n[l] && c in e && (n[l] = c);
                        t && !n.raf && ((t = t.toLowerCase()), (n.raf = window[t + "RequestAnimationFrame"]), n.raf && (n.caf = window[t + "CancelAnimationFrame"] || window[t + "CancelRequestAnimationFrame"]));
                    }
                    if (!n.raf) {
                        var f = 0;
                        (n.raf = function (e) {
                            var t = new Date().getTime(),
                                n = Math.max(0, 16 - (t - f)),
                                i = window.setTimeout(function () {
                                    e(t + n);
                                }, n);
                            return (f = t + n), i;
                        }),
                            (n.caf = function (e) {
                                clearTimeout(e);
                            });
                    }
                    return (n.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect), (o.features = n), n;
                },
            };
            o.detectFeatures(),
                o.features.oldIE &&
                    (o.bind = function (e, t, n, i) {
                        t = t.split(" ");
                        for (
                            var o,
                                a = (i ? "detach" : "attach") + "Event",
                                s = function () {
                                    n.handleEvent.call(n);
                                },
                                r = 0;
                            r < t.length;
                            r++
                        )
                            if ((o = t[r]))
                                if ("object" == typeof n && n.handleEvent) {
                                    if (i) {
                                        if (!n["oldIE" + o]) return !1;
                                    } else n["oldIE" + o] = s;
                                    e[a]("on" + o, n["oldIE" + o]);
                                } else e[a]("on" + o, n);
                    });
            var a = this,
                s = {
                    allowPanToNext: !0,
                    spacing: 0.12,
                    bgOpacity: 1,
                    mouseUsed: !1,
                    loop: !0,
                    pinchToClose: !0,
                    closeOnScroll: !0,
                    closeOnVerticalDrag: !0,
                    verticalDragRange: 0.75,
                    hideAnimationDuration: 333,
                    showAnimationDuration: 333,
                    showHideOpacity: !1,
                    focus: !0,
                    escKey: !0,
                    arrowKeys: !0,
                    mainScrollEndFriction: 0.35,
                    panEndFriction: 0.35,
                    isClickableElement: function (e) {
                        return "A" === e.tagName;
                    },
                    getDoubleTapZoom: function (e, t) {
                        return e ? 1 : t.initialZoomLevel < 0.7 ? 1 : 1.33;
                    },
                    maxSpreadZoom: 1.33,
                    modal: !0,
                    scaleMode: "fit",
                };
            o.extend(s, i);
            var r,
                l,
                c,
                d,
                u,
                p,
                m,
                f,
                h,
                g,
                v,
                T,
                y,
                S,
                w,
                b,
                x,
                C,
                _,
                P,
                k,
                I,
                D,
                A,
                M,
                E,
                R,
                O,
                N,
                $,
                L,
                F,
                U,
                B,
                H,
                W,
                j,
                z,
                G,
                q,
                Z,
                K,
                V,
                Y,
                X,
                J,
                Q,
                ee,
                te,
                ne,
                ie,
                oe,
                ae,
                se,
                re,
                le,
                ce,
                de = { x: 0, y: 0 },
                ue = { x: 0, y: 0 },
                pe = { x: 0, y: 0 },
                me = {},
                fe = 0,
                he = {},
                ge = { x: 0, y: 0 },
                ve = 0,
                Te = !0,
                ye = [],
                Se = {},
                we = !1,
                be = function (e, t) {
                    o.extend(a, t.publicMethods), ye.push(e);
                },
                xe = function (e) {
                    var t = Wt();
                    return e > t - 1 ? e - t : e < 0 ? t + e : e;
                },
                Ce = {},
                _e = function (e, t) {
                    return Ce[e] || (Ce[e] = []), Ce[e].push(t);
                },
                Pe = function (e) {
                    var t = Ce[e];
                    if (t) {
                        var n = Array.prototype.slice.call(arguments);
                        n.shift();
                        for (var i = 0; i < t.length; i++) t[i].apply(a, n);
                    }
                },
                ke = function () {
                    return new Date().getTime();
                },
                Ie = function (e) {
                    (re = e), (a.bg.style.opacity = e * s.bgOpacity);
                },
                De = function (e, t, n, i, o) {
                    (!we || (o && o !== a.currItem)) && (i /= o ? o.fitRatio : a.currItem.fitRatio), (e[I] = T + t + "px, " + n + "px" + y + " scale(" + i + ")");
                },
                Ae = function (e) {
                    ne && (e && (g > a.currItem.fitRatio ? we || (Jt(a.currItem, !1, !0), (we = !0)) : we && (Jt(a.currItem), (we = !1))), De(ne, pe.x, pe.y, g));
                },
                Me = function (e) {
                    e.container && De(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e);
                },
                Ee = function (e, t) {
                    t[I] = T + e + "px, 0px" + y;
                },
                Re = function (e, t) {
                    if (!s.loop && t) {
                        var n = d + (ge.x * fe - e) / ge.x,
                            i = Math.round(e - ut.x);
                        ((n < 0 && i > 0) || (n >= Wt() - 1 && i < 0)) && (e = ut.x + i * s.mainScrollEndFriction);
                    }
                    (ut.x = e), Ee(e, u);
                },
                Oe = function (e, t) {
                    var n = pt[e] - he[e];
                    return ue[e] + de[e] + n - n * (t / v);
                },
                Ne = function (e, t) {
                    (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
                },
                $e = function (e) {
                    (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
                },
                Le = null,
                Fe = function () {
                    Le && (o.unbind(document, "mousemove", Fe), o.addClass(e, "pswp--has_mouse"), (s.mouseUsed = !0), Pe("mouseUsed")),
                        (Le = setTimeout(function () {
                            Le = null;
                        }, 100));
                },
                Ue = function (e, t) {
                    var n = Kt(a.currItem, me, e);
                    return t && (te = n), n;
                },
                Be = function (e) {
                    return e || (e = a.currItem), e.initialZoomLevel;
                },
                He = function (e) {
                    return e || (e = a.currItem), e.w > 0 ? s.maxSpreadZoom : 1;
                },
                We = function (e, t, n, i) {
                    return i === a.currItem.initialZoomLevel ? ((n[e] = a.currItem.initialPosition[e]), !0) : ((n[e] = Oe(e, i)), n[e] > t.min[e] ? ((n[e] = t.min[e]), !0) : n[e] < t.max[e] && ((n[e] = t.max[e]), !0));
                },
                je = function (e) {
                    var t = "";
                    s.escKey && 27 === e.keyCode ? (t = "close") : s.arrowKeys && (37 === e.keyCode ? (t = "prev") : 39 === e.keyCode && (t = "next")),
                        t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), a[t]()));
                },
                ze = function (e) {
                    e && (K || Z || ie || j) && (e.preventDefault(), e.stopPropagation());
                },
                Ge = function () {
                    a.setScrollOffset(0, o.getScrollY());
                },
                qe = {},
                Ze = 0,
                Ke = function (e) {
                    qe[e] && (qe[e].raf && E(qe[e].raf), Ze--, delete qe[e]);
                },
                Ve = function (e) {
                    qe[e] && Ke(e), qe[e] || (Ze++, (qe[e] = {}));
                },
                Ye = function () {
                    for (var e in qe) qe.hasOwnProperty(e) && Ke(e);
                },
                Xe = function (e, t, n, i, o, a, s) {
                    var r,
                        l = ke();
                    Ve(e);
                    var c = function () {
                        if (qe[e]) {
                            if ((r = ke() - l) >= i) return Ke(e), a(n), void (s && s());
                            a((n - t) * o(r / i) + t), (qe[e].raf = M(c));
                        }
                    };
                    c();
                },
                Je = {
                    shout: Pe,
                    listen: _e,
                    viewportSize: me,
                    options: s,
                    isMainScrollAnimating: function () {
                        return ie;
                    },
                    getZoomLevel: function () {
                        return g;
                    },
                    getCurrentIndex: function () {
                        return d;
                    },
                    isDragging: function () {
                        return G;
                    },
                    isZooming: function () {
                        return J;
                    },
                    setScrollOffset: function (e, t) {
                        (he.x = e), ($ = he.y = t), Pe("updateScrollOffset", he);
                    },
                    applyZoomPan: function (e, t, n, i) {
                        (pe.x = t), (pe.y = n), (g = e), Ae(i);
                    },
                    init: function () {
                        if (!r && !l) {
                            var n;
                            (a.framework = o),
                                (a.template = e),
                                (a.bg = o.getChildByClass(e, "pswp__bg")),
                                (R = e.className),
                                (r = !0),
                                (L = o.detectFeatures()),
                                (M = L.raf),
                                (E = L.caf),
                                (I = L.transform),
                                (N = L.oldIE),
                                (a.scrollWrap = o.getChildByClass(e, "pswp__scroll-wrap")),
                                (a.container = o.getChildByClass(a.scrollWrap, "pswp__container")),
                                (u = a.container.style),
                                (a.itemHolders = b = [
                                    { el: a.container.children[0], wrap: 0, index: -1 },
                                    { el: a.container.children[1], wrap: 0, index: -1 },
                                    { el: a.container.children[2], wrap: 0, index: -1 },
                                ]),
                                (b[0].el.style.display = b[2].el.style.display = "none"),
                                (function () {
                                    if (I) {
                                        var t = L.perspective && !A;
                                        return (T = "translate" + (t ? "3d(" : "(")), void (y = L.perspective ? ", 0px)" : ")");
                                    }
                                    (I = "left"),
                                        o.addClass(e, "pswp--ie"),
                                        (Ee = function (e, t) {
                                            t.left = e + "px";
                                        }),
                                        (Me = function (e) {
                                            var t = e.fitRatio > 1 ? 1 : e.fitRatio,
                                                n = e.container.style,
                                                i = t * e.w,
                                                o = t * e.h;
                                            (n.width = i + "px"), (n.height = o + "px"), (n.left = e.initialPosition.x + "px"), (n.top = e.initialPosition.y + "px");
                                        }),
                                        (Ae = function () {
                                            if (ne) {
                                                var e = ne,
                                                    t = a.currItem,
                                                    n = t.fitRatio > 1 ? 1 : t.fitRatio,
                                                    i = n * t.w,
                                                    o = n * t.h;
                                                (e.width = i + "px"), (e.height = o + "px"), (e.left = pe.x + "px"), (e.top = pe.y + "px");
                                            }
                                        });
                                })(),
                                (h = {
                                    resize: a.updateSize,
                                    orientationchange: function () {
                                        clearTimeout(F),
                                            (F = setTimeout(function () {
                                                me.x !== a.scrollWrap.clientWidth && a.updateSize();
                                            }, 500));
                                    },
                                    scroll: Ge,
                                    keydown: je,
                                    click: ze,
                                });
                            var i = L.isOldIOSPhone || L.isOldAndroid || L.isMobileOpera;
                            for ((L.animationName && L.transform && !i) || (s.showAnimationDuration = s.hideAnimationDuration = 0), n = 0; n < ye.length; n++) a["init" + ye[n]]();
                            t && (a.ui = new t(a, o)).init(),
                                Pe("firstUpdate"),
                                (d = d || s.index || 0),
                                (isNaN(d) || d < 0 || d >= Wt()) && (d = 0),
                                (a.currItem = Ht(d)),
                                (L.isOldIOSPhone || L.isOldAndroid) && (Te = !1),
                                e.setAttribute("aria-hidden", "false"),
                                s.modal && (Te ? (e.style.position = "fixed") : ((e.style.position = "absolute"), (e.style.top = o.getScrollY() + "px"))),
                                void 0 === $ && (Pe("initialLayout"), ($ = O = o.getScrollY()));
                            var c = "pswp--open ";
                            for (
                                s.mainClass && (c += s.mainClass + " "),
                                    s.showHideOpacity && (c += "pswp--animate_opacity "),
                                    c += A ? "pswp--touch" : "pswp--notouch",
                                    c += L.animationName ? " pswp--css_animation" : "",
                                    c += L.svg ? " pswp--svg" : "",
                                    o.addClass(e, c),
                                    a.updateSize(),
                                    p = -1,
                                    ve = null,
                                    n = 0;
                                n < 3;
                                n++
                            )
                                Ee((n + p) * ge.x, b[n].el.style);
                            N || o.bind(a.scrollWrap, f, a),
                                _e("initialZoomInEnd", function () {
                                    a.setContent(b[0], d - 1),
                                        a.setContent(b[2], d + 1),
                                        (b[0].el.style.display = b[2].el.style.display = "block"),
                                        s.focus && e.focus(),
                                        o.bind(document, "keydown", a),
                                        L.transform && o.bind(a.scrollWrap, "click", a),
                                        s.mouseUsed || o.bind(document, "mousemove", Fe),
                                        o.bind(window, "resize scroll orientationchange", a),
                                        Pe("bindEvents");
                                }),
                                a.setContent(b[1], d),
                                a.updateCurrItem(),
                                Pe("afterInit"),
                                Te ||
                                    (S = setInterval(function () {
                                        Ze || G || J || g !== a.currItem.initialZoomLevel || a.updateSize();
                                    }, 1e3)),
                                o.addClass(e, "pswp--visible");
                        }
                    },
                    close: function () {
                        r &&
                            ((r = !1),
                            (l = !0),
                            Pe("close"),
                            o.unbind(window, "resize scroll orientationchange", a),
                            o.unbind(window, "scroll", h.scroll),
                            o.unbind(document, "keydown", a),
                            o.unbind(document, "mousemove", Fe),
                            L.transform && o.unbind(a.scrollWrap, "click", a),
                            G && o.unbind(window, m, a),
                            clearTimeout(F),
                            Pe("unbindEvents"),
                            zt(a.currItem, null, !0, a.destroy));
                    },
                    destroy: function () {
                        Pe("destroy"), Lt && clearTimeout(Lt), e.setAttribute("aria-hidden", "true"), (e.className = R), S && clearInterval(S), o.unbind(a.scrollWrap, f, a), o.unbind(window, "scroll", a), ht(), Ye(), (Ce = null);
                    },
                    panTo: function (e, t, n) {
                        n || (e > te.min.x ? (e = te.min.x) : e < te.max.x && (e = te.max.x), t > te.min.y ? (t = te.min.y) : t < te.max.y && (t = te.max.y)), (pe.x = e), (pe.y = t), Ae();
                    },
                    handleEvent: function (e) {
                        (e = e || window.event), h[e.type] && h[e.type](e);
                    },
                    goTo: function (e) {
                        var t = (e = xe(e)) - d;
                        (ve = t), (d = e), (a.currItem = Ht(d)), (fe -= t), Re(ge.x * fe), Ye(), (ie = !1), a.updateCurrItem();
                    },
                    next: function () {
                        a.goTo(d + 1);
                    },
                    prev: function () {
                        a.goTo(d - 1);
                    },
                    updateCurrZoomItem: function (e) {
                        if ((e && Pe("beforeChange", 0), b[1].el.children.length)) {
                            var t = b[1].el.children[0];
                            ne = o.hasClass(t, "pswp__zoom-wrap") ? t.style : null;
                        } else ne = null;
                        (te = a.currItem.bounds), (v = g = a.currItem.initialZoomLevel), (pe.x = te.center.x), (pe.y = te.center.y), e && Pe("afterChange");
                    },
                    invalidateCurrItems: function () {
                        w = !0;
                        for (var e = 0; e < 3; e++) b[e].item && (b[e].item.needsUpdate = !0);
                    },
                    updateCurrItem: function (e) {
                        if (0 !== ve) {
                            var t,
                                n = Math.abs(ve);
                            if (!(e && n < 2)) {
                                (a.currItem = Ht(d)), (we = !1), Pe("beforeChange", ve), n >= 3 && ((p += ve + (ve > 0 ? -3 : 3)), (n = 3));
                                for (var i = 0; i < n; i++)
                                    ve > 0
                                        ? ((t = b.shift()), (b[2] = t), p++, Ee((p + 2) * ge.x, t.el.style), a.setContent(t, d - n + i + 1 + 1))
                                        : ((t = b.pop()), b.unshift(t), p--, Ee(p * ge.x, t.el.style), a.setContent(t, d + n - i - 1 - 1));
                                if (ne && 1 === Math.abs(ve)) {
                                    var o = Ht(x);
                                    o.initialZoomLevel !== g && (Kt(o, me), Jt(o), Me(o));
                                }
                                (ve = 0), a.updateCurrZoomItem(), (x = d), Pe("afterChange");
                            }
                        }
                    },
                    updateSize: function (t) {
                        if (!Te && s.modal) {
                            var n = o.getScrollY();
                            if (($ !== n && ((e.style.top = n + "px"), ($ = n)), !t && Se.x === window.innerWidth && Se.y === window.innerHeight)) return;
                            (Se.x = window.innerWidth), (Se.y = window.innerHeight), (e.style.height = Se.y + "px");
                        }
                        if (((me.x = a.scrollWrap.clientWidth), (me.y = a.scrollWrap.clientHeight), Ge(), (ge.x = me.x + Math.round(me.x * s.spacing)), (ge.y = me.y), Re(ge.x * fe), Pe("beforeResize"), void 0 !== p)) {
                            for (var i, r, l, c = 0; c < 3; c++)
                                (i = b[c]),
                                    Ee((c + p) * ge.x, i.el.style),
                                    (l = d + c - 1),
                                    s.loop && Wt() > 2 && (l = xe(l)),
                                    (r = Ht(l)) && (w || r.needsUpdate || !r.bounds)
                                        ? (a.cleanSlide(r), a.setContent(i, l), 1 === c && ((a.currItem = r), a.updateCurrZoomItem(!0)), (r.needsUpdate = !1))
                                        : -1 === i.index && l >= 0 && a.setContent(i, l),
                                    r && r.container && (Kt(r, me), Jt(r), Me(r));
                            w = !1;
                        }
                        (v = g = a.currItem.initialZoomLevel), (te = a.currItem.bounds) && ((pe.x = te.center.x), (pe.y = te.center.y), Ae(!0)), Pe("resize");
                    },
                    zoomTo: function (e, t, n, i, a) {
                        t && ((v = g), (pt.x = Math.abs(t.x) - pe.x), (pt.y = Math.abs(t.y) - pe.y), Ne(ue, pe));
                        var s = Ue(e, !1),
                            r = {};
                        We("x", s, r, e), We("y", s, r, e);
                        var l = g,
                            c = { x: pe.x, y: pe.y };
                        $e(r);
                        var d = function (t) {
                            1 === t ? ((g = e), (pe.x = r.x), (pe.y = r.y)) : ((g = (e - l) * t + l), (pe.x = (r.x - c.x) * t + c.x), (pe.y = (r.y - c.y) * t + c.y)), a && a(t), Ae(1 === t);
                        };
                        n ? Xe("customZoomTo", 0, 1, n, i || o.easing.sine.inOut, d) : d(1);
                    },
                },
                Qe = {},
                et = {},
                tt = {},
                nt = {},
                it = {},
                ot = [],
                at = {},
                st = [],
                rt = {},
                lt = 0,
                ct = { x: 0, y: 0 },
                dt = 0,
                ut = { x: 0, y: 0 },
                pt = { x: 0, y: 0 },
                mt = { x: 0, y: 0 },
                ft = function (e, t) {
                    return (rt.x = Math.abs(e.x - t.x)), (rt.y = Math.abs(e.y - t.y)), Math.sqrt(rt.x * rt.x + rt.y * rt.y);
                },
                ht = function () {
                    V && (E(V), (V = null));
                },
                gt = function () {
                    G && ((V = M(gt)), At());
                },
                vt = function (e, t) {
                    return !(!e || e === document) && !(e.getAttribute("class") && e.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (t(e) ? e : vt(e.parentNode, t));
                },
                Tt = {},
                yt = function (e, t) {
                    return (Tt.prevent = !vt(e.target, s.isClickableElement)), Pe("preventDragEvent", e, t, Tt), Tt.prevent;
                },
                St = function (e, t) {
                    return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
                },
                wt = function (e, t, n) {
                    (n.x = 0.5 * (e.x + t.x)), (n.y = 0.5 * (e.y + t.y));
                },
                bt = function () {
                    var e = pe.y - a.currItem.initialPosition.y;
                    return 1 - Math.abs(e / (me.y / 2));
                },
                xt = {},
                Ct = {},
                _t = [],
                Pt = function (e) {
                    for (; _t.length > 0; ) _t.pop();
                    return (
                        D
                            ? ((ce = 0),
                              ot.forEach(function (e) {
                                  0 === ce ? (_t[0] = e) : 1 === ce && (_t[1] = e), ce++;
                              }))
                            : e.type.indexOf("touch") > -1
                            ? e.touches && e.touches.length > 0 && ((_t[0] = St(e.touches[0], xt)), e.touches.length > 1 && (_t[1] = St(e.touches[1], Ct)))
                            : ((xt.x = e.pageX), (xt.y = e.pageY), (xt.id = ""), (_t[0] = xt)),
                        _t
                    );
                },
                kt = function (e, t) {
                    var n,
                        i,
                        o,
                        r,
                        l = pe[e] + t[e],
                        c = t[e] > 0,
                        d = ut.x + t.x,
                        u = ut.x - at.x;
                    return (
                        (n = l > te.min[e] || l < te.max[e] ? s.panEndFriction : 1),
                        (l = pe[e] + t[e] * n),
                        (!s.allowPanToNext && g !== a.currItem.initialZoomLevel) ||
                        (ne
                            ? "h" !== oe ||
                              "x" !== e ||
                              Z ||
                              (c
                                  ? (l > te.min[e] && ((n = s.panEndFriction), te.min[e], (i = te.min[e] - ue[e])), (i <= 0 || u < 0) && Wt() > 1 ? ((r = d), u < 0 && d > at.x && (r = at.x)) : te.min.x !== te.max.x && (o = l))
                                  : (l < te.max[e] && ((n = s.panEndFriction), te.max[e], (i = ue[e] - te.max[e])), (i <= 0 || u > 0) && Wt() > 1 ? ((r = d), u > 0 && d < at.x && (r = at.x)) : te.min.x !== te.max.x && (o = l)))
                            : (r = d),
                        "x" !== e)
                            ? void (ie || Y || (g > a.currItem.fitRatio && (pe[e] += t[e] * n)))
                            : (void 0 !== r && (Re(r, !0), (Y = r !== at.x)), te.min.x !== te.max.x && (void 0 !== o ? (pe.x = o) : Y || (pe.x += t.x * n)), void 0 !== r)
                    );
                },
                It = function (e) {
                    if (!("mousedown" === e.type && e.button > 0)) {
                        if (Bt) return void e.preventDefault();
                        if (!z || "mousedown" !== e.type) {
                            if ((yt(e, !0) && e.preventDefault(), Pe("pointerDown"), D)) {
                                var t = o.arraySearch(ot, e.pointerId, "id");
                                t < 0 && (t = ot.length), (ot[t] = { x: e.pageX, y: e.pageY, id: e.pointerId });
                            }
                            var n = Pt(e),
                                i = n.length;
                            (X = null),
                                Ye(),
                                (G && 1 !== i) ||
                                    ((G = ae = !0),
                                    o.bind(window, m, a),
                                    (W = le = se = j = Y = K = q = Z = !1),
                                    (oe = null),
                                    Pe("firstTouchStart", n),
                                    Ne(ue, pe),
                                    (de.x = de.y = 0),
                                    Ne(nt, n[0]),
                                    Ne(it, nt),
                                    (at.x = ge.x * fe),
                                    (st = [{ x: nt.x, y: nt.y }]),
                                    (B = U = ke()),
                                    Ue(g, !0),
                                    ht(),
                                    gt()),
                                !J &&
                                    i > 1 &&
                                    !ie &&
                                    !Y &&
                                    ((v = g), (Z = !1), (J = q = !0), (de.y = de.x = 0), Ne(ue, pe), Ne(Qe, n[0]), Ne(et, n[1]), wt(Qe, et, mt), (pt.x = Math.abs(mt.x) - pe.x), (pt.y = Math.abs(mt.y) - pe.y), (Q = ee = ft(Qe, et)));
                        }
                    }
                },
                Dt = function (e) {
                    if ((e.preventDefault(), D)) {
                        var t = o.arraySearch(ot, e.pointerId, "id");
                        if (t > -1) {
                            var n = ot[t];
                            (n.x = e.pageX), (n.y = e.pageY);
                        }
                    }
                    if (G) {
                        var i = Pt(e);
                        if (oe || K || J) X = i;
                        else if (ut.x !== ge.x * fe) oe = "h";
                        else {
                            var a = Math.abs(i[0].x - nt.x) - Math.abs(i[0].y - nt.y);
                            Math.abs(a) >= 10 && ((oe = a > 0 ? "h" : "v"), (X = i));
                        }
                    }
                },
                At = function () {
                    if (X) {
                        var e = X.length;
                        if (0 !== e)
                            if ((Ne(Qe, X[0]), (tt.x = Qe.x - nt.x), (tt.y = Qe.y - nt.y), J && e > 1)) {
                                if (
                                    ((nt.x = Qe.x),
                                    (nt.y = Qe.y),
                                    !tt.x &&
                                        !tt.y &&
                                        (function (e, t) {
                                            return e.x === t.x && e.y === t.y;
                                        })(X[1], et))
                                )
                                    return;
                                Ne(et, X[1]), Z || ((Z = !0), Pe("zoomGestureStarted"));
                                var t = ft(Qe, et),
                                    n = Nt(t);
                                n > a.currItem.initialZoomLevel + a.currItem.initialZoomLevel / 15 && (le = !0);
                                var i = 1,
                                    o = Be(),
                                    r = He();
                                if (n < o)
                                    if (s.pinchToClose && !le && v <= a.currItem.initialZoomLevel) {
                                        var l = 1 - (o - n) / (o / 1.2);
                                        Ie(l), Pe("onPinchClose", l), (se = !0);
                                    } else (i = (o - n) / o) > 1 && (i = 1), (n = o - i * (o / 3));
                                else n > r && ((i = (n - r) / (6 * o)) > 1 && (i = 1), (n = r + i * o));
                                i < 0 && (i = 0), (Q = t), wt(Qe, et, ct), (de.x += ct.x - mt.x), (de.y += ct.y - mt.y), Ne(mt, ct), (pe.x = Oe("x", n)), (pe.y = Oe("y", n)), (W = n > g), (g = n), Ae();
                            } else {
                                if (!oe) return;
                                if ((ae && ((ae = !1), Math.abs(tt.x) >= 10 && (tt.x -= X[0].x - it.x), Math.abs(tt.y) >= 10 && (tt.y -= X[0].y - it.y)), (nt.x = Qe.x), (nt.y = Qe.y), 0 === tt.x && 0 === tt.y)) return;
                                if ("v" === oe && s.closeOnVerticalDrag && "fit" === s.scaleMode && g === a.currItem.initialZoomLevel) {
                                    (de.y += tt.y), (pe.y += tt.y);
                                    var c = bt();
                                    return (j = !0), Pe("onVerticalDrag", c), Ie(c), void Ae();
                                }
                                (function (e, t, n) {
                                    if (e - B > 50) {
                                        var i = st.length > 2 ? st.shift() : {};
                                        (i.x = t), (i.y = n), st.push(i), (B = e);
                                    }
                                })(ke(), Qe.x, Qe.y),
                                    (K = !0),
                                    (te = a.currItem.bounds),
                                    kt("x", tt) || (kt("y", tt), $e(pe), Ae());
                            }
                    }
                },
                Mt = function (e) {
                    if (L.isOldAndroid) {
                        if (z && "mouseup" === e.type) return;
                        e.type.indexOf("touch") > -1 &&
                            (clearTimeout(z),
                            (z = setTimeout(function () {
                                z = 0;
                            }, 600)));
                    }
                    Pe("pointerUp"), yt(e, !1) && e.preventDefault();
                    var t;
                    if (D) {
                        var n = o.arraySearch(ot, e.pointerId, "id");
                        if (n > -1)
                            if (((t = ot.splice(n, 1)[0]), navigator.msPointerEnabled)) {
                                var i = { 4: "mouse", 2: "touch", 3: "pen" };
                                (t.type = i[e.pointerType]), t.type || (t.type = e.pointerType || "mouse");
                            } else t.type = e.pointerType || "mouse";
                    }
                    var r,
                        l = Pt(e),
                        c = l.length;
                    if (("mouseup" === e.type && (c = 0), 2 === c)) return (X = null), !0;
                    1 === c && Ne(it, l[0]),
                        0 !== c ||
                            oe ||
                            ie ||
                            (t || ("mouseup" === e.type ? (t = { x: e.pageX, y: e.pageY, type: "mouse" }) : e.changedTouches && e.changedTouches[0] && (t = { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type: "touch" })),
                            Pe("touchRelease", e, t));
                    var d = -1;
                    if (
                        (0 === c && ((G = !1), o.unbind(window, m, a), ht(), J ? (d = 0) : -1 !== dt && (d = ke() - dt)),
                        (dt = 1 === c ? ke() : -1),
                        (r = -1 !== d && d < 150 ? "zoom" : "swipe"),
                        J && c < 2 && ((J = !1), 1 === c && (r = "zoomPointerUp"), Pe("zoomGestureEnded")),
                        (X = null),
                        K || Z || ie || j)
                    )
                        if ((Ye(), H || (H = Et()), H.calculateSwipeSpeed("x"), j))
                            if (bt() < s.verticalDragRange) a.close();
                            else {
                                var u = pe.y,
                                    p = re;
                                Xe("verticalDrag", 0, 1, 300, o.easing.cubic.out, function (e) {
                                    (pe.y = (a.currItem.initialPosition.y - u) * e + u), Ie((1 - p) * e + p), Ae();
                                }),
                                    Pe("onVerticalDrag", 1);
                            }
                        else {
                            if ((Y || ie) && 0 === c) {
                                if (Ot(r, H)) return;
                                r = "zoomPointerUp";
                            }
                            if (!ie) return "swipe" !== r ? void $t() : void (!Y && g > a.currItem.fitRatio && Rt(H));
                        }
                },
                Et = function () {
                    var e,
                        t,
                        n = {
                            lastFlickOffset: {},
                            lastFlickDist: {},
                            lastFlickSpeed: {},
                            slowDownRatio: {},
                            slowDownRatioReverse: {},
                            speedDecelerationRatio: {},
                            speedDecelerationRatioAbs: {},
                            distanceOffset: {},
                            backAnimDestination: {},
                            backAnimStarted: {},
                            calculateSwipeSpeed: function (i) {
                                st.length > 1 ? ((e = ke() - B + 50), (t = st[st.length - 2][i])) : ((e = ke() - U), (t = it[i])),
                                    (n.lastFlickOffset[i] = nt[i] - t),
                                    (n.lastFlickDist[i] = Math.abs(n.lastFlickOffset[i])),
                                    n.lastFlickDist[i] > 20 ? (n.lastFlickSpeed[i] = n.lastFlickOffset[i] / e) : (n.lastFlickSpeed[i] = 0),
                                    Math.abs(n.lastFlickSpeed[i]) < 0.1 && (n.lastFlickSpeed[i] = 0),
                                    (n.slowDownRatio[i] = 0.95),
                                    (n.slowDownRatioReverse[i] = 1 - n.slowDownRatio[i]),
                                    (n.speedDecelerationRatio[i] = 1);
                            },
                            calculateOverBoundsAnimOffset: function (e, t) {
                                n.backAnimStarted[e] ||
                                    (pe[e] > te.min[e] ? (n.backAnimDestination[e] = te.min[e]) : pe[e] < te.max[e] && (n.backAnimDestination[e] = te.max[e]),
                                    void 0 !== n.backAnimDestination[e] &&
                                        ((n.slowDownRatio[e] = 0.7),
                                        (n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e]),
                                        n.speedDecelerationRatioAbs[e] < 0.05 &&
                                            ((n.lastFlickSpeed[e] = 0),
                                            (n.backAnimStarted[e] = !0),
                                            Xe("bounceZoomPan" + e, pe[e], n.backAnimDestination[e], t || 300, o.easing.sine.out, function (t) {
                                                (pe[e] = t), Ae();
                                            }))));
                            },
                            calculateAnimOffset: function (e) {
                                n.backAnimStarted[e] ||
                                    ((n.speedDecelerationRatio[e] = n.speedDecelerationRatio[e] * (n.slowDownRatio[e] + n.slowDownRatioReverse[e] - (n.slowDownRatioReverse[e] * n.timeDiff) / 10)),
                                    (n.speedDecelerationRatioAbs[e] = Math.abs(n.lastFlickSpeed[e] * n.speedDecelerationRatio[e])),
                                    (n.distanceOffset[e] = n.lastFlickSpeed[e] * n.speedDecelerationRatio[e] * n.timeDiff),
                                    (pe[e] += n.distanceOffset[e]));
                            },
                            panAnimLoop: function () {
                                if (
                                    qe.zoomPan &&
                                    ((qe.zoomPan.raf = M(n.panAnimLoop)),
                                    (n.now = ke()),
                                    (n.timeDiff = n.now - n.lastNow),
                                    (n.lastNow = n.now),
                                    n.calculateAnimOffset("x"),
                                    n.calculateAnimOffset("y"),
                                    Ae(),
                                    n.calculateOverBoundsAnimOffset("x"),
                                    n.calculateOverBoundsAnimOffset("y"),
                                    n.speedDecelerationRatioAbs.x < 0.05 && n.speedDecelerationRatioAbs.y < 0.05)
                                )
                                    return (pe.x = Math.round(pe.x)), (pe.y = Math.round(pe.y)), Ae(), void Ke("zoomPan");
                            },
                        };
                    return n;
                },
                Rt = function (e) {
                    return (
                        e.calculateSwipeSpeed("y"),
                        (te = a.currItem.bounds),
                        (e.backAnimDestination = {}),
                        (e.backAnimStarted = {}),
                        Math.abs(e.lastFlickSpeed.x) <= 0.05 && Math.abs(e.lastFlickSpeed.y) <= 0.05
                            ? ((e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0), e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0)
                            : (Ve("zoomPan"), (e.lastNow = ke()), void e.panAnimLoop())
                    );
                },
                Ot = function (e, t) {
                    var n;
                    ie || (lt = d);
                    var i;
                    if ("swipe" === e) {
                        var r = nt.x - it.x,
                            l = t.lastFlickDist.x < 10;
                        r > 30 && (l || t.lastFlickOffset.x > 20) ? (i = -1) : r < -30 && (l || t.lastFlickOffset.x < -20) && (i = 1);
                    }
                    var c;
                    i && ((d += i) < 0 ? ((d = s.loop ? Wt() - 1 : 0), (c = !0)) : d >= Wt() && ((d = s.loop ? 0 : Wt() - 1), (c = !0)), (c && !s.loop) || ((ve += i), (fe -= i), (n = !0)));
                    var u,
                        p = ge.x * fe,
                        m = Math.abs(p - ut.x);
                    return (
                        n || p > ut.x == t.lastFlickSpeed.x > 0 ? ((u = Math.abs(t.lastFlickSpeed.x) > 0 ? m / Math.abs(t.lastFlickSpeed.x) : 333), (u = Math.min(u, 400)), (u = Math.max(u, 250))) : (u = 333),
                        lt === d && (n = !1),
                        (ie = !0),
                        Pe("mainScrollAnimStart"),
                        Xe("mainScroll", ut.x, p, u, o.easing.cubic.out, Re, function () {
                            Ye(), (ie = !1), (lt = -1), (n || lt !== d) && a.updateCurrItem(), Pe("mainScrollAnimComplete");
                        }),
                        n && a.updateCurrItem(!0),
                        n
                    );
                },
                Nt = function (e) {
                    return (1 / ee) * e * v;
                },
                $t = function () {
                    var e = g,
                        t = Be(),
                        n = He();
                    g < t ? (e = t) : g > n && (e = n);
                    var i,
                        s = re;
                    return se && !W && !le && g < t
                        ? (a.close(), !0)
                        : (se &&
                              (i = function (e) {
                                  Ie((1 - s) * e + s);
                              }),
                          a.zoomTo(e, 0, 200, o.easing.cubic.out, i),
                          !0);
                };
            be("Gestures", {
                publicMethods: {
                    initGestures: function () {
                        var e = function (e, t, n, i, o) {
                            (C = e + t), (_ = e + n), (P = e + i), (k = o ? e + o : "");
                        };
                        (D = L.pointerEvent) && L.touch && (L.touch = !1),
                            D
                                ? navigator.msPointerEnabled
                                    ? e("MSPointer", "Down", "Move", "Up", "Cancel")
                                    : e("pointer", "down", "move", "up", "cancel")
                                : L.touch
                                ? (e("touch", "start", "move", "end", "cancel"), (A = !0))
                                : e("mouse", "down", "move", "up"),
                            (m = _ + " " + P + " " + k),
                            (f = C),
                            D && !A && (A = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
                            (a.likelyTouchDevice = A),
                            (h[C] = It),
                            (h[_] = Dt),
                            (h[P] = Mt),
                            k && (h[k] = h[P]),
                            L.touch && ((f += " mousedown"), (m += " mousemove mouseup"), (h.mousedown = h[C]), (h.mousemove = h[_]), (h.mouseup = h[P])),
                            A || (s.allowPanToNext = !1);
                    },
                },
            });
            var Lt,
                Ft,
                Ut,
                Bt,
                Ht,
                Wt,
                jt,
                zt = function (t, n, i, r) {
                    Lt && clearTimeout(Lt), (Bt = !0), (Ut = !0);
                    var l;
                    t.initialLayout ? ((l = t.initialLayout), (t.initialLayout = null)) : (l = s.getThumbBoundsFn && s.getThumbBoundsFn(d));
                    var u = i ? s.hideAnimationDuration : s.showAnimationDuration,
                        p = function () {
                            Ke("initialZoom"),
                                i ? (a.template.removeAttribute("style"), a.bg.removeAttribute("style")) : (Ie(1), n && (n.style.display = "block"), o.addClass(e, "pswp--animated-in"), Pe("initialZoom" + (i ? "OutEnd" : "InEnd"))),
                                r && r(),
                                (Bt = !1);
                        };
                    if (!u || !l || void 0 === l.x)
                        return (
                            Pe("initialZoom" + (i ? "Out" : "In")),
                            (g = t.initialZoomLevel),
                            Ne(pe, t.initialPosition),
                            Ae(),
                            (e.style.opacity = i ? 0 : 1),
                            Ie(1),
                            void (u
                                ? setTimeout(function () {
                                      p();
                                  }, u)
                                : p())
                        );
                    !(function () {
                        var n = c,
                            r = !a.currItem.src || a.currItem.loadError || s.showHideOpacity;
                        t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"),
                            i || ((g = l.w / t.w), (pe.x = l.x), (pe.y = l.y - O), (a[r ? "template" : "bg"].style.opacity = 0.001), Ae()),
                            Ve("initialZoom"),
                            i && !n && o.removeClass(e, "pswp--animated-in"),
                            r &&
                                (i
                                    ? o[(n ? "remove" : "add") + "Class"](e, "pswp--animate_opacity")
                                    : setTimeout(function () {
                                          o.addClass(e, "pswp--animate_opacity");
                                      }, 30)),
                            (Lt = setTimeout(
                                function () {
                                    if ((Pe("initialZoom" + (i ? "Out" : "In")), i)) {
                                        var a = l.w / t.w,
                                            s = { x: pe.x, y: pe.y },
                                            c = g,
                                            d = re,
                                            m = function (t) {
                                                1 === t ? ((g = a), (pe.x = l.x), (pe.y = l.y - $)) : ((g = (a - c) * t + c), (pe.x = (l.x - s.x) * t + s.x), (pe.y = (l.y - $ - s.y) * t + s.y)),
                                                    Ae(),
                                                    r ? (e.style.opacity = 1 - t) : Ie(d - t * d);
                                            };
                                        n ? Xe("initialZoom", 0, 1, u, o.easing.cubic.out, m, p) : (m(1), (Lt = setTimeout(p, u + 20)));
                                    } else (g = t.initialZoomLevel), Ne(pe, t.initialPosition), Ae(), Ie(1), r ? (e.style.opacity = 1) : Ie(1), (Lt = setTimeout(p, u + 20));
                                },
                                i ? 25 : 90
                            ));
                    })();
                },
                Gt = {},
                qt = [],
                Zt = {
                    index: 0,
                    errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                    forceProgressiveLoading: !1,
                    preload: [1, 1],
                    getNumItemsFn: function () {
                        return Ft.length;
                    },
                },
                Kt = function (e, t, n) {
                    if (e.src && !e.loadError) {
                        var i = !n;
                        if ((i && (e.vGap || (e.vGap = { top: 0, bottom: 0 }), Pe("parseVerticalMargin", e)), (Gt.x = t.x), (Gt.y = t.y - e.vGap.top - e.vGap.bottom), i)) {
                            var o = Gt.x / e.w,
                                a = Gt.y / e.h;
                            e.fitRatio = o < a ? o : a;
                            var r = s.scaleMode;
                            "orig" === r ? (n = 1) : "fit" === r && (n = e.fitRatio), n > 1 && (n = 1), (e.initialZoomLevel = n), e.bounds || (e.bounds = { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } });
                        }
                        if (!n) return;
                        return (
                            (function (e, t, n) {
                                var i = e.bounds;
                                (i.center.x = Math.round((Gt.x - t) / 2)),
                                    (i.center.y = Math.round((Gt.y - n) / 2) + e.vGap.top),
                                    (i.max.x = t > Gt.x ? Math.round(Gt.x - t) : i.center.x),
                                    (i.max.y = n > Gt.y ? Math.round(Gt.y - n) + e.vGap.top : i.center.y),
                                    (i.min.x = t > Gt.x ? 0 : i.center.x),
                                    (i.min.y = n > Gt.y ? e.vGap.top : i.center.y);
                            })(e, e.w * n, e.h * n),
                            i && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center),
                            e.bounds
                        );
                    }
                    return (e.w = e.h = 0), (e.initialZoomLevel = e.fitRatio = 1), (e.bounds = { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } }), (e.initialPosition = e.bounds.center), e.bounds;
                },
                Vt = function (e, t, n, i, o, s) {
                    t.loadError ||
                        (i &&
                            ((t.imageAppended = !0),
                            Jt(t, i, t === a.currItem && we),
                            n.appendChild(i),
                            s &&
                                setTimeout(function () {
                                    t && t.loaded && t.placeholder && ((t.placeholder.style.display = "none"), (t.placeholder = null));
                                }, 500)));
                },
                Yt = function (e) {
                    (e.loading = !0), (e.loaded = !1);
                    var t = (e.img = o.createEl("pswp__img", "img")),
                        n = function () {
                            (e.loading = !1), (e.loaded = !0), e.loadComplete ? e.loadComplete(e) : (e.img = null), (t.onload = t.onerror = null), (t = null);
                        };
                    return (
                        (t.onload = n),
                        (t.onerror = function () {
                            (e.loadError = !0), n();
                        }),
                        (t.src = e.src),
                        t
                    );
                },
                Xt = function (e, t) {
                    if (e.src && e.loadError && e.container) return t && (e.container.innerHTML = ""), (e.container.innerHTML = s.errorMsg.replace("%url%", e.src)), !0;
                },
                Jt = function (e, t, n) {
                    if (e.src) {
                        t || (t = e.container.lastChild);
                        var i = n ? e.w : Math.round(e.w * e.fitRatio),
                            o = n ? e.h : Math.round(e.h * e.fitRatio);
                        e.placeholder && !e.loaded && ((e.placeholder.style.width = i + "px"), (e.placeholder.style.height = o + "px")), (t.style.width = i + "px"), (t.style.height = o + "px");
                    }
                },
                Qt = function () {
                    if (qt.length) {
                        for (var e, t = 0; t < qt.length; t++) (e = qt[t]).holder.index === e.index && Vt(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
                        qt = [];
                    }
                };
            be("Controller", {
                publicMethods: {
                    lazyLoadItem: function (e) {
                        e = xe(e);
                        var t = Ht(e);
                        t && ((!t.loaded && !t.loading) || w) && (Pe("gettingData", e, t), t.src && Yt(t));
                    },
                    initController: function () {
                        o.extend(s, Zt, !0),
                            (a.items = Ft = n),
                            (Ht = a.getItemAt),
                            (Wt = s.getNumItemsFn),
                            (jt = s.loop),
                            Wt() < 3 && (s.loop = !1),
                            _e("beforeChange", function (e) {
                                var t,
                                    n = s.preload,
                                    i = null === e || e >= 0,
                                    o = Math.min(n[0], Wt()),
                                    r = Math.min(n[1], Wt());
                                for (t = 1; t <= (i ? r : o); t++) a.lazyLoadItem(d + t);
                                for (t = 1; t <= (i ? o : r); t++) a.lazyLoadItem(d - t);
                            }),
                            _e("initialLayout", function () {
                                a.currItem.initialLayout = s.getThumbBoundsFn && s.getThumbBoundsFn(d);
                            }),
                            _e("mainScrollAnimComplete", Qt),
                            _e("initialZoomInEnd", Qt),
                            _e("destroy", function () {
                                for (var e, t = 0; t < Ft.length; t++)
                                    (e = Ft[t]).container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                                qt = null;
                            });
                    },
                    getItemAt: function (e) {
                        return e >= 0 && void 0 !== Ft[e] && Ft[e];
                    },
                    allowProgressiveImg: function () {
                        return s.forceProgressiveLoading || !A || s.mouseUsed || screen.width > 1200;
                    },
                    setContent: function (e, t) {
                        s.loop && (t = xe(t));
                        var n = a.getItemAt(e.index);
                        n && (n.container = null);
                        var i,
                            l = a.getItemAt(t);
                        if (l) {
                            Pe("gettingData", t, l), (e.index = t), (e.item = l);
                            var c = (l.container = o.createEl("pswp__zoom-wrap"));
                            if ((!l.src && l.html && (l.html.tagName ? c.appendChild(l.html) : (c.innerHTML = l.html)), Xt(l), Kt(l, me), !l.src || l.loadError || l.loaded))
                                l.src && !l.loadError && ((i = o.createEl("pswp__img", "img")), (i.style.opacity = 1), (i.src = l.src), Jt(l, i), Vt(0, l, c, i));
                            else {
                                if (
                                    ((l.loadComplete = function (n) {
                                        if (r) {
                                            if (e && e.index === t) {
                                                if (Xt(n, !0)) return (n.loadComplete = n.img = null), Kt(n, me), Me(n), void (e.index === d && a.updateCurrZoomItem());
                                                n.imageAppended
                                                    ? !Bt && n.placeholder && ((n.placeholder.style.display = "none"), (n.placeholder = null))
                                                    : L.transform && (ie || Bt)
                                                    ? qt.push({ item: n, baseDiv: c, img: n.img, index: t, holder: e, clearPlaceholder: !0 })
                                                    : Vt(0, n, c, n.img, 0, !0);
                                            }
                                            (n.loadComplete = null), (n.img = null), Pe("imageLoadComplete", t, n);
                                        }
                                    }),
                                    o.features.transform)
                                ) {
                                    var u = "pswp__img pswp__img--placeholder";
                                    u += l.msrc ? "" : " pswp__img--placeholder--blank";
                                    var p = o.createEl(u, l.msrc ? "img" : "");
                                    l.msrc && (p.src = l.msrc), Jt(l, p), c.appendChild(p), (l.placeholder = p);
                                }
                                l.loading || Yt(l), a.allowProgressiveImg() && (!Ut && L.transform ? qt.push({ item: l, baseDiv: c, img: l.img, index: t, holder: e }) : Vt(0, l, c, l.img, 0, !0));
                            }
                            Ut || t !== d ? Me(l) : ((ne = c.style), zt(l, i || l.img)), (e.el.innerHTML = ""), e.el.appendChild(c);
                        } else e.el.innerHTML = "";
                    },
                    cleanSlide: function (e) {
                        e.img && (e.img.onload = e.img.onerror = null), (e.loaded = e.loading = e.img = e.imageAppended = !1);
                    },
                },
            });
            var en,
                tn = {},
                nn = function (e, t, n) {
                    var i = document.createEvent("CustomEvent"),
                        o = { origEvent: e, target: e.target, releasePoint: t, pointerType: n || "touch" };
                    i.initCustomEvent("pswpTap", !0, !0, o), e.target.dispatchEvent(i);
                };
            be("Tap", {
                publicMethods: {
                    initTap: function () {
                        _e("firstTouchStart", a.onTapStart),
                            _e("touchRelease", a.onTapRelease),
                            _e("destroy", function () {
                                (tn = {}), (en = null);
                            });
                    },
                    onTapStart: function (e) {
                        e.length > 1 && (clearTimeout(en), (en = null));
                    },
                    onTapRelease: function (e, t) {
                        if (t && !K && !q && !Ze) {
                            var n = t;
                            if (
                                en &&
                                (clearTimeout(en),
                                (en = null),
                                (function (e, t) {
                                    return Math.abs(e.x - t.x) < 25 && Math.abs(e.y - t.y) < 25;
                                })(n, tn))
                            )
                                return void Pe("doubleTap", n);
                            if ("mouse" === t.type) return void nn(e, t, "mouse");
                            if ("BUTTON" === e.target.tagName.toUpperCase() || o.hasClass(e.target, "pswp__single-tap")) return void nn(e, t);
                            Ne(tn, n),
                                (en = setTimeout(function () {
                                    nn(e, t), (en = null);
                                }, 300));
                        }
                    },
                },
            });
            var on;
            be("DesktopZoom", {
                publicMethods: {
                    initDesktopZoom: function () {
                        N ||
                            (A
                                ? _e("mouseUsed", function () {
                                      a.setupDesktopZoom();
                                  })
                                : a.setupDesktopZoom(!0));
                    },
                    setupDesktopZoom: function (t) {
                        on = {};
                        var n = "wheel mousewheel DOMMouseScroll";
                        _e("bindEvents", function () {
                            o.bind(e, n, a.handleMouseWheel);
                        }),
                            _e("unbindEvents", function () {
                                on && o.unbind(e, n, a.handleMouseWheel);
                            }),
                            (a.mouseZoomedIn = !1);
                        var i,
                            s = function () {
                                a.mouseZoomedIn && (o.removeClass(e, "pswp--zoomed-in"), (a.mouseZoomedIn = !1)), g < 1 ? o.addClass(e, "pswp--zoom-allowed") : o.removeClass(e, "pswp--zoom-allowed"), r();
                            },
                            r = function () {
                                i && (o.removeClass(e, "pswp--dragging"), (i = !1));
                            };
                        _e("resize", s),
                            _e("afterChange", s),
                            _e("pointerDown", function () {
                                a.mouseZoomedIn && ((i = !0), o.addClass(e, "pswp--dragging"));
                            }),
                            _e("pointerUp", r),
                            t || s();
                    },
                    handleMouseWheel: function (e) {
                        if (g <= a.currItem.fitRatio) return s.modal && (!s.closeOnScroll || Ze || G ? e.preventDefault() : I && Math.abs(e.deltaY) > 2 && ((c = !0), a.close())), !0;
                        if ((e.stopPropagation(), (on.x = 0), "deltaX" in e)) 1 === e.deltaMode ? ((on.x = 18 * e.deltaX), (on.y = 18 * e.deltaY)) : ((on.x = e.deltaX), (on.y = e.deltaY));
                        else if ("wheelDelta" in e) e.wheelDeltaX && (on.x = -0.16 * e.wheelDeltaX), e.wheelDeltaY ? (on.y = -0.16 * e.wheelDeltaY) : (on.y = -0.16 * e.wheelDelta);
                        else {
                            if (!("detail" in e)) return;
                            on.y = e.detail;
                        }
                        Ue(g, !0);
                        var t = pe.x - on.x,
                            n = pe.y - on.y;
                        (s.modal || (t <= te.min.x && t >= te.max.x && n <= te.min.y && n >= te.max.y)) && e.preventDefault(), a.panTo(t, n);
                    },
                    toggleDesktopZoom: function (t) {
                        t = t || { x: me.x / 2 + he.x, y: me.y / 2 + he.y };
                        var n = s.getDoubleTapZoom(!0, a.currItem),
                            i = g === n;
                        (a.mouseZoomedIn = !i), a.zoomTo(i ? a.currItem.initialZoomLevel : n, t, 333), o[(i ? "remove" : "add") + "Class"](e, "pswp--zoomed-in");
                    },
                },
            });
            var an,
                sn,
                rn,
                ln,
                cn,
                dn,
                un,
                pn,
                mn,
                fn,
                hn,
                gn,
                vn = { history: !0, galleryUID: 1 },
                Tn = function () {
                    return hn.hash.substring(1);
                },
                yn = function () {
                    an && clearTimeout(an), rn && clearTimeout(rn);
                },
                Sn = function () {
                    var e = Tn(),
                        t = {};
                    if (e.length < 5) return t;
                    var n,
                        i = e.split("&");
                    for (n = 0; n < i.length; n++)
                        if (i[n]) {
                            var o = i[n].split("=");
                            o.length < 2 || (t[o[0]] = o[1]);
                        }
                    if (s.galleryPIDs) {
                        var a = t.pid;
                        for (t.pid = 0, n = 0; n < Ft.length; n++)
                            if (Ft[n].pid === a) {
                                t.pid = n;
                                break;
                            }
                    } else t.pid = parseInt(t.pid, 10) - 1;
                    return t.pid < 0 && (t.pid = 0), t;
                },
                wn = function () {
                    if ((rn && clearTimeout(rn), Ze || G)) rn = setTimeout(wn, 500);
                    else {
                        ln ? clearTimeout(sn) : (ln = !0);
                        var e = d + 1,
                            t = Ht(d);
                        t.hasOwnProperty("pid") && (e = t.pid);
                        var n = un + "&gid=" + s.galleryUID + "&pid=" + e;
                        pn || (-1 === hn.hash.indexOf(n) && (fn = !0));
                        var i = hn.href.split("#")[0] + "#" + n;
                        gn ? "#" + n !== window.location.hash && history[pn ? "replaceState" : "pushState"]("", document.title, i) : pn ? hn.replace(i) : (hn.hash = n),
                            (pn = !0),
                            (sn = setTimeout(function () {
                                ln = !1;
                            }, 60));
                    }
                };
            be("History", {
                publicMethods: {
                    initHistory: function () {
                        if ((o.extend(s, vn, !0), s.history)) {
                            (hn = window.location),
                                (fn = !1),
                                (mn = !1),
                                (pn = !1),
                                (un = Tn()),
                                (gn = "pushState" in history),
                                un.indexOf("gid=") > -1 && ((un = un.split("&gid=")[0]), (un = un.split("?gid=")[0])),
                                _e("afterChange", a.updateURL),
                                _e("unbindEvents", function () {
                                    o.unbind(window, "hashchange", a.onHashChange);
                                });
                            var e = function () {
                                (dn = !0), mn || (fn ? history.back() : un ? (hn.hash = un) : gn ? history.pushState("", document.title, hn.pathname + hn.search) : (hn.hash = "")), yn();
                            };
                            _e("unbindEvents", function () {
                                c && e();
                            }),
                                _e("destroy", function () {
                                    dn || e();
                                }),
                                _e("firstUpdate", function () {
                                    d = Sn().pid;
                                });
                            var t = un.indexOf("pid=");
                            t > -1 && "&" === (un = un.substring(0, t)).slice(-1) && (un = un.slice(0, -1)),
                                setTimeout(function () {
                                    r && o.bind(window, "hashchange", a.onHashChange);
                                }, 40);
                        }
                    },
                    onHashChange: function () {
                        return Tn() === un ? ((mn = !0), void a.close()) : void (ln || ((cn = !0), a.goTo(Sn().pid), (cn = !1)));
                    },
                    updateURL: function () {
                        yn(), cn || (pn ? (an = setTimeout(wn, 800)) : wn());
                    },
                },
            }),
                o.extend(a, Je);
        };
    }),
    (function (e, t) {
        "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? (module.exports = t()) : (e.PhotoSwipeUI_Default = t());
    })(this, function () {
        "use strict";
        return function (e, t) {
            var n,
                i,
                o,
                a,
                s,
                r,
                l,
                c,
                d,
                u,
                p,
                m,
                f,
                h,
                g,
                v,
                T,
                y,
                S,
                w = this,
                b = !1,
                x = !0,
                C = !0,
                _ = {
                    barsSize: { top: 44, bottom: "auto" },
                    closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                    timeToIdle: 4e3,
                    timeToIdleOutside: 1e3,
                    loadingIndicatorDelay: 1e3,
                    addCaptionHTMLFn: function (e, t) {
                        return e.title ? ((t.children[0].innerHTML = e.title), !0) : ((t.children[0].innerHTML = ""), !1);
                    },
                    closeEl: !0,
                    captionEl: !0,
                    fullscreenEl: !0,
                    zoomEl: !0,
                    shareEl: !0,
                    counterEl: !0,
                    arrowEl: !0,
                    preloaderEl: !0,
                    tapToClose: !1,
                    tapToToggleControls: !0,
                    clickToCloseNonZoomable: !0,
                    shareButtons: [
                        { id: "facebook", label: "Share on Facebook", url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" },
                        { id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" },
                        { id: "pinterest", label: "Pin it", url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" },
                        { id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0 },
                    ],
                    getImageURLForShare: function () {
                        return e.currItem.src || "";
                    },
                    getPageURLForShare: function () {
                        return window.location.href;
                    },
                    getTextForShare: function () {
                        return e.currItem.title || "";
                    },
                    indexIndicatorSep: " / ",
                    fitControlsWidth: 1200,
                },
                P = function (e) {
                    if (v) return !0;
                    (e = e || window.event), g.timeToIdle && g.mouseUsed && !d && $();
                    for (var n, i, o = (e.target || e.srcElement).getAttribute("class") || "", a = 0; a < B.length; a++) (n = B[a]).onTap && o.indexOf("pswp__" + n.name) > -1 && (n.onTap(), (i = !0));
                    if (i) {
                        e.stopPropagation && e.stopPropagation(), (v = !0);
                        var s = t.features.isOldAndroid ? 600 : 30;
                        T = setTimeout(function () {
                            v = !1;
                        }, s);
                    }
                },
                k = function () {
                    return !e.likelyTouchDevice || g.mouseUsed || screen.width > g.fitControlsWidth;
                },
                I = function (e, n, i) {
                    t[(i ? "add" : "remove") + "Class"](e, "pswp__" + n);
                },
                D = function () {
                    var e = 1 === g.getNumItemsFn();
                    e !== h && (I(i, "ui--one-slide", e), (h = e));
                },
                A = function () {
                    I(l, "share-modal--hidden", C);
                },
                M = function () {
                    return (
                        (C = !C)
                            ? (t.removeClass(l, "pswp__share-modal--fade-in"),
                              setTimeout(function () {
                                  C && A();
                              }, 300))
                            : (A(),
                              setTimeout(function () {
                                  C || t.addClass(l, "pswp__share-modal--fade-in");
                              }, 30)),
                        C || R(),
                        !1
                    );
                },
                E = function (t) {
                    var n = (t = t || window.event).target || t.srcElement;
                    return (
                        e.shout("shareLinkClick", t, n),
                        !(
                            !n.href ||
                            (!n.hasAttribute("download") &&
                                (window.open(n.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), C || M(), 1))
                        )
                    );
                },
                R = function () {
                    for (var e, t, n, i, o, a = "", s = 0; s < g.shareButtons.length; s++)
                        (e = g.shareButtons[s]),
                            (n = g.getImageURLForShare(e)),
                            (i = g.getPageURLForShare(e)),
                            (o = g.getTextForShare(e)),
                            (t = e.url.replace("{{url}}", encodeURIComponent(i)).replace("{{image_url}}", encodeURIComponent(n)).replace("{{raw_image_url}}", n).replace("{{text}}", encodeURIComponent(o))),
                            (a += '<a href="' + t + '" target="_blank" class="pswp__share--' + e.id + '"' + (e.download ? "download" : "") + ">" + e.label + "</a>"),
                            g.parseShareButtonOut && (a = g.parseShareButtonOut(e, a));
                    (l.children[0].innerHTML = a), (l.children[0].onclick = E);
                },
                O = function (e) {
                    for (var n = 0; n < g.closeElClasses.length; n++) if (t.hasClass(e, "pswp__" + g.closeElClasses[n])) return !0;
                },
                N = 0,
                $ = function () {
                    clearTimeout(S), (N = 0), d && w.setIdle(!1);
                },
                L = function (e) {
                    var t = (e = e || window.event).relatedTarget || e.toElement;
                    (t && "HTML" !== t.nodeName) ||
                        (clearTimeout(S),
                        (S = setTimeout(function () {
                            w.setIdle(!0);
                        }, g.timeToIdleOutside)));
                },
                F = function (e) {
                    m !== e && (I(p, "preloader--active", !e), (m = e));
                },
                U = function (e) {
                    var n = e.vGap;
                    if (k()) {
                        var s = g.barsSize;
                        if (g.captionEl && "auto" === s.bottom)
                            if ((a || ((a = t.createEl("pswp__caption pswp__caption--fake")).appendChild(t.createEl("pswp__caption__center")), i.insertBefore(a, o), t.addClass(i, "pswp__ui--fit")), g.addCaptionHTMLFn(e, a, !0))) {
                                var r = a.clientHeight;
                                n.bottom = parseInt(r, 10) || 44;
                            } else n.bottom = s.top;
                        else n.bottom = "auto" === s.bottom ? 0 : s.bottom;
                        n.top = s.top;
                    } else n.top = n.bottom = 0;
                },
                B = [
                    {
                        name: "caption",
                        option: "captionEl",
                        onInit: function (e) {
                            o = e;
                        },
                    },
                    {
                        name: "share-modal",
                        option: "shareEl",
                        onInit: function (e) {
                            l = e;
                        },
                        onTap: function () {
                            M();
                        },
                    },
                    {
                        name: "button--share",
                        option: "shareEl",
                        onInit: function (e) {
                            r = e;
                        },
                        onTap: function () {
                            M();
                        },
                    },
                    { name: "button--zoom", option: "zoomEl", onTap: e.toggleDesktopZoom },
                    {
                        name: "counter",
                        option: "counterEl",
                        onInit: function (e) {
                            s = e;
                        },
                    },
                    { name: "button--close", option: "closeEl", onTap: e.close },
                    { name: "button--arrow--left", option: "arrowEl", onTap: e.prev },
                    { name: "button--arrow--right", option: "arrowEl", onTap: e.next },
                    {
                        name: "button--fs",
                        option: "fullscreenEl",
                        onTap: function () {
                            n.isFullscreen() ? n.exit() : n.enter();
                        },
                    },
                    {
                        name: "preloader",
                        option: "preloaderEl",
                        onInit: function (e) {
                            p = e;
                        },
                    },
                ];
            (w.init = function () {
                t.extend(e.options, _, !0),
                    (g = e.options),
                    (i = t.getChildByClass(e.scrollWrap, "pswp__ui")),
                    (u = e.listen),
                    (function () {
                        u("onVerticalDrag", function (e) {
                            x && e < 0.95 ? w.hideControls() : !x && e >= 0.95 && w.showControls();
                        });
                        var e;
                        u("onPinchClose", function (t) {
                            x && t < 0.9 ? (w.hideControls(), (e = !0)) : e && !x && t > 0.9 && w.showControls();
                        }),
                            u("zoomGestureEnded", function () {
                                (e = !1) && !x && w.showControls();
                            });
                    })(),
                    u("beforeChange", w.update),
                    u("doubleTap", function (t) {
                        var n = e.currItem.initialZoomLevel;
                        e.getZoomLevel() !== n ? e.zoomTo(n, t, 333) : e.zoomTo(g.getDoubleTapZoom(!1, e.currItem), t, 333);
                    }),
                    u("preventDragEvent", function (e, t, n) {
                        var i = e.target || e.srcElement;
                        i && i.getAttribute("class") && e.type.indexOf("mouse") > -1 && (i.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(i.tagName)) && (n.prevent = !1);
                    }),
                    u("bindEvents", function () {
                        t.bind(i, "pswpTap click", P), t.bind(e.scrollWrap, "pswpTap", w.onGlobalTap), e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", w.onMouseOver);
                    }),
                    u("unbindEvents", function () {
                        C || M(),
                            y && clearInterval(y),
                            t.unbind(document, "mouseout", L),
                            t.unbind(document, "mousemove", $),
                            t.unbind(i, "pswpTap click", P),
                            t.unbind(e.scrollWrap, "pswpTap", w.onGlobalTap),
                            t.unbind(e.scrollWrap, "mouseover", w.onMouseOver),
                            n && (t.unbind(document, n.eventK, w.updateFullscreen), n.isFullscreen() && ((g.hideAnimationDuration = 0), n.exit()), (n = null));
                    }),
                    u("destroy", function () {
                        g.captionEl && (a && i.removeChild(a), t.removeClass(o, "pswp__caption--empty")), l && (l.children[0].onclick = null), t.removeClass(i, "pswp__ui--over-close"), t.addClass(i, "pswp__ui--hidden"), w.setIdle(!1);
                    }),
                    g.showAnimationDuration || t.removeClass(i, "pswp__ui--hidden"),
                    u("initialZoomIn", function () {
                        g.showAnimationDuration && t.removeClass(i, "pswp__ui--hidden");
                    }),
                    u("initialZoomOut", function () {
                        t.addClass(i, "pswp__ui--hidden");
                    }),
                    u("parseVerticalMargin", U),
                    (function () {
                        var e,
                            n,
                            o,
                            a = function (i) {
                                if (i)
                                    for (var a = i.length, s = 0; s < a; s++) {
                                        (e = i[s]), (n = e.className);
                                        for (var r = 0; r < B.length; r++)
                                            (o = B[r]), n.indexOf("pswp__" + o.name) > -1 && (g[o.option] ? (t.removeClass(e, "pswp__element--disabled"), o.onInit && o.onInit(e)) : t.addClass(e, "pswp__element--disabled"));
                                    }
                            };
                        a(i.children);
                        var s = t.getChildByClass(i, "pswp__top-bar");
                        s && a(s.children);
                    })(),
                    g.shareEl && r && l && (C = !0),
                    D(),
                    g.timeToIdle &&
                        u("mouseUsed", function () {
                            t.bind(document, "mousemove", $),
                                t.bind(document, "mouseout", L),
                                (y = setInterval(function () {
                                    2 == ++N && w.setIdle(!0);
                                }, g.timeToIdle / 2));
                        }),
                    g.fullscreenEl &&
                        !t.features.isOldAndroid &&
                        (n || (n = w.getFullscreenAPI()), n ? (t.bind(document, n.eventK, w.updateFullscreen), w.updateFullscreen(), t.addClass(e.template, "pswp--supports-fs")) : t.removeClass(e.template, "pswp--supports-fs")),
                    g.preloaderEl &&
                        (F(!0),
                        u("beforeChange", function () {
                            clearTimeout(f),
                                (f = setTimeout(function () {
                                    e.currItem && e.currItem.loading ? (!e.allowProgressiveImg() || (e.currItem.img && !e.currItem.img.naturalWidth)) && F(!1) : F(!0);
                                }, g.loadingIndicatorDelay));
                        }),
                        u("imageLoadComplete", function (t, n) {
                            e.currItem === n && F(!0);
                        }));
            }),
                (w.setIdle = function (e) {
                    (d = e), I(i, "ui--idle", e);
                }),
                (w.update = function () {
                    x && e.currItem ? (w.updateIndexIndicator(), g.captionEl && (g.addCaptionHTMLFn(e.currItem, o), I(o, "caption--empty", !e.currItem.title)), (b = !0)) : (b = !1), C || M(), D();
                }),
                (w.updateFullscreen = function (i) {
                    i &&
                        setTimeout(function () {
                            e.setScrollOffset(0, t.getScrollY());
                        }, 50),
                        t[(n.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pswp--fs");
                }),
                (w.updateIndexIndicator = function () {
                    g.counterEl && (s.innerHTML = e.getCurrentIndex() + 1 + g.indexIndicatorSep + g.getNumItemsFn());
                }),
                (w.onGlobalTap = function (n) {
                    var i = (n = n || window.event).target || n.srcElement;
                    if (!v)
                        if (n.detail && "mouse" === n.detail.pointerType) {
                            if (O(i)) return void e.close();
                            t.hasClass(i, "pswp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? g.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(n.detail.releasePoint));
                        } else if ((g.tapToToggleControls && (x ? w.hideControls() : w.showControls()), g.tapToClose && (t.hasClass(i, "pswp__img") || O(i)))) return void e.close();
                }),
                (w.onMouseOver = function (e) {
                    var t = (e = e || window.event).target || e.srcElement;
                    I(i, "ui--over-close", O(t));
                }),
                (w.hideControls = function () {
                    t.addClass(i, "pswp__ui--hidden"), (x = !1);
                }),
                (w.showControls = function () {
                    (x = !0), b || w.update(), t.removeClass(i, "pswp__ui--hidden");
                }),
                (w.supportsFullscreen = function () {
                    var e = document;
                    return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen);
                }),
                (w.getFullscreenAPI = function () {
                    var t,
                        n = document.documentElement,
                        i = "fullscreenchange";
                    return (
                        n.requestFullscreen
                            ? (t = { enterK: "requestFullscreen", exitK: "exitFullscreen", elementK: "fullscreenElement", eventK: i })
                            : n.mozRequestFullScreen
                            ? (t = { enterK: "mozRequestFullScreen", exitK: "mozCancelFullScreen", elementK: "mozFullScreenElement", eventK: "moz" + i })
                            : n.webkitRequestFullscreen
                            ? (t = { enterK: "webkitRequestFullscreen", exitK: "webkitExitFullscreen", elementK: "webkitFullscreenElement", eventK: "webkit" + i })
                            : n.msRequestFullscreen && (t = { enterK: "msRequestFullscreen", exitK: "msExitFullscreen", elementK: "msFullscreenElement", eventK: "MSFullscreenChange" }),
                        t &&
                            ((t.enter = function () {
                                return (c = g.closeOnScroll), (g.closeOnScroll = !1), "webkitRequestFullscreen" !== this.enterK ? e.template[this.enterK]() : void e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                            }),
                            (t.exit = function () {
                                return (g.closeOnScroll = c), document[this.exitK]();
                            }),
                            (t.isFullscreen = function () {
                                return document[this.elementK];
                            })),
                        t
                    );
                });
        };
    }),
    (function (e) {
        "use strict";
        function t(e, t) {
            return JSON.parse(e || t || "{}");
        }
        var n = e(window),
            i = e(document),
            o = n.width(),
            a = e("html"),
            s = e("body"),
            r = o < 768,
            l = window.T4Sstrings,
            c = e(".t4s-close-overlay"),
            d = "t4s-lock-scroll",
            u = "[data-t4s-scroll-me]",
            p = T4Srequest.page_type,
            m = T4Sroutes.search_url,
            f = T4Sconfigs.platform_email,
            h = T4Sconfigs.enableConfetti,
            g = T4SThemeSP.cacheNameFirst,
            v = "change:ajaxCart",
            T = "top-start, top, top-end, left-start, left, left-end, right-start, right, right-end, bottom-start, bottom, bottom-end".split(", "),
            y = { left: "right", "left-start": "right-start", "left-end": "right-end", right: "left", "right-start": "left-start", "right-end": "left-end" },
            S = function (e) {
                return isThemeRTL ? y[e] || e : e;
            };
        (T4SThemeSP.Tooltip = (function () {
            function t(t, n, a) {
                var s = e(t),
                    r = (function (e) {
                        do {
                            e += ~~(1e6 * Math.random());
                        } while (document.getElementById(e));
                        return e;
                    })("tooltipt4s");
                s.attr("aria-describedby", r),
                    (function (e, t) {
                        T4SThemeSP.$appendComponent.after(i.replace("nt_txt_tt", e).replace("id_nt_tt", t));
                    })(a, r);
                var l = e("#" + r);
                !(function (e, t, n, i) {
                    fastdomT4s.mutate(function () {
                        FloatingUIT4sDOM.computePosition(e, t, {
                            placement: i,
                            middleware: [FloatingUIT4sDOM.offset(6), FloatingUIT4sDOM.flip({ fallbackPlacements: ["top", "bottom"] }), FloatingUIT4sDOM.shift({ padding: 5 }), FloatingUIT4sDOM.arrow({ element: n })],
                        }).then(({ x: e, y: i, placement: o, middlewareData: a }) => {
                            Object.assign(t.style, { top: "0", left: "0", transform: `translate3d(${Math.round(e)}px,${Math.round(i)}px,0)` });
                            const { x: s, y: r } = a.arrow,
                                l = { top: "bottom", right: "left", bottom: "top", left: "right" }[o.split("-")[0]];
                            Object.assign(n.style, { left: null != s ? `${s}px` : "", top: null != r ? `${r}px` : "", right: "", bottom: "", [l]: "-4px" });
                        });
                    });
                })(t, l[0], l.find(".t4s-tt-arrow")[0], n),
                    l.addClass(o);
            }
            function n(t) {
                var n = e("#" + e(t).attr("aria-describedby"));
                n.removeClass(o), n.remove();
            }
            var i = '<div class="t4s-tooltip" id="id_nt_tt" role="tooltip"><div class="t4s-tt-arrow"></div><div class="t4s-tooltip-inner">nt_txt_tt</div></div>',
                o = "is--show",
                a = function (e) {
                    var t = e.find(".t4s-text-pr").text() || e.text();
                    return (
                        e.attr("title") && "string" != typeof e.attr("data-original-title") && ((t = e.attr("title")), e.attr("data-original-title", e.attr("title") || "").attr("title", "")),
                        e.attr("data-t4s-tooltip") ? (t = e.attr("data-t4s-tooltip")) : e.attr("data-original-title") && (t = e.attr("data-original-title")),
                        t
                    );
                };
            return (
                s.on("t4s:hideTooltip", function () {
                    e(".t4s-tooltip.is--show").remove();
                }),
                function (i) {
                    if (!T4SThemeSP.isTouch) {
                        var o = e("[data-tooltip]:not(.t4s-tooltip-actived)");
                        0 != o.length &&
                            o
                                .hoverIntent({
                                    sensitivity: 6,
                                    interval: 80,
                                    timeout: 100,
                                    over: function (i) {
                                        let o = e(this),
                                            s = o.attr("data-tooltip") || "nt94";
                                        T.indexOf(s) < 0 ||
                                            (t(this, S(s), a(o)),
                                            o.on("updateTooltip", function () {
                                                n(this), t(this, S(s), a(o));
                                            }),
                                            o.on("destroyTooltip", function () {
                                                n(this);
                                            }));
                                    },
                                    out: function (t) {
                                        var i = e(this).attr("data-tooltip") || "nt94";
                                        T.indexOf(i) < 0 || (n(this), e(this).off("updateTooltip").off("destroyTooltip"));
                                    },
                                })
                                .addClass("t4s-tooltip-actived");
                    }
                }
            );
        })()),
            (T4SThemeSP.LookBook = (function () {
                function t(t, n, i = !1) {
                    if (t.hasClass(f.loaded)) i && a(t, n);
                    else {
                        var o = t.data("sid"),
                            s = h[n + o];
                        if (!t.is("[data-is-pr]")) return t.addClass(f.loaded), (s = e("#tem" + n).html()), T4SThemeSP.$appendComponent.after(s.replace('id=""', 'id="' + n + '"')), void (i && a(t, n));
                        s
                            ? (T4SThemeSP.$appendComponent.after(s), t.addClass(f.loaded), T4SThemeSP.ProductItem.init(), T4SThemeSP.Tooltip(), i && a(t, n))
                            : (t.addClass(f.loading),
                              fetch(t.data("href") + "/?section_id=" + o)
                                  .then(function (e) {
                                      return e.text();
                                  })
                                  .then(function (e) {
                                      (e = (e = e.split("[t4splitlz]")[1]).replace("id_nt_t4s", n)),
                                          T4SThemeSP.$appendComponent.after(e),
                                          t.removeClass(f.loading).addClass(f.loaded),
                                          T4SThemeSP.ProductItem.init(),
                                          T4SThemeSP.Tooltip(),
                                          i && a(t, n),
                                          g && (h[n + o] = e);
                                  })
                                  .catch(function (e) {
                                      t.removeClass(f.loading), console.log(e);
                                  }));
                    }
                }
                function o() {
                    r && (s.removeClass(d), T4SThemeSP.Helpers.disableBodyScroll(!1, u)),
                        e("[data-pin-close],[data-pin-popup]." + f.clicked).off("click.closelb"),
                        i.off("click.closelb").off("keyup.closelb"),
                        e("[data-pin-wrapper]." + f.opened).removeClass(f.opened),
                        e("[data-pin-popup]." + f.clicked).removeClass(f.clicked),
                        s.hasClass("is--opend-drawer") ? c.removeClass("is--pindop") : c.removeClass(f.visible);
                }
                function a(t, a, l = "lb") {
                    !(function (t) {
                        r && (s.addClass(d), T4SThemeSP.Helpers.disableBodyScroll(!0, u));
                        let n = e("#" + t);
                        n.addClass(f.opened), n.hasClass("is-style-mb--false") || c.addClass(f.visible);
                    })(a);
                    var m = e("#" + a),
                        h = m[0],
                        g = m.find(".t4s-" + l + "-arrow"),
                        v = t.data("position") || "top";
                    (n.width() > 767 || m.hasClass("is-style-mb--false")) &&
                        (function (e, t, n, i) {
                            fastdomT4s.mutate(function () {
                                FloatingUIT4sDOM.computePosition(e, t, {
                                    placement: i,
                                    middleware: [FloatingUIT4sDOM.offset(12), FloatingUIT4sDOM.flip({ fallbackPlacements: ["top", "bottom"] }), FloatingUIT4sDOM.shift({ padding: 0 }), FloatingUIT4sDOM.arrow({ element: n })],
                                }).then(({ x: e, y: i, placement: o, middlewareData: a }) => {
                                    Object.assign(t.style, { top: "0", left: "0", transform: `translate3d(${Math.round(e)}px,${Math.round(i)}px,0)` });
                                    const { x: s, y: r } = a.arrow,
                                        l = { top: "bottom", right: "left", bottom: "top", left: "right" }[o.split("-")[0]];
                                    Object.assign(n.style, { left: null != s ? `${s}px` : "", top: null != r ? `${r}px` : "", right: "", bottom: "", [l]: "-6px" });
                                });
                            });
                        })(t[0], h, g[0], S(v)),
                        "lb" == l
                            ? (i.on("click.closelb", function (t) {
                                  var n = e(t.target);
                                  n.closest("[data-pin-wrapper]").length > 0 || n.is("[data-pin-popup]") || o();
                              }),
                              e(`#${a} [data-pin-close], [data-pin-popup].${f.clicked}`).on("click.closelb", function (e) {
                                  e.preventDefault(), e.stopPropagation(), o();
                              }),
                              i.on("keyup.closelb", function (e) {
                                  27 === e.keyCode && o();
                              }))
                            : (i.on("click.closeDrop", function (t) {
                                  var n = e(t.target);
                                  n.closest("[data-dropdown-wrapper]").length > 0 || n.is("[data-dropdown-open]") || n.closest("[data-dropdown-open]").length > 0 || p();
                              }),
                              e(`#${a} [data-dropdown-close], [data-dropdown-open].${f.clicked}`).on("click.closeDrop", function (e) {
                                  e.preventDefault(), e.stopPropagation(), p();
                              }),
                              i.on("keyup.closeDrop", function (e) {
                                  27 === e.keyCode && p();
                              }));
                }
                function l() {
                    i.on("click", "[data-pin-popup]:not(." + f.clicked + ")", function (n) {
                        n.preventDefault();
                        var i = e(this),
                            a = i.data("bid");
                        o(), i.addClass(f.clicked), t(i, a, !0);
                    }),
                        e("[data-pin-popup][data-is-pr]:not(." + f.clicked + "):not(." + f.opened + ")").on("mouseenter.pin", function (n) {
                            var i = e(this),
                                o = i.data("bid");
                            i.addClass(f.preload), t(i, o), i.off("touchstart.pin mouseenter.pin");
                        });
                }
                function p() {
                    s.removeClass(d),
                        T4SThemeSP.Helpers.disableBodyScroll(!1, u),
                        e("[data-dropdown-close],[data-dropdown-open]." + f.clicked).off("click.closeDrop"),
                        i.off("click.closeDrop").off("keyup.closeDrop"),
                        e("[data-dropdown-wrapper]." + f.opened).removeClass(f.opened),
                        e("[data-dropdown-open]." + f.clicked).removeClass(f.clicked),
                        s.hasClass("is--opend-drawer") ? c.removeClass("is--pindop") : c.removeClass(f.visible);
                }
                function m() {
                    i.on("click", "[data-dropdown-open]:not(." + f.clicked + ")", function (t) {
                        t.preventDefault();
                        var n = e(this),
                            i = n.data("id");
                        p(),
                            n.addClass(f.clicked),
                            a(n, i, "drop"),
                            (function (t) {
                                e("#" + t).on("click.dopText", "[data-dropdown-item]", function (n) {
                                    n.preventDefault();
                                    var i = e(this);
                                    i
                                        .parents()
                                        .find("." + f.selected)
                                        .removeClass(f.selected),
                                        i.addClass(f.selected),
                                        e('[data-dropdown-open][data-id="' + t + '"]>span:not([data-not-change-txt])').text(i.text()),
                                        e("#" + t).off("click.dopText"),
                                        i.trigger("change:drop", [i, i.data("value")]),
                                        p();
                                });
                            })(i);
                    }),
                        i.on("click", "[data-dropdown-off]", function (t) {
                            var n = e(this);
                            e(this).closest("[data-dropdown-wrapper]").find("[data-dropdown-open]>span").text(n.text()), p();
                        }),
                        i.on("dropdown:t4s:close", function (e) {
                            p();
                        });
                }
                var f = { loading: "is--loading", loaded: "is--loaded", clicked: "is--clicked", selected: "is--selected", opened: "is--opened", preload: "is--preLoaded", visible: "is--visible is--pindop" },
                    h = [],
                    g = !1;
                return function () {
                    l(), m();
                };
            })()),
            (T4SThemeSP.Hover = function () {
                var t = e("[data-hover-t4s]");
                if (!(0 == t.length || o < 1025)) {
                    t.each(function (t, n) {
                        var i = this,
                            o = e(i);
                        (i.ishasGroup = i.hasAttribute("data-has-group")),
                            o.hoverIntent({
                                sensitivity: 3,
                                interval: o.data("interval") || 35,
                                timeout: o.data("timeout") || 150,
                                over: function (e) {
                                    i.ishasGroup ? (o.siblings().removeClass("is--hover"), o.addClass("is--hover")) : o.addClass("is--hover");
                                },
                                out: function () {
                                    i.ishasGroup || o.removeClass("is--hover");
                                },
                            });
                    });
                }
            }),
            (T4SThemeSP.ProductItem = (function () {
                function n(e, t) {
                    var n = e.find("[data-product-badge]"),
                        i = (n.attr("data-sort") || "").replace(/ /g, "").split(","),
                        o = "",
                        a = !t.unQuickShopInline;
                    if (0 != i.length && 0 != n.length) {
                        for (var s = i.length, r = 0; r < s; r++)
                            switch (i[r]) {
                                case "sale":
                                    var l = t.compare_at_price,
                                        c = t.price;
                                    if (l <= c || !x) {
                                        a && (o += '<span data-badge-sale class="t4s-badge-item t4s-badge-sale" hidden></span>');
                                        break;
                                    }
                                    if ("2" == C)
                                        var d = (100 * (l - c)) / l,
                                            u = ee.SavePercent.replace("[sale]", Math.round(d));
                                    else if ("3" == C)
                                        var p = l - c,
                                            u = T4SThemeSP.Currency.formatMoney(p);
                                    else u = ee[i[r]];
                                    o += '<span data-badge-sale class="t4s-badge-item t4s-badge-sale">' + u + "</span>";
                                    break;
                                case "preOrder":
                                    if (!t.isPreoder || !_) {
                                        a && (o += '<span data-badge-preorder class="t4s-badge-item t4s-badge-preorder" hidden>' + ee[i[r]] + "</span>");
                                        break;
                                    }
                                    o += '<span data-badge-preorder class="t4s-badge-item t4s-badge-preorder">' + ee[i[r]] + "</span>";
                                    break;
                                case "new":
                                    var m = y - t.dateStart,
                                        f = Math.floor(m / 3600);
                                    if ((f = Math.floor(f / 24)) >= S || !P) break;
                                    o += '<span class="t4s-badge-item t4s-badge-new">' + ee[i[r]] + "</span>";
                                    break;
                                case "soldout":
                                    if (t.available || !k) {
                                        a && (o += '<span data-badge-soldout class="t4s-badge-item t4s-badge-soldout" hidden>' + ee[i[r]] + "</span>");
                                        break;
                                    }
                                    o += '<span data-badge-soldout class="t4s-badge-item t4s-badge-soldout">' + ee[i[r]] + "</span>";
                                    break;
                                default:
                                    var h = t.customBadge;
                                    if (!h || !I) break;
                                    for (var g = h.length, v = 0; v < g; v++) o += '<span class="t4s-badge-item t4s-badge-custom t4s-badge-' + t.customBadgeHandle[v] + '">' + h[v] + "</span>";
                            }
                        n.html(o);
                    }
                }
                function o(n, i) {
                    var o = n.find("[" + B + "]");
                    if (0 != o.length) {
                        for (
                            var a = t(o.attr(B)),
                                s = a.color_variants,
                                r = a.color_variants_avai,
                                l = a.color_variants_handle,
                                c = a.img_options,
                                d = a.img_variants,
                                u = a.id_variants,
                                p = a.id_images || [],
                                m = a.img_ratios,
                                f = "",
                                h = d.length > 0,
                                g = s.length,
                                v = g != r.length,
                                T = 0;
                            T < g;
                            T++
                        ) {
                            var y = s[T],
                                S = c.indexOf(y),
                                w = h ? d[S] : "nt94",
                                b = "nt94" != (w = w || "nt94") ? T4SThemeSP.Images.lazyloadImagePath(w) : "none",
                                x = "nt94" != w && "2" == Z ? 'data-bg="' + T4SThemeSP.Images.getNewImageUrl(w, 100) + '"' : "",
                                C = v && r.indexOf(y) < 0 ? " t4s-pr-color--sold-out" : "";
                            f +=
                                '<span data-imgid="' +
                                (p[S] || "0") +
                                '" class="t4s-pr-color__item' +
                                C +
                                '" data-vid="' +
                                u[S] +
                                '" data-tooltip="top" data-img="' +
                                b +
                                '" data-ratio="' +
                                (m[S] || "") +
                                '"><span class="t4s-pr-color__name">' +
                                y +
                                '</span><span class="t4s-pr-color__value bg_color_' +
                                l[T] +
                                ' lazyloadt4s" ' +
                                x +
                                "></span></span>";
                        }
                        g > E &&
                            D &&
                            (f += '<span class="t4s-pr-color__item is--colors-more" data-tooltip="top-end"><span class="t4s-pr-color__name">' + K + '</span><a href="' + i + '" class="t4s-pr-color__value bg_color_limit4s"></a></span>'),
                            o.html(f);
                        if (0 != n.find(H).length) {
                            var _ = n.closest("[data-product-options]").data("product-options");
                            void 0 == T4sFunc.psjson_lib[_.id] &&
                                e
                                    .ajax({ url: Shopify.routes.root + "products/" + _.handle + ".js", type: "GET", dataType: "json" })
                                    .done(function (e) {
                                        T4sFunc.psjson_lib[_.id] = e;
                                    })
                                    .fail(function () {})
                                    .always(function (e) {});
                        }
                    }
                }
                function r(t) {
                    if (D) {
                        var n = t ? "[" + B + "]" : "[" + B + "]:not(." + z + ")";
                        M
                            ? fastdomT4s.measure(function () {
                                  e(n).each(function (t) {
                                      var n = e(this),
                                          i = n.find(".t4s-pr-color__item").length - 1,
                                          o = i - M;
                                      fastdomT4s.mutate(function () {
                                          n.addClass(z).removeClass(G),
                                              n.find(".is-color--limit").removeClass("is-color--limit"),
                                              o > 0 &&
                                                  (n.addClass(G),
                                                  n
                                                      .find(".t4s-pr-color__item")
                                                      .eq(M - 1)
                                                      .addClass("is-color--limit"),
                                                  n.attr("data-limit", i).attr("style", '--text : "+' + o + '";--text2 : "-' + o + '"'));
                                      });
                                  });
                              })
                            : fastdomT4s.measure(function () {
                                  e(n).each(function (t) {
                                      var n = e(this),
                                          i = n.find(".t4s-pr-color__item"),
                                          o = i.outerWidth(!0),
                                          a = i.length - 1,
                                          s = Math.floor(n.outerWidth() / o),
                                          r = a - s;
                                      fastdomT4s.mutate(function () {
                                          n.addClass(z).removeClass(G),
                                              n.find(".is-color--limit").removeClass("is-color--limit"),
                                              r > 0 &&
                                                  r != a &&
                                                  ((r += 1),
                                                  n.addClass(G),
                                                  n
                                                      .find(".t4s-pr-color__item")
                                                      .eq(s - 2)
                                                      .addClass("is-color--limit"),
                                                  n.attr("data-limit", s).attr("style", '--text : "+' + r + '";--text2 : "-' + r + '"'));
                                      });
                                  });
                              });
                    }
                }
                function l(t) {
                    var n = t.closest("[data-product-options]"),
                        i = n.data("product-options");
                    if ("0" == t.data("imgid")) {
                        var o = t.data("img"),
                            a = (t.data("ratio"), t.data("vid")),
                            s = n.find("[data-pr-img]"),
                            r = n.find("[data-pr-href]"),
                            l = r.attr("href");
                        if (
                            (t.closest("[data-color-options]").find(".is-swatch--selected").removeClass("is-swatch--selected"),
                            t.addClass("is-swatch--selected"),
                            n.addClass("t4s-colors-selected"),
                            s.attr("data-srcset", o),
                            "1" != J &&
                                void 0 !== a &&
                                (r.attr(
                                    "href",
                                    (function (e, t) {
                                        return /variant=/.test(e) ? e.replace(/(variant=)[^&]+/, "$1" + t) : /\?/.test(e) ? e.concat("&variant=").concat(t) : e.concat("?variant=").concat(t);
                                    })(l, a)
                                ),
                                void 0 !== T4sFunc.psjson_lib[i.id]))
                        ) {
                            let t = n.find(H),
                                o = t.find(">span"),
                                s = T4sFunc.psjson_lib[i.id].variants,
                                r = s.find((e) => e.id === a),
                                l = s.filter((e) => e[i.index_color] === r[i.index_color]);
                            o.removeClass("t4s-product-sizes--sold-out");
                            let c = 0;
                            e.map(l, function (e, t) {
                                e.available ? ++c : o.eq(t).addClass("t4s-product-sizes--sold-out");
                            }),
                                t.attr("data-size", c);
                        }
                    } else {
                        let e = n.find(".flickityt4s-enabled[data-product-img-carousel]");
                        if (0 == e.length) return;
                        let i = t.data("imgid");
                        t.data("isWrapped"), t.data("isInstant");
                        e.flickityt4s("select", e.find(`[data-product-img-slide="${i}"]`).index());
                    }
                }
                function c() {
                    T4Sconfigs.within_cat &&
                        0 != e(re).length &&
                        e(ae).each(function () {
                            (ne = e(this).attr(oe)),
                                e.trim(ne).length < 1 ||
                                    e(this)
                                        .find(re)
                                        .each(function () {
                                            (ie = e(this).attr("href")),
                                                (ie = ie.split(le)[1]),
                                                (ie = le + ie),
                                                e(this)
                                                    .attr("href", ne + ie)
                                                    .addClass(se);
                                        });
                        });
                }
                function d() {
                    c(),
                        e("[data-product-options]:not(.is-t4s-pr-created)").each(function () {
                            var i = e(this),
                                a = t(i.attr("data-product-options")),
                                s = i.find("[data-pr-href]").attr("href");
                            "boolean" != typeof a.unQuickShopInline && (a.unQuickShopInline = !0),
                                (function (e, t, n) {
                                    var i = "";
                                    "2" == w && t && ((i = T.replace("image_src", t).replace("image_alt", n)), e.find(".t4s-product-img").addClass("is-show-img2")), e.find("[data-replace-img2]").replaceWith(i);
                                })(i, a.image2, a.alt),
                                (function (t, n, i) {
                                    var o = t.find("[data-replace-quickview]"),
                                        a = o.attr(p) || "",
                                        s = n.id,
                                        r = t.find("[data-replace-compare]"),
                                        l = r.attr(p) || "",
                                        c = t.find("[data-replace-wishlist]"),
                                        d = c.attr(p) || "",
                                        g = t.find("[data-replace-atc]"),
                                        v = g.is("[data-has-qty]"),
                                        T = g.attr(p) || "",
                                        y = u.replace(/#t4s_pr_url/g, i).split("[split_t4snt]");
                                    o.each(function (t) {
                                        (a = e(this).attr(p) || ""), e(this).replaceWith(y[0].replace(m, m + a).replace(f, s));
                                    }),
                                        r.each(function (t) {
                                            (l = e(this).attr(p) || ""),
                                                e(this).replaceWith(
                                                    y[1]
                                                        .replace(m, m + l)
                                                        .replace(f, s)
                                                        .replace(h, n.handle)
                                                );
                                        }),
                                        c.each(function (t) {
                                            (d = e(this).attr(p) || ""),
                                                e(this).replaceWith(
                                                    y[2]
                                                        .replace(m, m + d)
                                                        .replace(f, s)
                                                        .replace(h, n.handle)
                                                );
                                        }),
                                        g.each(function (t) {
                                            (T = g.attr(p) || ""), e(this).replaceWith(y[3].replace(m, m + T).replace(f, s));
                                        });
                                    var S = (g = t.find("[data-atc-selector]")).find(F),
                                        w = g.find(U);
                                    if (n.isExternal) g.attr("href", n.external_link).attr("target", "_blank"), S.text(n.external_title), w.attr("xlink:href", "#t4s-icon-external");
                                    else if (n.available)
                                        if (n.isGrouped) S.text(L);
                                        else if (n.isDefault) {
                                            if ((n.isPreoder && S.text(R), g.attr({ "data-action-atc": "", "data-variant-id": n.VariantFirstID, "data-qty": n.cusQty || 1 }), Y && v && g[0])) {
                                                var x = g[0].outerHTML,
                                                    C = y[4].replace('max="9999"', `max="${n.maxQuantity}"`).replace('min="1"', `min="${n.cusQty || 1}"`);
                                                g.replaceWith('<div class="t4s-product-atc-qty">' + C + x + "</div>");
                                            }
                                        } else b && n.unQuickShopInline ? (g.attr("data-action-quickshop", ""), S.text($)) : S.text(N);
                                    else S.text(O), w.attr("xlink:href", "#t4s-icon-link");
                                    n.unQuickShopInline ||
                                        t.one("replace:btnAtc", function () {
                                            if ((g.attr({ "data-action-atc": "", "data-variant-id": n.VariantFirstID, "data-qty": n.cusQty || 1 }), Y && v && g[0])) {
                                                var e = g[0].outerHTML,
                                                    t = y[4].replace('max="9999"', `max="${n.maxQuantity}"`).replace('min="1"', `min="${n.cusQty || 1}"`);
                                                g.replaceWith('<div class="t4s-product-atc-qty">' + t + e + "</div>");
                                            }
                                        });
                                })(i, a, s),
                                n(i, a),
                                o(i, s),
                                r(),
                                (function (e, t, n) {
                                    if (n.unQuickShopInline || t.hasClass(te) || n.isGrouped || n.isExternal) return;
                                    var i = t.find("[data-qs-inl]");
                                    i.hasClass("lazyloadt4sed")
                                        ? new T4SThemeSP.Product(e)
                                        : i.one("lazyincluded", function () {
                                              new T4SThemeSP.Product(e);
                                          });
                                })(this, i, a),
                                i.addClass("is-t4s-pr-created");
                        }),
                        T4SThemeSP.Tooltip(),
                        T4SThemeSP.Compare.updateAll(),
                        T4SThemeSP.Wishlist.updateAll();
                }
                var u = e("#btns_pr_temp").html(),
                    p = "data-tooltip",
                    m = p + '="',
                    f = "id_nt_94",
                    h = "handle_nt_94",
                    g = T4Sconfigs,
                    v = T4SProductStrings,
                    T = T4Sconfigs.img2,
                    y = g.nowTimestamp,
                    S = g.new_day_int,
                    w = g.show_img,
                    b = g.enable_quickshop,
                    x = g.use_sale_badge,
                    C = g.label_sale_style,
                    _ = g.use_preorder_badge,
                    P = g.use_new_badge,
                    k = g.use_soldout_badge,
                    I = g.use_custom_badge,
                    D = g.swatch_limit,
                    A = g.swatch_click,
                    M = g.swatch_num,
                    E = 2,
                    R = v.preOrder,
                    O = v.readMore,
                    N = (v.soldOut, v.selectOption),
                    $ = v.quickShop,
                    L = v.preView,
                    F = ".t4s-text-pr",
                    U = ".t4s-svg-pr-icon use",
                    B = "data-color-options",
                    H = ".t4s-product-sizes",
                    W = "is--loading",
                    j = "is-t4s--opended",
                    z = "is-t4s--calced",
                    G = "is-t4s--limit",
                    q = "[data-t4s-resizeobserver]",
                    Z = g.sw_item_style,
                    K = v.swatch_limit,
                    V = v.swatch_limit_less,
                    Y = g.show_qty,
                    X = '.t4s-pr-color__item:not(.is-swatch--current):not([data-img="none"]):not(.is--colors-more)',
                    J = g.pr_curent,
                    Q = T4Sconfigs.app_review,
                    ee = { sale: v.badgeSale, new: v.badgeNew, preOrder: v.badgepreOrder, soldout: v.badgeSoldout, SavePercent: v.badgeSavePercent },
                    te = "initProducts__enabled";
                D && (a.addClass("t4s-pr-item-sw-limit"), M && M > 0 && (E = M));
                var ne,
                    ie,
                    oe = "data-collection-url",
                    ae = "[data-collection-url]",
                    se = "is--href-replaced",
                    re = "[data-pr-href]:not(.is--href-replaced)",
                    le = "/products/",
                    ce = [];
                return {
                    init: d,
                    initQuickVS: function () {
                        function t() {
                            var t = e(".t4s-product-quick-view"),
                                n = t.find("[data-product-featured]:not(." + te + ")");
                            n.addClass(te);
                            var i = t.find("[data-main-media]");
                            i.hasClass("flickityt4s") && !i.hasClass("flickityt4s-enabled") && (i[0].flickityt4s = new T4SThemeSP.Carousel(i[0])),
                                new T4SThemeSP.Product(n[0]),
                                T4SThemeSP.PopupMFP(),
                                T4SThemeSP.initGroupsProduct(),
                                window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                                T4SThemeSP.Wishlist.updateAll(),
                                T4SThemeSP.Compare.updateAll(),
                                T4SThemeSP.ProductItem.reloadReview(),
                                T4SThemeSP.Tooltip(),
                                s.trigger("currency:update");
                        }
                        function n() {
                            var t = e(".t4s-product-quick-shop:not(." + te + ")");
                            t.addClass(te),
                                new T4SThemeSP.Product(t[0]),
                                T4SThemeSP.PopupMFP(),
                                window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                                T4SThemeSP.Wishlist.updateAll(),
                                T4SThemeSP.Compare.updateAll(),
                                T4SThemeSP.ProductItem.reloadReview(),
                                T4SThemeSP.Tooltip(),
                                s.trigger("currency:update");
                        }
                        Y && a.addClass("t4s-pr-item-has-qty"),
                            s.on("click", "[data-action-quickview], [data-action-quickshop]", function (o) {
                                o.preventDefault();
                                var a = e(this);
                                if (!a.hasClass(W)) {
                                    var r = a.attr("href"),
                                        l = a.is("[data-action-quickview]"),
                                        c = l ? "main-qv" : "main-qs",
                                        d = l ? "t4s-opening-qv" : "t4s-opening-qs",
                                        u = a.data("id"),
                                        p = ce[c + u];
                                    if (((T4SThemeSP.isEditCartReplace = "0" == a.data("edit")), (T4SThemeSP.iDVariantEdit = u), (T4SThemeSP.keyVariantEdit = a.data("key")), p))
                                        T4SThemeSP.NTpopupInline(p, c, l ? t : n, d), s.trigger("modalt4s:opened");
                                    else {
                                        if (T4SThemeSP.isEditCartReplace) {
                                            var m = a.closest("[data-cart-item]"),
                                                f = a.closest("[data-cart-wrapper]"),
                                                h = m.find(".t4s-cart-ld__bar"),
                                                g = h.find(".t4s-cart-spinner");
                                            f.addClass("is--contentUpdate"),
                                                m.addClass("is--update"),
                                                h.removeAttr("hidden"),
                                                g.removeAttr("hidden"),
                                                i.on("cart:updated", function (e, t = "success") {
                                                    f.removeClass("is--contentUpdate"), i.off("cart:updated"), m.removeClass("is--update"), h.attr("hidden", ""), g.attr("hidden", ""), "success" == t && s.trigger("modalt4s:closed");
                                                });
                                        } else a.addClass(W);
                                        fetch(
                                            (function (e, t) {
                                                return e + (e.indexOf("?") > -1 || e.indexOf("&") > -1 ? "&" : "/?") + t;
                                            })(r, "section_id=" + c)
                                        )
                                            .then(function (e) {
                                                return e.text();
                                            })
                                            .then(function (o) {
                                                a.removeClass(W),
                                                    i.trigger("cart:updated"),
                                                    (o = IsDesignMode ? e(o).find("template").html() : e(o).html()),
                                                    T4SThemeSP.NTpopupInline(o, c, l ? t : n, d),
                                                    s.trigger("modalt4s:opened"),
                                                    (ce[c + u] = o);
                                            })
                                            .catch(function (e) {
                                                a.removeClass(W), i.trigger("cart:updated"), console.log(e);
                                            });
                                    }
                                }
                            });
                    },
                    recalculateSwatches: r,
                    clickMoreSwatches: function () {
                        D &&
                            "2" != A &&
                            s.on("click", ".t4s-pr-color__item.is--colors-more>a", function (t) {
                                t.preventDefault();
                                var n = e(this).closest("." + G);
                                n.hasClass(j) ? (n.removeClass(j), e(this).siblings().text(K)) : (n.addClass(j), e(this).siblings().text(V));
                            });
                    },
                    swatchesClickHover: function () {
                        T4SThemeSP.isTouch
                            ? s.on("click", X, function () {
                                  l(e(this));
                              })
                            : s.hoverIntent({
                                  selector: X,
                                  sensitivity: 6,
                                  interval: 100,
                                  timeout: 100,
                                  over: function (t) {
                                      l(e(this));
                                  },
                                  out: function () {},
                              });
                    },
                    resizeObserver: function () {
                        var t = e(q + ".flickityt4s-enabled .t4s-product:not(.t4s_observered), " + q + ".isotopet4s-enabled .t4s-product:not(.t4s_observered)");
                        if (0 != t.length && window.ResizeObserver) {
                            var n = new ResizeObserver(function (t) {
                                t.forEach(function (t) {
                                    var n,
                                        i = e(t.target),
                                        o = i.is(q) ? i : i.closest(q);
                                    clearTimeout(n),
                                        o.addClass("is-t4s--doing"),
                                        (n = setTimeout(function () {
                                            o.hasClass("flickityt4s-enabled") ? o.flickityt4s("resize") : o.hasClass("isotopet4s-enabled") && o.isotopet4s("layout"), o.removeClass("is-t4s--doing");
                                        }, 28));
                                });
                            });
                            t.each(function (t) {
                                var i = e(this);
                                n.observe(this),
                                    i.addClass("t4s_observered"),
                                    i.one("destroy.observered", function () {
                                        n.unobserve(this), i.removeClass("t4s_observered");
                                    });
                            });
                        }
                    },
                    reloadReview: function () {
                        if ("1" == Q)
                            try {
                                window.SPR && e(".spr-badge").length > 0 && SPR.initDomEls(), SPR.loadBadges();
                            } catch (e) {}
                        else "8" == Q ? "undefined" != typeof SMARTIFYAPPS && SMARTIFYAPPS.rv.installed && SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews() : "6" == Q && s.trigger("reloadReview.t4s");
                    },
                    loadjsRevew: function () {
                        "6" == Q && $script(T4Sconfigs.script12);
                    },
                    updateColelction: c,
                };
            })()),
            (T4SThemeSP.ProductAjax = (function () {
                function t(e = "json") {
                    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
                }
                function n(e = !1) {
                    e && !S && T4SThemeSP.Notices(e);
                }
                function o(e, o, s) {
                    var r = e.closest("[data-cart-item]"),
                        l = e.closest("[data-cart-wrapper]"),
                        c = r.find(".t4s-cart-ld__bar"),
                        d = c.find(".t4s-cart-spinner");
                    l.addClass("is--contentUpdate"),
                        r.addClass("is--update"),
                        c.removeAttr("hidden"),
                        d.removeAttr("hidden"),
                        i.on("cart:updated", function (e) {
                            l.removeClass("is--contentUpdate"), i.off("cart:updated"), r.removeClass("is--update"), c.attr("hidden", ""), d.attr("hidden", "");
                        });
                    const u = t("javascript");
                    (u.headers["X-Requested-With"] = "XMLHttpRequest"),
                        (u.body = JSON.stringify({ line: r.index() + 1, quantity: s, sections: f, sections_url: window.location.pathname })),
                        fetch(`${y}`, u)
                            .then((e) => e.json())
                            .then((e) => {
                                if (e.status) return n(e.description), void i.trigger("cart:updated", ["error"]);
                                a(e.sections);
                            })
                            .catch((e) => {
                                i.trigger("cart:updated"), console.error(e);
                            });
                }
                function a(e) {
                    e ? T4SThemeSP.Cart.renderContents(e) : T4SThemeSP.Cart.getToFetch();
                }
                function r(o) {
                    var r,
                        l = o.find("[data-field-required]"),
                        c = !!o.hasClass("has--properties") && l.length > 0,
                        p = !1;
                    o.on("click", "[data-atc-form]", function (m) {
                        if (e(this).attr(u.disabled)) m.preventDefault(), T4SThemeSP.Notices(T4SProductStrings.pleaseChooseOptions);
                        else {
                            if (
                                (c &&
                                    (m.preventDefault(),
                                    (p = !1),
                                    l.each(function () {
                                        let t = e(this),
                                            n = t.closest("[data-item-property-field]");
                                        n.hasClass("is--type-radio") || n.hasClass("is--type-checkbox") ? n.find("input[name]").is(":checked") || (n.addClass(x), (p = !0)) : 0 == t.val().length && (n.addClass(x), (p = !0));
                                    })),
                                p)
                            )
                                return (
                                    clearTimeout(r),
                                    (r = setTimeout(function () {
                                        o.find(".is--animated.t4s-ani-shake").removeClass("is--animated t4s-ani-shake");
                                    }, 999)),
                                    void l.off(b).on(b, function (t) {
                                        let n = e(this),
                                            i = n.closest("[data-item-property-field]");
                                        i.hasClass("is--type-radio") || i.hasClass("is--type-checkbox") ? i.find("input[name]").is(":checked") && i.removeClass(x) : n.val().length > 0 && i.removeClass(x);
                                    })
                                );
                            if (!h) return;
                            l.off(b),
                                m.preventDefault(),
                                (function (e) {
                                    e.addClass(d.loading).attr("aria-disabled", !0),
                                        e.find(".loading-overlay__spinner").removeAttr("hidden"),
                                        e.find(".t4s-svg-spinner").removeAttr("hidden"),
                                        i.on("cart:updated", function (t, n = "success") {
                                            e.removeClass(d.loading).removeAttr(u.disabled),
                                                e.find(".loading-overlay__spinner").attr("hidden", ""),
                                                e.find(".t4s-svg-spinner").attr("hidden", ""),
                                                i.off("cart:updated"),
                                                "success" == n && s.trigger("modalt4s:closed");
                                        });
                                    const o = t("javascript");
                                    (o.headers["X-Requested-With"] = "XMLHttpRequest"), delete o.headers["Content-Type"];
                                    const r = new FormData(e.closest("form")[0]);
                                    r.append("sections", w),
                                        r.append("sections_url", window.location.pathname),
                                        (o.body = r),
                                        fetch(`${T}`, o)
                                            .then((e) => e.json())
                                            .then((e) => {
                                                if (e.status) return n(e.description), void i.trigger("cart:updated", ["error"]);
                                                if (T4SThemeSP.isEditCartReplace && e.variant_id != T4SThemeSP.iDVariantEdit) {
                                                    const e = t("javascript");
                                                    (e.headers["X-Requested-With"] = "XMLHttpRequest"),
                                                        (e.body = JSON.stringify({ id: `${T4SThemeSP.keyVariantEdit}`, quantity: 0 })),
                                                        fetch(`${y}`, e)
                                                            .then((e) => e.json())
                                                            .then((e) => {
                                                                e.status ? n(e.description) : (i.trigger("add:cart:success").trigger("add:cart:upsell"), (T4SThemeSP.isATCSuccess = !0), a(e.sections));
                                                            })
                                                            .catch((e) => {
                                                                console.error(e);
                                                            });
                                                } else i.trigger("add:cart:success").trigger("add:cart:upsell"), (T4SThemeSP.isATCSuccess = !0), a(e.sections);
                                            })
                                            .catch((e) => {
                                                i.trigger("cart:updated");
                                            })
                                            .finally(() => {});
                                })(e(this));
                        }
                    });
                }
                function l() {
                    s.on("click", "[data-action-atc]", function (o) {
                        h &&
                            (o.preventDefault(),
                            (function (e) {
                                e.addClass(d.loading).attr(u.disabled, !0);
                                const o = t("javascript");
                                o.headers["X-Requested-With"] = "XMLHttpRequest";
                                var s = e.attr("data-variant-id"),
                                    r = parseInt(e.prev("[data-quantity-wrapper]").find("[data-quantity-value]").val()) || e.data("qty") || 1,
                                    l = [];
                                l.push({ id: s, quantity: r }),
                                    (o.body = JSON.stringify({ items: l, sections: f, sections_url: window.location.pathname })),
                                    i.on("cart:updated", function (t) {
                                        e.removeClass(d.loading).removeAttr(u.disabled), i.off("cart:updated");
                                    }),
                                    fetch(`${T}`, o)
                                        .then((e) => e.json())
                                        .then((e) => {
                                            if (e.status) return n(e.description), void i.trigger("cart:updated", ["error"]);
                                            i.trigger("add:cart:success").trigger("add:cart:upsell"), (T4SThemeSP.isATCSuccess = !0), a(e.sections);
                                        })
                                        .catch((e) => {
                                            i.trigger("cart:updated"), console.error(e);
                                        });
                            })(e(this)));
                    });
                }



              
                // function c() {
                //     e("[data-cart-items]")
                //         .off(v)
                //         .on(v, "[data-action-change]", function (t) {
                //             var n = e(this),
                //                 i = (n.closest("[data-cart-item]"), n.data("id"), n.val() || 1);
                //             n.attr("max");
                //             g && o(n, 0, i);
                //         })
                //         .off("click.remove")
                //         .on("click.remove", "[data-cart-remove]", function (t) {
                //             if (g) {
                //                 t.preventDefault();
                //                 var n = e(this);
                //                 n.data("id");
                //                 o(n, 0, 0);
                //             }
                //         });
                // }

function c() {
                    e("[data-cart-items]")
                        .off(v)
                        .on(v, "[data-action-change]", function (t) {
                            var n = e(this),
                                i = (n.closest("[data-cart-item]"), n.data("id"), n.val() || 1);
                            n.attr("max");
                            g && o(n, 0, i);
                        })
                        .off("click.remove")
                        .on("click.remove", "[data-cart-remove]", function (t) {
                            if (g) {
                                t.preventDefault();
                                var n = e(this);
                       
var productId = n.data("id"); 
var mainItem = e("[data-cart-items] [data-cart-item-parent-addon]");
// console.log("main Item", mainItem);     
// var mainItemValue = e("[data-cart-item-parent-addon]").value;
// console.log("main Item Value", mainItemValue)
// var mainItemValue = document.querySelector("[data-cart-item-parent-addon]").getAttribute('data-cart-item-parent-addon');
// console.log("main Item Value", mainItemValue);
var mainItems = document.querySelector("[data-cart-items] [data-cart-item-parent-addon]");
var mainItemIds = mainItems ? mainItems.id : null;
// console.log("Main Item ID:", mainItemIds);

var mainItemsChild = document.querySelector("[data-cart-items] [data-cart-item-parent-addon]");
var mainItemIdsChild = mainItemsChild ? mainItemsChild.id : null;
// console.log("Child Item ID:", mainItemIdsChild);                              
                              
var isAddonItem = e("[data-cart-items] [data-cart-item-child-addon]");
// console.log("is Addon Item", isAddonItem);    
                              
var mainItemCount = mainItem.length;                                
var isAddonItemCount = isAddonItem.length;
                              
function removeChildItemsRecursively(items, index) {
if (index >= items.length) return; // Exit condition
var childItem = items.eq(index);
setTimeout(function() {
  ToRemoveItsOwnChild();
  // o(childItem.find("[data-cart-remove]"), 0, 0);
  removeChildItemsRecursively(items, index + 1);
}, 1000);
}
if (isAddonItemCount > 0) {
// console.log("Addon Items Count: " + isAddonItemCount);
// console.log("Main Items Count: " + mainItemCount);
var parentItem = n.closest("[data-cart-item-parent-addon]");
var parentValue = parentItem.attr("data-cart-item-parent-addon");
  
var childItemsToRemove = isAddonItem.filter(function() {
var childValue = e(this).attr("data-cart-item-child-addon");  
if(childValue === parentValue){
// console.log("Found Child addon Value: " + childValue);
// console.log("Found Parent Value: " + parentValue);
return childValue === parentValue && e(this).hasClass('ads-on');
}
});


removeChildItemsRecursively(childItemsToRemove, 0);
// n.data("id"), o(n, 0, 0);
}
function ToRemoveItsOwnChild() {  
  console.log("Main Item ID:", mainItemIds);

  var btsdf = document.querySelectorAll('.ads-on.t4s-mini_cart__remove');
  btsdf.forEach(function(item) {
    var itemId = item.id;
    console.log("Item ID:", itemId);
    var checkThis = mainItemIds.split(' ')[0];
    var check2 = itemId.split(' ')[0];
    console.log('check', checkThis);
    console.log('check2', check2);

    if (itemId === mainItemIds || itemId.split(' ')[0] === mainItemIds.split(' ')[0]) {
      item.click();
    }
  });
}
                              

                                n.data("id");
                                o(n, 0, 0);
                            }
                        });
                }







              
                var d = { loading: "is--loading" },
                    u = { disabled: "aria-disabled" },
                    m = "disable" == T4Sconfigs.cartType,
                    f = "cart" != p ? (m ? "cart_data" : "cart_data,mini_cart") : `cart_data,${window.cartT4SectionID}`,
                    h = T4Sconfigs.enableAjaxATC,
                    g = T4Sconfigs.enableAjaxCart,
                    T = T4Sroutes.cart_add_url + ".js",
                    y = T4Sroutes.cart_change_url + ".js",
                    S = T4Sconfigs.disATCerror,
                    w = f.split(","),
                    b = "change.required keyup.required",
                    x = "is--field-emty is--animated t4s-ani-shake";
                return {
                    init: function () {
                        i.on("submitAtc:t4s", function (e) {
                            r(e.$container.find('[data-type="add-to-cart-form"]'));
                        }),
                            r(e('[data-type="add-to-cart-form"]')),
                            l(),
                            c();
                    },
                    change: c,
                };
            })()),
            (T4SThemeSP.T4sQuantityAdjust = (function () {
                var t = l.notice_stock_msg,
                    n = T4Sconfigs.disOnlyStock,
                    i = "data-current-qty";
                return (
                    String.prototype.getDecimals ||
                        (String.prototype.getDecimals = function () {
                            var e = ("" + this).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                            return e ? Math.max(0, (e[1] ? e[1].length : 0) - (e[2] ? +e[2] : 0)) : 0;
                        }),
                    function () {
                        s.on("change", "[data-quantity-value]", function (o) {
                            var a = e(this),
                                r = (a.data("id"), a.val() || 1),
                                l = a.attr("max") || 9999,
                                c = a.attr("min") || 1,
                                d = a.attr(i) || 0.1,
                                u = a.closest(".fgr_frm");
                            if ((u.length > 0 && (subtt_price_group(u), s.trigger("currency:update")), parseInt(r) > parseInt(l))) {
                                if ((a.val(l), a.attr(i, l), d != l && a.attr(i, l).trigger(v), n)) return;
                                return T4SThemeSP.Notices(t.replace("[max]", l)), !1;
                            }
                            if (parseInt(r) < parseInt(c)) return a.val(c), d != c && a.attr(i, c).trigger(v), !1;
                            a.trigger(v), a.attr(i, r);
                        }),
                            s.on("click", "[data-quantity-selector]", function (i) {
                                i.preventDefault();
                                var o = e(this),
                                    a = o.closest("[data-quantity-wrapper]").find("[data-quantity-value]"),
                                    s = parseFloat(a.val()),
                                    r = parseFloat(a.attr("max")),
                                    l = parseFloat(a.attr("min")),
                                    c = a.attr("step");
                                if (
                                    ((s && "" !== s && "NaN" !== s) || (s = 0),
                                    ("" !== r && "NaN" !== r) || (r = ""),
                                    ("" !== l && "NaN" !== l) || (l = 0),
                                    ("any" !== c && "" !== c && void 0 !== c && "NaN" !== parseFloat(c)) || (c = 1),
                                    o.is("[data-increase-qty]"))
                                ) {
                                    if (r && s >= r) {
                                        if ((a.val(r), n)) return;
                                        return T4SThemeSP.Notices(t.replace("[max]", r)), !1;
                                    }
                                    a.val((s + parseFloat(c)).toFixed(c.getDecimals()));
                                } else l && s <= l ? a.val(l) : s > 0 && a.val((s - parseFloat(c)).toFixed(c.getDecimals()));
                                a.trigger("change");
                            });
                    }
                );
            })()),
            (T4SThemeSP.agreeForm = (function () {
                var t = !1,
                    n = "[data-agree-checkbox]";
                return function () {
                    t ||
                        0 == e(n).length ||
                        ((t = !0),
                        s.on("click", '[data-agree-btn], [name="checkout"], [name="goto_pp"], [name="goto_gc"]', function (t) {
                            var i = e(this).closest("form"),
                                o = i.find(`[type="checkbox"]${n}`);
                            i[0] && 0 != o.length && (o.is(":checked") ? e(this).submit() : (t.preventDefault(), t.stopPropagation(), T4SThemeSP.Notices(l.agree_checkout)));
                        }),
                        s.on("click", n, function (t) {
                            e(this).closest("form"), e(this).is(":checked") && s.trigger("hide.t4s.notices");
                        }));
                };
            })()),
            (T4SThemeSP.PhotoSwipe = (function () {
                function n() {
                    e("[data-t4s-gallery].flickityt4s-enabled")
                        .on("dragEnd.flickityt4s", function (e, t) {
                            p = !0;
                        })
                        .on("staticClick.flickityt4s", function (e, t, n, i) {
                            p = !1;
                        }),
                        i.on(f, m, function (t) {
                            t.preventDefault();
                            var n = e(this),
                                i = -1;
                            if (n.is("[data-pswp-btn-triger]")) {
                                var o = n.closest("[data-t4s-group-btns]") || n,
                                    a = n[0].hasAttribute("data-pr-trigger-pswp"),
                                    u = o.siblings("[data-t4s-gallery]");
                                (i = (function (t, n, i) {
                                    return n.hasClass("flickityt4s-enabled") ? n.find(i + ".is-selected").index() : e(t.currentTarget).is(m) ? 0 : e(t.currentTarget).index();
                                })(t, u, (f = a ? '[data-media-type="image"]:not(.is--media-hide)' : "[data-t4s-gallery--item]"))),
                                    (n = u.find("[data-t4s-gallery--open]").eq(i)),
                                    (p = !1);
                            } else var f = (a = n.hasClass("t4s-product__media")) ? '[data-media-type="image"]:not(.is--media-hide)' : "[data-t4s-gallery--item]";
                            var h = n.parents(f),
                                v = n.closest("[data-t4s-gallery]"),
                                T = v.find(a ? '[data-media-type="image"]:not(.is--media-hide) [data-master]' : "[data-pswp-src]");
                            if (0 == T.length || p) p = !1;
                            else {
                                var y = v.is("[data-t4s-thumb-true]"),
                                    S = (function (t) {
                                        var n,
                                            i = [];
                                        return (
                                            t.each(function () {
                                                (n = e(this)), i.push({ src: n.attr("data-pswp-src") || n.attr("data-master"), w: n.attr("data-pswp-w") || n.attr("width"), h: n.attr("data-pswp-h") || n.attr("height") });
                                            }),
                                            i
                                        );
                                    })(T),
                                    w = parseFloat(v.attr("data-maxSpreadZoom")),
                                    b = v.attr("data-fullscreenEl"),
                                    x = v.attr("data-shareEl"),
                                    C = v.attr("data-counterEl");
                                (function (t) {
                                    var n = t.items,
                                        i = n.length,
                                        o = t.index,
                                        a = t.galleryItems;
                                    isThemeRTL && (o = i - o - 1);
                                    var u = {
                                        closeEl: !0,
                                        captionEl: !0,
                                        fullscreenEl: t.fullscreenEl || !0,
                                        zoomEl: !0,
                                        shareEl: t.shareEl || !0,
                                        counterEl: t.counterEl || !0,
                                        arrowEl: !0,
                                        preloaderEl: !0,
                                        history: !1,
                                        maxSpreadZoom: t.maxSpreadZoom || 2,
                                        showHideOpacity: !0,
                                        bgOpacity: 1,
                                        index: t.index,
                                        tapToToggleControls: !0,
                                        shareButtons: [
                                            { id: "facebook", label: l.pswp_facebook, url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" },
                                            { id: "twitter", label: l.pswp_twitter, url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" },
                                            { id: "pinterest", label: l.pswp_pinterest, url: "https://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" },
                                        ],
                                        getThumbBoundsFn: function (e) {
                                            var n = a.find(t.parents).eq(e);
                                            t.global && (n = a.find("a[data-index=" + e + "]").parents(t.parents));
                                            var i = window.pageYOffset || document.documentElement.scrollTop,
                                                o = n[0].getElementsByTagName("img")[0].getBoundingClientRect();
                                            return { x: o.left, y: o.top + i, w: o.width };
                                        },
                                    };
                                    s.find(g).remove(), T4SThemeSP.$appendComponent.after(c);
                                    var p,
                                        m = document.querySelectorAll(g)[0],
                                        f = e("." + d),
                                        h = new PhotoSwipe(m, PhotoSwipeUI_Default, n, u);
                                    h.init(),
                                        f.empty(),
                                        clearTimeout(p),
                                        s.trigger("NTpopupInline:offClose"),
                                        h.listen("close", function () {
                                            if (
                                                ((p = setTimeout(function () {
                                                    s.trigger("NTpopupInline:onClose");
                                                }, 500)),
                                                a.hasClass("flickityt4s-enabled"))
                                            ) {
                                                var e = h.getCurrentIndex();
                                                a.flickityt4s("selectCell", e, !1, !0);
                                            }
                                        }),
                                        t.HasThumb && r(i, n, f, h);
                                })({ index: (i = i > -1 ? i : h.index()), items: S, HasThumb: y, galleryItems: v, parents: f, global: !1, maxSpreadZoom: w, fullscreenEl: b, shareEl: x, counterEl: C });
                            }
                        });
                }
                function o() {
                    i.on(f, "[data-t4s-image-opend]", function (t) {
                        t.preventDefault(),
                            (function (t) {
                                s.find(g).remove(), T4SThemeSP.$appendComponent.after(c);
                                var n = e(g),
                                    i = n[0],
                                    o = t.attr("data-pswp-class");
                                o && n.addClass(o);
                                var a = {
                                        history: !1,
                                        maxSpreadZoom: 2,
                                        showHideOpacity: !0,
                                        fullscreenEl: !1,
                                        shareEl: !1,
                                        counterEl: !1,
                                        bgOpacity: 1,
                                        getThumbBoundsFn: function (e) {
                                            var n = window.pageYOffset || document.documentElement.scrollTop,
                                                i = t[0].getBoundingClientRect();
                                            return { x: i.left, y: i.top + n, w: i.width };
                                        },
                                    },
                                    r = [],
                                    l = t.attr("data-pswp-w"),
                                    d = t.attr("data-pswp-h"),
                                    u = t.attr("data-pswp-src");
                                r.push({ src: u, w: l, h: d, title: t.text() });
                                var p,
                                    m = new PhotoSwipe(i, PhotoSwipeUI_Default, r, a);
                                m.init(),
                                    clearTimeout(p),
                                    s.trigger("NTpopupInline:offClose"),
                                    m.listen("close", function () {
                                        p = setTimeout(function () {
                                            s.trigger("NTpopupInline:onClose");
                                        }, 500);
                                    });
                            })(e(this));
                    });
                }
                function a() {
                    i.on(f, `[${h}]`, function (n) {
                        n.preventDefault();
                        let i = e(this),
                            o = t(i.attr(h), "[]");
                        0 != o.length &&
                            (function (t, n) {
                                if (!t) return;
                                s.find(g).remove(), T4SThemeSP.$appendComponent.after(c);
                                let i = t.length,
                                    o = document.querySelectorAll(g)[0],
                                    a = e("." + d),
                                    l = new PhotoSwipe(o, PhotoSwipeUI_Default, t, { history: !1, focus: !1, showAnimationDuration: 0, hideAnimationDuration: 0 });
                                if ((l.init(), n.is("data-disable-thumb"))) return;
                                r(i, t, a, l);
                            })(o, i);
                    });
                }
                function r(t, n, i, o) {
                    if (!(t <= 1)) {
                        for (var a = 0; a < t; a++) i.append('<div class="pswp_thumb_item" data-index="' + (a + 1) + '"><img loading="lazy" src="' + n[a].src + '" alt="pswp-thumb-img"></div>');
                        i.find('.pswp_thumb_item[data-index="' + (o.getCurrentIndex() + 1) + '"]').addClass(u),
                            o.listen("beforeChange", function () {
                                var e = o.getCurrentIndex() + 1,
                                    t = i.find('.pswp_thumb_item[data-index="' + e + '"]');
                                t.siblings().removeClass(u), t.addClass(u);
                            }),
                            o.listen("afterChange", function () {
                                !(function (t) {
                                    let n = e("." + u)[0],
                                        i = t,
                                        o = i[0],
                                        a = n.getBoundingClientRect(),
                                        s = o.getBoundingClientRect();
                                    a.left + a.width > s.width ? i.animate({ scrollLeft: n.offsetLeft + a.width - s.width + 10 }, 200) : n.offsetLeft < o.scrollLeft && i.animate({ scrollLeft: n.offsetLeft - 10 }, 200);
                                })(i);
                            }),
                            i.find(".pswp_thumb_item").on("click", function () {
                                var t = e(this).data("index");
                                o.goTo(t - 1);
                            });
                    }
                }
                var c = e("#photoswipe_template").html(),
                    d = "pswp__thumbnails",
                    u = "pswp_thumb_active",
                    p = !1,
                    m = "[data-pswp-btn-triger], [data-t4s-gallery--open]:not(.is-pswp-disable)",
                    f = "click.pswp",
                    h = "data-pswp-images-trigger",
                    g = ".pswp__t4s";
                return { gallery: n, image: o, images: a };
            })()),
            (T4SThemeSP.Video = (function () {
                function t() {
                    e(".js-youtube").each(function () {
                        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
                    }),
                        e(".js-vimeo").each(function () {
                            this.contentWindow.postMessage('{"method":"pause"}', "*");
                        }),
                        e("video:not(.t4s_bg_vid_html5)").each(function () {
                            this.pause();
                        }),
                        e(".product-model").each(function () {
                            this.modelViewerUI && this.modelViewerUI.pause();
                        });
                }
                function n(e) {
                    e.target.playVideo();
                }
                function i() {
                    e("[data-video-poster-btn]").on("click", function (i) {
                        i.preventDefault();
                        var s = e(this).closest("[data-video-poster]"),
                            r = s.find("video, iframe");
                        t(),
                            (function (t, i) {
                                if (!t.is("[loaded]")) {
                                    var a = t.find("[data-video-insert]").length ? t.find("[data-video-insert]") : t,
                                        s =
                                            '<iframe src="src_t4s" id="id_t4s" class="class_t4s" title="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen frameborder="0"></iframe>',
                                        r = JSON.parse(i.attr("data-options") || "{}"),
                                        l = r.type,
                                        c = r.vid,
                                        d = r.id,
                                        u = r.srcDefault,
                                        p = r.autoplay,
                                        m = r.loop,
                                        f = { html5: "html5", youtube: "youtube", vimeo: "vimeo" };
                                    if (
                                        (l == f.youtube
                                            ? (s = '<div id="' + d.replace("#", "t4s_yt_") + '"></div>')
                                            : l == f.vimeo
                                            ? (s = s.replace("src_t4s", "//player.vimeo.com/video/" + c + "?&portrait=0&byline=0&color=" + r.accent_color + "&autoplay=" + +p + "&loop=" + +m).replace("class_t4s", "js-vimeo"))
                                            : d && e(d)[0]
                                            ? (s = e(d).html())
                                            : ((s = '<video src="src_t4s" preload="auto" controls data-autoplay data-loop playsinline></video>'.replace("src_t4s", u)),
                                              p && (s = s.replace("data-autoplay", "autoplay")),
                                              m && (s = s.replace("data-loop", "loop"))),
                                        a.append(s),
                                        t.attr("data-type-video-inline", "").attr("loaded", !0),
                                        l == f.youtube)
                                    ) {
                                        if (e("#YTAPI").length <= 0) {
                                            var h = document.createElement("script");
                                            (h.src = "https://www.youtube.com/iframe_api"), (h.id = "YTAPI");
                                            var g = document.getElementsByTagName("script")[0];
                                            g.parentNode.insertBefore(h, g);
                                        }
                                        var v = setInterval(function () {
                                            "function" == typeof onYouTubeIframeAPIReady &&
                                                "function" == typeof YT.Player &&
                                                ((o = new YT.Player(d.replace("#", "t4s_yt_"), { height: "315", width: "560", videoId: c, playerVars: { playsinline: 1, rel: 0, playlist: c, loop: m ? 1 : 0 }, events: { onReady: n } })),
                                                clearInterval(v));
                                        }, 100);
                                    }
                                }
                            })(s, e(this)),
                            setTimeout(function () {
                                s.addClass(a), r.focus();
                            }, 50);
                    }),
                        e("[data-video-poster-close]").on("click", function (n) {
                            n.preventDefault(), t();
                            var i = e(this).closest("[data-video-poster]");
                            i.removeAttr("loaded").removeClass(a), i.find("video, iframe").remove();
                        });
                }
                var o,
                    a = "t4s-postervideo-playing";
                return { initPoster: i };
            })());
        var w = (function () {
            function t(t) {
                (this.container = t),
                    (this.$container = e(t)),
                    (this.options = JSON.parse(this.$container.attr("data-ntajax-options"))),
                    (this.main = this.options.id || ""),
                    (this.typeAjax = this.options.type || "LmDefault"),
                    (this.isProduct = this.options.isProduct || !1),
                    (this.$section = e(`#shopify-section-${this.main}`)),
                    (self.isbtnLoadMore = !0),
                    this.setupEventListeners();
            }
            var n,
                i = { loading: "is--loading" };
            return (
                (t.prototype = Object.assign({}, t.prototype, {
                    setupEventListeners: function () {
                        var t = this;
                        t.$container.on("click.ntlm", "[data-load-more]", function (o) {
                            o.preventDefault();
                            const a = e(this);
                            a.addClass(i.loading), (n = `${a.attr("data-href") || a.attr("href")}&section_id=${t.main}`), (t.isbtnLoadMore = !e(this).is("[data-is-prev]")), (t.$btnCurrent = e(this)), t.renderSectionFromFetch(n);
                        });
                    },
                    renderSectionFromFetch: function (e) {
                        var t = this;
                        T4SThemeSP.getToFetchSection(null, "text", e).then((e) => {
                            "NVT_94" != e ? (t.$btnCurrent.removeClass(i.loading), t[t.typeAjax](e), this.isProduct && T4SThemeSP.reinitProductGridItem(), s.trigger("t4s:hideTooltip")) : t.$btnCurrent.removeClass(i.loading);
                        });
                    },
                    LmDefault: function (t) {
                        var n = e(t),
                            i = n.find("[data-contentlm-replace]").html(),
                            o = this.isbtnLoadMore ? n.find("[data-wrap-lm]") : n.find("[data-wrap-lm-prev]"),
                            a = this.$container.find("[data-contentlm-replace]");
                        a[0] || (a = this.$section.find("[data-contentlm-replace]")), this.isbtnLoadMore ? a.append(i) : a.prepend(i), this.initLoamoreUpdate(o);
                    },
                    LmIsotope: function (t) {
                        var n = e(t),
                            i = n.find("[data-contentlm-replace]").html(),
                            o = this.isbtnLoadMore ? n.find("[data-wrap-lm]") : n.find("[data-wrap-lm-prev]"),
                            a = this.$container.find("[data-contentlm-replace]");
                        a[0] || (a = this.$section.find("[data-contentlm-replace]")), (i = e(i)), this.isbtnLoadMore ? a.append(i).isotopet4s("appended", i) : a.prepend(i).isotopet4s("prepended", i), this.initLoamoreUpdate(o);
                    },
                    initLoamoreUpdate: function (e) {
                        let t = this.isbtnLoadMore ? "[data-wrap-lm]" : "[data-wrap-lm-prev]",
                            n = this.$container.find(t);
                        n[0] || (n = this.$section.find(t)), e.length > 0 ? n.html(e.html()) : n.hide();
                    },
                })),
                t
            );
        })();
        (T4SThemeSP.initLoadMore = function () {
            e("[data-ntajax-options][data-not-main]:not(.is--enabled)").each(function () {
                e(this).addClass("is--enabled"), (this.LoadMore = new w(this));
            });
        }),
            (T4SThemeSP.reinitProductGridItem = function () {
                this.ProductItem.init(), this.ProductItem.reloadReview(), this.Tooltip(), T4SThemeSP.Countdown(), T4SThemeSP.Compare.updateAll(), T4SThemeSP.Wishlist.updateAll(), s.trigger("currency:update");
            }),
            (T4SThemeSP.instagram = (function () {
                function n(t, n, i, o, a, s, r) {
                    1 == d.length && ((c = e(l).html() || ""), (d = c.split("[t4split]")));
                    var p = "",
                        i = i || !0,
                        m = { IMAGE: "image", VIDEO: "video", CAROUSEL_ALBUM: "carousel_album" },
                        f = { image: d[0], video: d[1], carousel_album: d[2] };
                    e.each(n, function (e, t) {
                        if (e >= a) return 0;
                        var n = t.thumbnail_url || t.media_url,
                            i = m[t.media_type];
                        p +=
                            '<div class="t4s-col-ins' +
                            e +
                            " t4s-col-ins t4s-col-item t4s-ins-type-" +
                            i +
                            '"><a data-no-instant rel="nofollow" class="t4s-d-block t4s-pr t4s-oh" href="' +
                            t.permalink +
                            '" target="' +
                            r +
                            '"><div class="t4s_ratio t4s_bg lazyloadt4s t4s-lz--ins" data-bg="' +
                            n +
                            '" data-sizes="auto"></div><span class="lazyloadt4s-loader"></span><div class="t4s-ins-info"><span class="t4s-ins-icon">' +
                            f[i] +
                            "</span></div></a></div>";
                    }),
                        t.html(p).parent().addClass(u.loaded),
                        t.hasClass("flickityt4s-later") && (t[0].flickityt4s = new T4SThemeSP.Carousel(t[0])),
                        isStorageSpSessionAll && i && (sessionStorage.setItem("nt_ins" + o + s, p), sessionStorage.setItem("nt_ins" + o, JSON.stringify({ timestamp: new Date(), content: n })));
                }
                function i() {
                    0 != e("[data-inst4s-options]").length &&
                        e("[data-inst4s-options]").each(function (i) {
                            !(function (e) {
                                var i,
                                    l,
                                    c = t(e.attr("data-inst4s-options")),
                                    d = null,
                                    p = null,
                                    m = c.id,
                                    f = c.limit,
                                    h = c.acc || "spnt_t4s",
                                    g = c.target;
                                if ("spnt_t4s" != h) {
                                    if (
                                        ((h = atob(h)),
                                        isStorageSpSessionAll &&
                                            ((d = sessionStorage.getItem("nt_ins" + h + m)),
                                            null != (p = sessionStorage.getItem("nt_ins" + h)) &&
                                                "" != p &&
                                                ((i = new Date()),
                                                (l = new Date(p.timestamp)).setMinutes(l.getMinutes() + 30),
                                                i.getTime() > l.getTime() && ((p = null), (d = null), sessionStorage.removeItem("nt_ins" + h + m), sessionStorage.removeItem("nt_ins" + h)))),
                                        null != d && "" != p)
                                    ) {
                                        if ((e.html(d).parent().addClass(u.loaded), !e.hasClass("flickityt4s-later"))) return;
                                        return (e[0].flickityt4s = new T4SThemeSP.Carousel(e[0])), !1;
                                    }
                                    null != p && "" != p
                                        ? ((p = JSON.parse(p).content), n(e, p, !1, h, f, m, g))
                                        : (h != a && (o = "https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token=" + h),
                                          fetch(o)
                                              .then(function (e) {
                                                  if (!e.ok) throw new Error("not ok");
                                                  return e.json();
                                              })
                                              .then((t) => {
                                                  var i = h == a ? t : t.data;
                                                  n(e, i, !0, h, f, m, g), r || (CookiesT4.set(s, "true", { expires: 7 }), fetch("https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&access_token=" + h));
                                              })
                                              .catch((t) => {
                                                  e.html(""), console.error("Instagram Feed:error fetch");
                                              }));
                                }
                            })(e(this));
                        });
                }
                var o = "https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=" + Shopify.shop + "&resource=default",
                    a = "ins_19041994",
                    s = "ig_t4s_token",
                    r = "true" === CookiesT4.get(s),
                    l = ".t4s-icons-ins-svg",
                    c = e(l).html() || "",
                    d = c.split("[t4split]"),
                    u = { loaded: "ins-is--loaded" };
                return i;
            })()),
            (T4SThemeSP.sideBarInit = function () {
                var t = e("[data-sidebar-id]"),
                    o = t.is("[data-sidebar-true]"),
                    a = e("[data-sidebar-content]"),
                    r = t.is("[data-is-disableDrawer]");
                if (0 != t.length) {
                    var l = t.attr("data-sidebar-id"),
                        c = window.location.search.slice(1),
                        d = `${window.location.pathname}?section_id=${l}&${c}`;
                    T4SThemeSP.getToFetchSection(null, "text", d).then((l) => {
                        if ("NVT_94" == l) return a.html(""), void console.log(error);
                        if (o || (n.width() < 1024 && !r)) {
                            d = (c = l.split("[t4splitlz]"))[2].split("[t4splitlz2]");
                            T4SThemeSP.$appendComponent.after(d[0] + c[1] + d[1]);
                        } else {
                            var c = l.split("[t4splitlz]"),
                                d = c[2].split("[t4splitlz2]");
                            a.html(c[1]), T4SThemeSP.$appendComponent.after(d[0] + c[1] + d[1]);
                        }
                        T4SThemeSP.instagram(), T4SThemeSP.Countdown(), T4SThemeSP.Tooltip(), T4SThemeSP.reinitProductGridItem(), T4SThemeSP.Tabs.Accordion(), s.trigger("currency:update"), i.trigger("sidebar:updated");
                        let u = t.attr("data-drawer-options");
                        e.each(e(JSON.parse(u).id).find(".flickityt4s-later"), function (e) {
                            this.flickityt4s = new T4SThemeSP.Carousel(this);
                        }),
                            e.each(e("[data-sidebar-content]").find(".flickityt4s-later"), function (e) {
                                this.flickityt4s = new T4SThemeSP.Carousel(this);
                            });
                    });
                }
            }),
            (T4SThemeSP.BackToTop = (function () {
                var t,
                    i,
                    o = e("[data-t4sBackToTop]"),
                    a = parseInt(o.data("scrolltop")),
                    s = o.find(".t4s-circle-css")[0];
                return function () {
                    (n.width() < 768 && o.data("hidden-mobile")) ||
                        0 == o.length ||
                        (window.addEventListener("scroll", () => {
                            t && clearTimeout(t),
                                (t = setTimeout(function () {
                                    window.scrollY > a ? o.addClass("is--show") : o.removeClass("is--show");
                                }, 40)),
                                s &&
                                    (i && clearTimeout(i),
                                    (i = setTimeout(function () {
                                        let e = window.scrollY / (document.body.offsetHeight - window.innerHeight),
                                            t = (Math.round(100 * e), 360 * e);
                                        s.style.setProperty("--cricle-degrees", t + "deg");
                                    }, 6)));
                        }),
                        o.on("click", function (t) {
                            t.preventDefault(), e("html, body").animate({ scrollTop: 0 }, isBehaviorSmooth ? 0 : 800);
                        }));
                };
            })()),
            (T4SThemeSP.Header = (function () {
                function t() {
                    IsDesignMode &&
                        (k.removeEventListener("preventHeaderReveal", s),
                        window.removeEventListener("scroll", r),
                        (k = document.querySelector(".t4s-section-header")),
                        (I = {}),
                        (D = 0),
                        (A = !1),
                        (R =
                            e(k)
                                .find("[" + E + "]")
                                .attr(E) || "{}"),
                        (R = JSON.parse(R)),
                        (O = R.isSticky),
                        (N = R.hideScroldown)),
                        O && N && !W
                            ? (k.addEventListener("preventHeaderReveal", s),
                              window.addEventListener("scroll", r, !1),
                              new IntersectionObserver((e, t) => {
                                  (I = e[0].intersectionRect), t.disconnect();
                              }).observe(k))
                            : k.classList.remove("shopify-section-header-hidden", "animate");
                }
                function s() {
                    A = !0;
                }
                function r() {
                    const e = window.pageYOffset || document.documentElement.scrollTop;
                    e > D && e > I.bottom
                        ? requestAnimationFrame(l)
                        : e < D && e > I.bottom
                        ? A
                            ? (window.clearTimeout(M),
                              (M = setTimeout(() => {
                                  A = !1;
                              }, 366)),
                              requestAnimationFrame(l))
                            : requestAnimationFrame(c)
                        : e <= I.top && requestAnimationFrame(d),
                        (D = e);
                }
                function l() {
                    k.dispatchEvent(new Event("T4sHeaderHide")),
                        B.one("transitionend webkitTransitionEnd oTransitionEnd", function () {
                            B.hasClass("shopify-section-header-hidden") && $.classList.remove(V);
                        }),
                        k.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
                }
                function c() {
                    k.dispatchEvent(new Event("T4sHeaderReveal")), $.classList.add(V), k.classList.add("shopify-section-header-sticky", "animate"), k.classList.remove("shopify-section-header-hidden");
                }
                function d() {
                    $.classList.remove(V),
                        X && 0 == I.top && 0 == I.height && ((I = k.getBoundingClientRect()), (X = !1)),
                        k.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate"),
                        $.classList.add(K),
                        clearTimeout(_),
                        (_ = setTimeout(() => {
                            $.classList.remove(K);
                        }, 366));
                }
                function u() {
                    !(function () {
                        if (!O || (O && N) || W) return;
                        let t = new IntersectionObserver(
                            function (e) {
                                0 === Math.round(e[0].intersectionRatio)
                                    ? ($.classList.add(V), X && ($.classList.add("t4s-hsticky__ready"), (X = !1)))
                                    : 1 === Math.round(e[0].intersectionRatio) &&
                                      ($.classList.remove(V),
                                      $.classList.add(K),
                                      clearTimeout(_),
                                      (_ = setTimeout(() => {
                                          $.classList.remove(K);
                                      }, 366)));
                            },
                            { threshold: [0, 1] }
                        );
                        e("#t4s-hsticky__sentinel").length > 0 && t.observe(document.querySelector("#t4s-hsticky__sentinel")),
                            setTimeout(() => {
                                $.classList.add("t4s-hsticky__ready"), (X = !1);
                            }, 396);
                    })(),
                        t(),
                        a.css({
                            "--topbar-height": (e("#t4s-top-bar-main").is(":visible") ? e("#t4s-top-bar-main").height() : 0) + "px",
                            "--header-height": (e(".t4s-section-header").is(":visible") ? e(".t4s-section-header").height() : 0) + "px",
                        }),
                        n.on("resize", function () {
                            a.css({
                                "--topbar-height": (e("#t4s-top-bar-main").is(":visible") ? e("#t4s-top-bar-main").height() : 0) + "px",
                                "--header-height": (e(".t4s-section-header").is(":visible") ? e(".t4s-section-header").height() : 0) + "px",
                            });
                        });
                }
                function p(t, n) {
                    var i = e(n);
                    t.each(function (t) {
                        var n,
                            o = e(this),
                            a = "#t4s-mega-contents" + o.data("id"),
                            s = i.find(a).html();
                        s
                            ? (o.html(s),
                              o.find(".t4s-products .t4s-product").length > 0 && T4SThemeSP.reinitProductGridItem(),
                              setTimeout(function () {
                                  o.hasClass("isotopet4s") && T4SThemeSP.Isotopet4s.init(o),
                                      S(o.closest(".has--children")),
                                      T4SThemeSP.PopupMFP(),
                                      0 != (n = o.find(".flickityt4s-later")).length &&
                                          n.each(function (e) {
                                              this.flickityt4s = new T4SThemeSP.Carousel(this);
                                          });
                              }, 600))
                            : o.html("");
                    }),
                        setTimeout(function () {
                            B.find(".isotopet4s-enabled").isotopet4s("layout");
                        }, 800);
                }
                function f(t) {
                    t.find(J)
                        .off("click")
                        .on("click", function (t) {
                            t.preventDefault();
                            var n = e(this);
                            n.hasClass("t4s--menu-toggle") && (n = n.closest("a")), n.hasClass(Z) ? n.removeClass(Z).siblings("ul").slideUp(Y) : n.addClass(Z).siblings("ul").slideDown(Y);
                        });
                }
                function h(t) {
                    if ((t && (U = t), !(o < 1024 || 0 == U.length) && T4SThemeSP.isHover)) {
                        U.each(function (t, n) {
                            var i = e(this);
                            i.hoverIntent({
                                sensitivity: 3,
                                interval: 35,
                                timeout: 150,
                                over: function (e) {
                                    i.addClass(L);
                                },
                                out: function () {
                                    i.removeClass(L);
                                },
                            });
                        });
                    }
                }
                function v(t) {
                    (C = t ? t.find(">a") : U.find(">a")),
                        T4SThemeSP.isHover || o < 1024 || 0 == C.length
                            ? C.off("click.menu click.menuIntent")
                            : C.on("click.menu", function (t) {
                                  t.preventDefault();
                                  let n = e(this).parent();
                                  n.hasClass(L)
                                      ? (n.removeClass(L), i.off("click.menuIntent"))
                                      : (n.addClass(L).siblings().removeClass(L),
                                        i.on("click.menuIntent", function (t) {
                                            var n = t.target;
                                            e(n).is("." + L) ||
                                                e(n)
                                                    .parents("li")
                                                    .is("." + L) ||
                                                (F.find("." + L).removeClass(L), i.off("click.menuIntent"));
                                        }));
                              });
                }
                function T(t, n) {
                    t && (U = t),
                        o < 1024 ||
                            0 == U.length ||
                            (IsDesignMode && (B = e(P)),
                            U.each(function (t, i) {
                                S(e(this), n);
                            }),
                            B.addClass(H));
                }
                function y() {
                    if (n.width() < 1024) return;
                    IsDesignMode && (B = e(P)),
                        B.removeAttr("style").css({ "--t4s-max-width": `${n.width() - 10}px`, "--t4s-max-height": `${n.height() - Math.max(0, k.getBoundingClientRect().top) - Math.max(0, k.offsetHeight) - 20}px` }),
                        B.find(".isotopet4s-enabled").isotopet4s("layout"),
                        setTimeout(function () {
                            B.find(".isotopet4s-enabled").isotopet4s("layout");
                        }, 500);
                    var t = e("#t4s-nav-categories");
                    if (0 == t.length) return;
                    let i = n.width() - Math.max(0, t[0].getBoundingClientRect().left) - t.width();
                    isThemeRTL && (i = n.width() - (n.width() - Math.max(0, t[0].getBoundingClientRect().left))),
                        t.removeAttr("style").css({ "--t4s-max-width": `${i}px`, "--t4s-max-height": `${n.height() - Math.max(0, t[0].getBoundingClientRect().top) - 10}px` }),
                        t.find(".isotopet4s-enabled").isotopet4s("layout"),
                        setTimeout(function () {
                            t.find(".isotopet4s-enabled").isotopet4s("layout");
                        }, 500);
                }
                function S(t, n = !1) {
                    var i = t.find(">a")[0],
                        a = t.find(">.t4s-sub-menu")[0],
                        s = t.data("placement") || "bottom";
                    if (
                        (!t.hasClass("menu-width__full") || "right-start" == s) &&
                        a &&
                        (e(a).attr("style", ""),
                        ("bottom" != s ||
                            t.hasClass("t4s-type__drop") ||
                            !(function (t) {
                                var n = e(t);
                                n.attr("style", "");
                                var i = n.outerWidth(),
                                    a = n.offset();
                                if (!i || !a) return !1;
                                var s = a.left,
                                    r = (o - i) / 2;
                                return !isThemeRTL && r <= s && s <= r + i && o >= r + i
                                    ? (n.addClass("is--center-screen"), !0)
                                    : isThemeRTL && r <= s + i && s <= r && o >= r + i
                                    ? (n.addClass("is--center-screen"), !0)
                                    : (n.removeClass("is--center-screen"), !1);
                            })(a)) &&
                            (FloatingUIT4sDOM.computePosition(i, a, { placement: s, middleware: [FloatingUIT4sDOM.flip({}), FloatingUIT4sDOM.shift({ padding: 5 })] }).then(({ x: e, y: t, placement: n, middlewareData: i }) => {
                                Object.assign(a.style, { left: `${e}px`, top: n.indexOf("bottom") > -1 ? "100%" : `${t}px` });
                            }),
                            !n))
                    ) {
                        let t = e(a).find(".t4s-lazy_menu.isotopet4s.isotopet4s-enabled");
                        t.length > 0 && t.isotopet4s("layout");
                    }
                }
                function w() {
                    if (0 != G.find("[data-wrapper-categories]").length)
                        if (IsDesignMode) IsDesignMode && ((G = e(j)), b((q = e(z)).html()));
                        else {
                            var t = g + "timeCatT4s",
                                n = g + "dataCatT4s",
                                i = isStorageSpSession ? sessionStorage.getItem(t) || 0 : 0;
                            if ((i = parseInt(i)) > 0 && i >= Date.now()) b(sessionStorage.getItem(n));
                            else {
                                var o = e(".t4s-is-header-categories"),
                                    a = o.length > 0 ? o.find("[data-section-id]").data("section-id") + "&q=" + o.find("[data-section-id]").data("section-id") : "header-categories";
                                T4SThemeSP.getToFetchSection(null, "text", m + "/?section_id=" + a).then((e) => {
                                    if ("NVT_94" != e) {
                                        var o = new DOMParser().parseFromString(e, "text/html").querySelector("div").innerHTML;
                                        b(o), isStorageSpSession && ((i = Date.now() + 18e5), sessionStorage.setItem(t, i), sessionStorage.setItem(n, o));
                                    }
                                });
                            }
                        }
                }
                function b(t, n) {
                    var i = void 0 === n ? G.find("[data-wrapper-categories]") : n;
                    i.html(t), y();
                    var o = i.find("#t4s-nav-categories>.has--children");
                    h(o),
                        v(o),
                        document.addEventListener("theme:hover", function (e) {
                            v(o);
                        }),
                        T(o),
                        setTimeout(() => {
                            T(o);
                        }, 1e3),
                        i.find(".t4s-type__drop .t4s-lazy_menu").each(function (t) {
                            f(e(this));
                        }),
                        i.find(".t4s-products .t4s-product").length > 0 && T4SThemeSP.reinitProductGridItem();
                    var a = i.find(".isotopet4s-later"),
                        s = i.find(".flickityt4s-later");
                    a.length > 0 &&
                        a.each(function (t) {
                            T4SThemeSP.Isotopet4s.init(e(this));
                        }),
                        a.length > 0 &&
                            s.each(function (e) {
                                this.flickityt4s = new T4SThemeSP.Carousel(this);
                            });
                }
                function x(t) {
                    !(function () {
                        var t = e(".t4s-type__mega .t4s-lazy_menu"),
                            n = e(".t4s-list-categories--item.is--active"),
                            i = n.index(),
                            a = i > 0 ? i : "",
                            s = g + "timeMegaT4s" + a,
                            r = g + "dataMegaT4s" + a,
                            l = isStorageSpSession ? sessionStorage.getItem(s) || 0 : 0,
                            l = parseInt(l),
                            c = 18e5;
                        if (!(0 == t.length || o < 1024))
                            if (!IsDesignMode && l > 0 && l >= Date.now()) p(t, sessionStorage.getItem(r));
                            else {
                                var d = e(".t4s-section-mega__menu"),
                                    u = d.length > 0 ? d.find("[data-section-id]").data("section-id") : "mega-menu,mega-menu2",
                                    m = n.find(">a").attr("href");
                                i > 0 && 0 == d.length && location.pathname != m
                                    ? T4SThemeSP.getToFetchSection(null, "text", m).then((t) => {
                                          if ("NVT_94" == t) return;
                                          const n = e(t).find(".t4s-section-mega__menu [data-section-id]").data("section-id");
                                          n && f();
                                      })
                                    : f();
                                function f(e) {
                                    T4SThemeSP.getToFetchSection("?sections=" + u, "json").then((e) => {
                                        if ("NVT_94" == e || e.status) e.status && console.error(e.description);
                                        else {
                                            var n = "";
                                            for (const t in e) n += e[t].split("[nt_mega_split1]")[1];
                                            p(t, "<div>" + n + "</div>"), isStorageSpSession && ((l = Date.now() + c), sessionStorage.setItem(s, l), sessionStorage.setItem(r, "<div>" + n + "</div>"));
                                        }
                                    });
                                }
                            }
                    })(),
                        (function () {
                            var t = e(".t4s-type__drop .t4s-lazy_menu"),
                                n = e(".t4s-list-categories--item.is--active").index(),
                                i = n > 0 ? n : "",
                                a = g + "timeDropT4s" + i,
                                s = g + "dataDropT4s" + i,
                                r = isStorageSpSession ? sessionStorage.getItem(a) || 0 : 0,
                                r = parseInt(r);
                            if (
                                (IsDesignMode &&
                                    t.each(function (t) {
                                        S(e(this).closest(".has--children")), f(e(this));
                                    }),
                                !(0 == t.length || o < 1024 || IsDesignMode))
                            )
                                if (r > 0 && r >= Date.now()) {
                                    var l = sessionStorage.getItem(s).split("[nt_drop_split2]");
                                    t.each(function (t) {
                                        e(this).html(l[t]), S(e(this).closest(".has--children")), f(e(this));
                                    });
                                } else {
                                    var c = [];
                                    t.each(function (t) {
                                        c.push(e(this).data("handle"));
                                    }),
                                        (c = c.join(" ")),
                                        T4SThemeSP.getToFetchSection(null, "text", `${window.T4Sroutes.search_url}?type=article&q=${c}&section_id=dropdown-menu`).then((n) => {
                                            if ("NVT_94" != n) {
                                                var i = n.split("[nt_drop_split1]")[1],
                                                    o = i.split("[nt_drop_split2]");
                                                t.each(function (t) {
                                                    e(this).html(o[t]), S(e(this).closest(".has--children")), f(e(this));
                                                }),
                                                    isStorageSpSession && ((r = Date.now() + 18e5), sessionStorage.setItem(a, r), sessionStorage.setItem(s, "<div>" + i + "</div>"));
                                            }
                                        });
                                }
                        })(),
                        h(t),
                        v(t),
                        document.addEventListener("theme:hover", function (e) {
                            v(t);
                        }),
                        y(),
                        T(t, !0),
                        w(),
                        setTimeout(function () {
                            n.on("resize.menu", y);
                        }, 2e3);
                }
                var C,
                    _,
                    P = ".t4s-section-header",
                    k = document.querySelector(P),
                    I = {},
                    D = 0,
                    A = !1,
                    M = 0,
                    E = "data-header-options",
                    R =
                        e(k)
                            .find("[" + E + "]")
                            .attr(E) || "{}",
                    O = (R = JSON.parse(R)).isSticky,
                    N = R.hideScroldown,
                    $ = document.documentElement,
                    L = "is-action__hover",
                    F = e("[data-menu-nav]"),
                    U = F.find(">li.has--children"),
                    B = (U.find(">.t4s-sub-menu"), e(k)),
                    H = (e(".t4s-website-wrapper"), "calc-pos-submenu"),
                    W = B.hasClass("header-vertical"),
                    j = ".t4s-is-header-categories-menu",
                    z = ".t4s-is-header-categories",
                    G = e(j),
                    q = e(z),
                    Z = "is--child-open",
                    K = "no-transiton-nav-a",
                    V = "is-header--stuck",
                    Y = 200,
                    X = !0,
                    J = T4Sconfigs.onlyClickDropIcon ? ".t4s-menu-item.has--children>a>.t4s--menu-toggle" : ".t4s-menu-item.has--children>a";
                return { stickyInit: u, init: x, updateCat: b };
            })()),
            (T4SThemeSP.MobileNav = (function () {
                function t(e) {
                    e.hasClass(c.opend) ? e.removeClass(c.opend).children("ul").slideUp(200) : e.addClass(c.opend).children("ul").slideDown(200);
                }
                function i(e = 4) {
                    IsDesignMode ||
                        v ||
                        (0 == C.$mobileNav.is(":visible") && o > 1024) ||
                        setTimeout(function () {
                            if (p > 0) {
                                (r = 1 == w ? r : "mb_nav"), (l = 1 == b ? l : "mb_cat");
                                var e = !1,
                                    t = !1;
                                T4SThemeSP.getToFetchSection("?section_id=" + r, "text").then((n) => {
                                    "NVT_94" != n && (C.$mobileNav.find("#shopify-mb_nav").html(n), t ? a("indexPage") : (e = !0));
                                }),
                                    T4SThemeSP.getToFetchSection("?section_id=" + l, "text").then((n) => {
                                        "NVT_94" != n && (C.$mobileNav.find("#shopify-mb_cat").html(n), e ? a("indexPage") : (t = !0));
                                    });
                            } else
                                T4SThemeSP.getToFetchSection(null, "text", T4Sroutes.search_url + "/?view=mn").then((e) => {
                                    "NVT_94" != e && a(e);
                                });
                        }, e);
                }
                function a(e) {
                    T4SThemeSP.Helpers.promiseStylesheet(T4Sconfigs.stylesheet2).then(function () {
                        (v = !0),
                            p <= 0 && "indexPage" != e && C.$mobileNav.html(e),
                            p > 0 && "indexPage" == e && (e = C.$mobileNav.html()),
                            n.off(d),
                            C.$mobileNav.off(u),
                            C.$mobileNav.trigger("lazyincluded"),
                            isStorageSpSession && ((x = Date.now() + T), sessionStorage.setItem(f, x), sessionStorage.setItem(h, e));
                    });
                }
                function s() {
                    (C = { $mobileNav: e("#t4s-menu-drawer") }),
                        isStorageSpSession && x > 0 && x >= Date.now()
                            ? T4SThemeSP.Helpers.promiseStylesheet(T4Sconfigs.stylesheet2).then(function () {
                                  C.$mobileNav.html(sessionStorage.getItem(h)), C.$mobileNav.trigger("lazyincluded");
                              })
                            : (n.on(
                                  d,
                                  T4SThemeSP.debounce(300, function () {
                                      (o = n.width()), i(0);
                                  })
                              ),
                              i(500),
                              IsDesignMode ||
                                  C.$mobileNav.on(u, function () {
                                      i(0);
                                  })),
                        C.$mobileNav.on("click", "[data-tab-mb-nav]>[data-tab-mb-item]", function () {
                            var t = e(this);
                            t.hasClass(c.tabNavActive) ||
                                (t.addClass(c.tabNavActive).siblings().removeClass(c.tabNavActive), e("[data-tab-mb-content]." + c.tabNavActive).removeClass(c.tabNavActive), e(t.data("id")).addClass(c.tabNavActive));
                        }),
                        C.$mobileNav.on("click", ".t4s-menu-item-has-children.t4s-only_icon_false>a", function (n) {
                            n.preventDefault(), n.stopPropagation(), t(e(this).parent());
                        });
                    // C.$mobileNav.on("click",".t4s-menu-item-has-children > a > .t4s-mb-nav__icon",function(n){n.preventDefault(),n.stopPropagation(),t(e(this).parent().parent())})
                    C.$mobileNav.on("click", ".t4s-menu-item-has-children .t4s-mb-nav__icon", function (n) {
                        n.preventDefault();
                        n.stopPropagation();
                        var $parentMenuItem = $(this).parent().parent();
                        if (!$parentMenuItem.hasClass("is--opend")) {
                            $(".t4s-menu-item-has-children.is--opend").removeClass("is--opend").find(".t4s-sub-menu").slideUp();
                            $parentMenuItem.addClass("is--opend").find(".t4s-sub-menu").slideDown();
                        } else {
                            $parentMenuItem.removeClass("is--opend").find(".t4s-sub-menu").slideUp();
                        }
                    });
                }
                var r,
                    l,
                    c = { tabNavActive: "is--active", opend: "is--opend" },
                    d = "resize.navmb",
                    u = "opendDrawer",
                    p = e(".t4s-list-categories--item.is--active").index(),
                    m = p > 0 ? p : "",
                    f = g + "timeMenuT4s" + m,
                    h = g + "dataMenuT4s" + m,
                    v = !1,
                    T = 18e5,
                    y = e(".t4s-sp-section-mb-nav [data-section-id]"),
                    S = e(".t4s-sp-section-mb-cat [data-section-id]"),
                    w = y.length,
                    b = S.length;
                p > 0 && ((r = y.data("section-id")), (l = S.data("section-id")));
                var x = isStorageSpSession ? sessionStorage.getItem(f) || 0 : 0,
                    x = parseInt(x),
                    C = {};
                return s;
            })()),
            (T4SThemeSP.loadingBar = (function () {
                return function () {
                    console.log("loadingBar");
                };
            })()),
            (T4SThemeSP.currencyForm = (function () {
                function t(t) {
                    r != t && (isStorageSpdLocalAll && localStorage.setItem("T4Currency", t), e(`[data-currency-wrap] [data-iso="${t}"]`).first().trigger("click"));
                }
                function n() {
                    var t, n, i, r, l, c, d, u, p, m, f;
                    s.on("click", "[data-locale-wrap] [data-locale-item] ,[data-currency-wrap] [data-currency-item]", function (s) {
                        if ((s.preventDefault(), (t = e(this)), !(("2" == T4Sconfigs.currency_type && t.is("[data-currency-item]")) || t.hasClass(o.select)))) {
                            if (
                                (t.is("[data-locale-item]")
                                    ? ((n = "[data-locale-wrap]"), (i = "[data-locale-wrap] [data-locale-item]"), (r = "$localeSelector"), (f = !1))
                                    : ((n = "[data-currency-wrap]"), (i = "[data-currency-wrap] [data-currency-item]"), (r = "$currencySelector"), (f = !0)),
                                (l = t.attr("data-iso")),
                                (c = e(n + " ." + o.select)
                                    .first()
                                    .attr("data-iso")),
                                (d = t.attr("data-language")),
                                (u = e(n + " ." + o.select)
                                    .first()
                                    .attr("data-language")),
                                (p = t.attr("data-country")),
                                (m = e(n + " ." + o.select)
                                    .first()
                                    .attr("data-country")),
                                e(n + " [data-current]")
                                    .text(d || l)
                                    .removeClass("flagst4s-" + c)
                                    .addClass("flagst4s-" + l),
                                e(n + " [data-img-current]").length > 0)
                            ) {
                                var h = e(n + " [data-img-current]").attr("src");
                                e(n + " [data-img-current]").attr("src", h.replace(/\/\w\w.svg/g, "/" + p.toLowerCase() + ".svg"));
                            }
                            e(n + " [data-iso=" + l + "]")
                                .addClass(o.select)
                                .siblings()
                                .removeClass(o.select),
                                (function (e, t, n) {
                                    a[e].val(t), "$currencySelector" === e && a.$countryMirror.val(n), a.$formCurrencyLocale.submit();
                                })(r, l, p),
                                isStorageSpdLocal && f && localStorage.setItem("T4Currency", l),
                                T4SThemeSP.loadingBar();
                        }
                    });
                }
                function i() {
                    0 != (a = { $formCurrencyLocale: e("#CurrencyLangSelector"), $countryMirror: e("#countryMirror"), $localeSelector: e("#LocaleSelector"), $currencySelector: e("#CurrencySelector") }).$formCurrencyLocale.length &&
                        (n(),
                        (function () {
                            var n = isStorageSpdLocalAll ? localStorage.getItem("T4Currency") : null;
                            if (T4Sconfigs.auto_currency && !navigator.userAgent.match(/bot|spider/i) && !n && !IsDesignMode) {
                                var i,
                                    o = isStorageSpdLocalAll ? localStorage.getItem("nt_currency") : null,
                                    a = {
                                        AF: "AFN",
                                        AX: "EUR",
                                        AL: "ALL",
                                        DZ: "DZD",
                                        AS: "USD",
                                        AD: "EUR",
                                        AO: "AOA",
                                        AI: "XCD",
                                        AQ: "",
                                        AG: "XCD",
                                        AR: "ARS",
                                        AM: "AMD",
                                        AW: "AWG",
                                        AU: "AUD",
                                        AT: "EUR",
                                        AZ: "AZN",
                                        BS: "BSD",
                                        BH: "BHD",
                                        BD: "BDT",
                                        BB: "BBD",
                                        BY: "BYN",
                                        T4: "EUR",
                                        BZ: "BZD",
                                        BJ: "XOF",
                                        BM: "BMD",
                                        BT: "BTN",
                                        BO: "BOB",
                                        BA: "BAM",
                                        BW: "BWP",
                                        BV: "NOK",
                                        BR: "BRL",
                                        IO: "USD",
                                        BN: "BND",
                                        BG: "BGN",
                                        BF: "XOF",
                                        BI: "BIF",
                                        KH: "KHR",
                                        CM: "XAF",
                                        CA: "CAD",
                                        CV: "CVE",
                                        KY: "KYD",
                                        CF: "XAF",
                                        TD: "XAF",
                                        CL: "CLP",
                                        CN: "CNY",
                                        CX: "AUD",
                                        CC: "AUD",
                                        CO: "COP",
                                        KM: "KMF",
                                        CG: "XAF",
                                        CD: "CDF",
                                        CK: "NZD",
                                        CR: "CRC",
                                        CI: "XOF",
                                        HR: "HRK",
                                        CU: "CUP",
                                        CY: "EUR",
                                        CZ: "CZK",
                                        DK: "DKK",
                                        DJ: "DJF",
                                        DM: "XCD",
                                        DO: "DOP",
                                        EC: "USD",
                                        EG: "EGP",
                                        SV: "USD",
                                        GQ: "XAF",
                                        ER: "ERN",
                                        EE: "EUR",
                                        ET: "ETB",
                                        FK: "FKP",
                                        FO: "DKK",
                                        FJ: "FJD",
                                        FI: "EUR",
                                        FR: "EUR",
                                        GF: "EUR",
                                        PF: "XPF",
                                        TF: "EUR",
                                        GA: "XAF",
                                        GM: "GMD",
                                        GE: "GEL",
                                        DE: "EUR",
                                        GH: "GHS",
                                        GI: "GIP",
                                        GR: "EUR",
                                        GL: "DKK",
                                        GD: "XCD",
                                        GP: "EUR",
                                        GU: "USD",
                                        GT: "GTQ",
                                        GG: "GBP",
                                        GN: "GNF",
                                        GW: "XOF",
                                        GY: "GYD",
                                        HT: "HTG",
                                        HM: "AUD",
                                        VA: "EUR",
                                        HN: "HNL",
                                        HK: "HKD",
                                        HU: "HUF",
                                        IS: "ISK",
                                        IN: "INR",
                                        ID: "IDR",
                                        IR: "IRR",
                                        IQ: "IQD",
                                        IE: "EUR",
                                        IM: "GBP",
                                        IL: "ILS",
                                        IT: "EUR",
                                        JM: "JMD",
                                        JP: "JPY",
                                        JE: "GBP",
                                        JO: "JOD",
                                        KZ: "KZT",
                                        KE: "KES",
                                        KI: "AUD",
                                        KR: "KRW",
                                        KW: "KWD",
                                        KG: "KGS",
                                        LA: "LAK",
                                        LV: "EUR",
                                        LB: "LBP",
                                        LS: "LSL",
                                        LR: "LRD",
                                        LY: "LYD",
                                        LI: "CHF",
                                        LT: "EUR",
                                        LU: "EUR",
                                        MO: "MOP",
                                        MK: "MKD",
                                        MG: "MGA",
                                        MW: "MWK",
                                        MY: "MYR",
                                        MV: "MVR",
                                        ML: "XOF",
                                        MT: "EUR",
                                        MH: "USD",
                                        MQ: "EUR",
                                        MR: "MRU",
                                        MU: "MUR",
                                        YT: "EUR",
                                        MX: "MXN",
                                        FM: "USD",
                                        MD: "MDL",
                                        MC: "EUR",
                                        MN: "MNT",
                                        ME: "EUR",
                                        MS: "XCD",
                                        MA: "MAD",
                                        MZ: "MZN",
                                        MM: "MMK",
                                        NA: "NAD",
                                        NR: "AUD",
                                        NP: "NPR",
                                        NL: "EUR",
                                        AN: "",
                                        NC: "XPF",
                                        NZ: "NZD",
                                        NI: "NIO",
                                        NE: "XOF",
                                        NG: "NGN",
                                        NU: "NZD",
                                        NF: "AUD",
                                        MP: "USD",
                                        NO: "NOK",
                                        OM: "OMR",
                                        PK: "PKR",
                                        PW: "USD",
                                        PS: "ILS",
                                        PA: "PAB",
                                        PG: "PGK",
                                        PY: "PYG",
                                        PE: "PEN",
                                        PH: "PHP",
                                        PN: "NZD",
                                        PL: "PLN",
                                        PT: "EUR",
                                        PR: "USD",
                                        QA: "QAR",
                                        RE: "EUR",
                                        RO: "RON",
                                        RU: "RUB",
                                        RW: "RWF",
                                        BL: "EUR",
                                        SH: "SHP",
                                        KN: "XCD",
                                        LC: "XCD",
                                        MF: "EUR",
                                        PM: "EUR",
                                        VC: "XCD",
                                        WS: "WST",
                                        SM: "EUR",
                                        ST: "STN",
                                        SA: "SAR",
                                        SN: "XOF",
                                        RS: "RSD",
                                        SC: "SCR",
                                        SL: "SLL",
                                        SG: "SGD",
                                        SK: "EUR",
                                        SI: "EUR",
                                        SB: "SBD",
                                        SO: "SOS",
                                        ZA: "ZAR",
                                        GS: "GBP",
                                        ES: "EUR",
                                        LK: "LKR",
                                        SD: "SDG",
                                        SR: "SRD",
                                        SJ: "NOK",
                                        SZ: "SZL",
                                        SE: "SEK",
                                        CH: "CHF",
                                        SY: "SYP",
                                        TW: "TWD",
                                        TJ: "TJS",
                                        TZ: "TZS",
                                        TH: "THB",
                                        TL: "USD",
                                        TG: "XOF",
                                        TK: "NZD",
                                        TO: "TOP",
                                        TT: "TTD",
                                        TN: "TND",
                                        TR: "TRY",
                                        TM: "TMT",
                                        TC: "USD",
                                        TV: "AUD",
                                        UG: "UGX",
                                        UA: "UAH",
                                        AE: "AED",
                                        GB: "GBP",
                                        US: "USD",
                                        UM: "USD",
                                        UY: "UYU",
                                        UZ: "UZS",
                                        VU: "VUV",
                                        VE: "VEF",
                                        VN: "VND",
                                        VG: "USD",
                                        VI: "USD",
                                        WF: "XPF",
                                        EH: "MAD",
                                        YE: "YER",
                                        ZM: "ZMW",
                                        ZW: "ZWD",
                                    };
                                if (o) {
                                    let e = JSON.parse(o);
                                    try {
                                        i = n || e.currency.handle;
                                    } catch (t) {
                                        i = a[e.countryCode] || a[e.country] || e.currency;
                                    }
                                    t(i);
                                } else {
                                    var s = {
                                            type: "get",
                                            url: "https://extreme-ip-lookup.com/json/?key=demo2",
                                            dataType: "json",
                                            success: function (n) {
                                                "success" == n.status ? (t(a[n.countryCode]), isStorageSpdLocal && localStorage.setItem("nt_currency", JSON.stringify(n))) : e.ajax(r);
                                            },
                                            error: function (t, n) {
                                                e.ajax(r);
                                            },
                                        },
                                        r = {
                                            type: "get",
                                            url: "https://ipinfo.io/json",
                                            dataType: "json",
                                            success: function (e) {
                                                t(a[e.country]), isStorageSpdLocal && localStorage.setItem("nt_currency", JSON.stringify(e));
                                            },
                                            error: function (t, n) {
                                                e.ajax(l);
                                            },
                                        },
                                        l = {
                                            type: "get",
                                            url: "https://d1hcrjcdtouu7e.cloudfront.net/users/countryDetection",
                                            dataType: "json",
                                            success: function (e) {
                                                t(a[e.country]), isStorageSpdLocal && localStorage.setItem("nt_currency", JSON.stringify(e));
                                            },
                                        };
                                    e.ajax({
                                        type: "get",
                                        url: "/browsing_context_suggestions.json?source=geolocation_recommendation&currency[enabled]=true&language[enabled]=true",
                                        dataType: "json",
                                        success: function (n) {
                                            try {
                                                var i = n.suggestions[0].parts;
                                                t(i.currency.handle), isStorageSpdLocal && localStorage.setItem("nt_currency", JSON.stringify(i));
                                            } catch (t) {
                                                e.ajax(s);
                                            }
                                        },
                                        error: function (t, n) {
                                            e.ajax(s);
                                        },
                                    });
                                }
                            }
                        })());
                }
                var o = { select: "is--selected", opend: "is--opend" },
                    a = {},
                    r = T4Sconfigs.cartCurrency;
                return i;
            })()),
            (T4SThemeSP.productRecommendations = (function () {
                function t(t) {
                    t[0]
                        ? t.hide()
                        : i.$recommendationsWrap.hasClass("t4s-pr-single_tab-content")
                        ? (i.$recommendationsWrap.find(".t4s-loading--bg").hide(), i.$recommendationsWrap.find("[data-emty-product]").show())
                        : ((T4SThemeSP.isRelatedEmty = !0), T4SThemeSP.isRencentEmty ? e(".t4s-tp-rencent-related").hide() : i.$recommendationsWrap.hide());
                }
                function n(n) {
                    (i = { $recommendationsWrap: e("#pr_recommendations:not(.is--not-rub-js)") }),
                        0 != (n = n || i.$recommendationsWrap).length &&
                            (function (n) {
                                var i = n.data("type"),
                                    o = n.data("sid"),
                                    a = n.data("baseurl"),
                                    s = n.closest(".id_product-recommendations"),
                                    r = m + a + "&section_id=" + o;
                                "3" == i && (r = a + "?section_id=" + o + "&product_id=" + n.data("id") + "&limit=" + n.data("limit")),
                                    T4SThemeSP.getToFetchSection(null, "text", r).then((i) => {
                                        if ("NVT_94" != i) {
                                            var o = IsDesignMode ? e(e(i)[2]).html() : e(i).html();
                                            try {
                                                o.trim();
                                            } catch (t) {
                                                o = e(i).html();
                                            }
                                            if ("" !== o.trim()) {
                                                if ((n.html(o), n.find(".t4s-product").length > 0 && T4SThemeSP.reinitProductGridItem(), T4SThemeSP.Reveal(), n.find(".flickityt4s").length > 0)) {
                                                    var a = n.find(".flickityt4s")[0];
                                                    (a.flickityt4s = new T4SThemeSP.Carousel(a)), T4SThemeSP.ProductItem.resizeObserver();
                                                }
                                            } else t(s);
                                        } else t(s);
                                    });
                            })(n);
                }
                var i = {};
                return n;
            })()),
            (T4SThemeSP.recentlyViewed = (function () {
                function t(t) {
                    var i = localStorage.getItem("nt_recent"),
                        o = "product" == p ? t.data("id") : "19041994",
                        a = t.data("sid"),
                        s = t.data("unpr"),
                        r = t.data("limit"),
                        l = t.closest(".id_recently_viewed");
                    if (null != i) {
                        var c = (f = i.split(",")).indexOf(o);
                        if ((c > -1 ? (f = f.splice(0, r + 1)).splice(c, 1) : (f = f.splice(0, r)), 0 == f.length)) return n(l, !1), !1;
                        var d = f.toString().replace(/,/g, " OR "),
                            u = encodeURI(d);
                        T4SThemeSP.getToFetchSection(null, "text", m + "/?section_id=" + a + "&type=product&options[unavailable_products]=" + s + "&q=" + u).then((i) => {
                            if ("NVT_94" != i) {
                                var o = IsDesignMode ? e(e(i)[2]).html() : e(i).html();
                                try {
                                    o.trim();
                                } catch (t) {
                                    o = e(i).html();
                                }
                                if ("" !== o.trim()) {
                                    if ((t.html(o), t.find(".t4s-product").length > 0 && T4SThemeSP.reinitProductGridItem(), T4SThemeSP.Reveal(), t.find(".flickityt4s").length > 0)) {
                                        var a = t.find(".flickityt4s")[0];
                                        (a.flickityt4s = new T4SThemeSP.Carousel(a)), T4SThemeSP.ProductItem.resizeObserver();
                                    }
                                } else n(l);
                            } else n(l);
                        });
                    } else {
                        n(l);
                        var f = new Array();
                    }
                    f.indexOf(o) < 0 && "19041994" != o && (f.length > r && (f = f.splice(0, r)), f.unshift(o), localStorage.setItem("nt_recent", f.toString()));
                }
                function n(t, n = !0) {
                    t[0]
                        ? n
                            ? t.hide()
                            : t.slideUp()
                        : o.$recentlyWrap.hasClass("t4s-pr-single_tab-content")
                        ? (o.$recentlyWrap.find(".t4s-loading--bg").hide(), o.$recentlyWrap.find("[data-emty-product]").show())
                        : ((T4SThemeSP.isRencentEmty = !0), T4SThemeSP.isRelatedEmty ? e(".t4s-tp-rencent-related").hide() : o.$recentlyWrap.hide());
                }
                function i(n) {
                    (o = { $recentlyWrap: e("#recently_wrap") }), (n = n || o.$recentlyWrap), isStorageSpdLocalAll && 0 != n.length && t(n);
                }
                var o = {};
                return i;
            })()),
            (T4SThemeSP.Cart = (function () {
                function n() {
                    e("[data-cart-count]").html(e("#t4s-mini_cart").data("ccount")),
                        T4SThemeSP.Tooltip(),
                        s.trigger("currency:update"),
                        E ||
                            (T4SThemeSP.ProductAjax.change(),
                            T4SThemeSP.agreeForm(),
                            (function () {
                                if ("cart" == p) return;
                                var t = e("[data-cart-wrapper]"),
                                    n = ".t4s-mini_cart-tool__content";
                                e("[data-cart-tools]").on("click", "[data-cart-tool_action]", function (i) {
                                    i.preventDefault(), i.stopPropagation();
                                    var o = e(this).data("id"),
                                        a = e(n + ".is--" + o),
                                        r = a.find("[data-cart-tool_close]");
                                    a.addClass("is--opend"),
                                        t.addClass("is--contentUpdate"),
                                        a.removeAttr("style"),
                                        T4SThemeSP.isTouch ||
                                            a.one("transitionend webkitTransitionEnd oTransitionEnd", function () {
                                                a.find("[data-opend-focus]").focus();
                                            }),
                                        t.on("click.tool", function (i) {
                                            i.preventDefault(),
                                                e(i.target).is(n) || e(i.target).closest(n).length > 0 || (e(n + ".is--" + o).removeClass("is--opend"), t.removeClass("is--contentUpdate"), t.off("click.tool"), r.off("click"));
                                        }),
                                        r.on("click", function (e) {
                                            e.preventDefault(), a.removeClass("is--opend"), t.removeClass("is--contentUpdate"), t.off("click.tool"), r.off("click");
                                        }),
                                        s.off("keyup.drawer").on("keyup.toolCart", function (i) {
                                            27 === i.keyCode &&
                                                (e(n + ".is--" + o).removeClass("is--opend"),
                                                t.removeClass("is--contentUpdate"),
                                                t.off("click.tool"),
                                                r.off("click"),
                                                s.off("keyup.toolCart").on("keyup.drawer", function (e) {
                                                    27 === e.keyCode && T4SThemeSP.Drawer.close(e);
                                                }));
                                        });
                                });
                            })(),
                            u(),
                            g(),
                            f(),
                            v(),
                            (function () {
                                let t = e("[data-tab-cart-wrap]");
                                if (((T4SThemeSP.cartTabActive = !0), !t[0])) return;
                                let n = e("[data-cart-tab-title]"),
                                    i = e("[data-cart-tab-content]");
                                t.on("click", "[data-tab-cart-item]", function (t) {
                                    t.preventDefault();
                                    let o = e(this);
                                    (T4SThemeSP.cartTabActive = o.is("[data-is-tab-cart]")),
                                        n.text(o.data("title")),
                                        o
                                            .addClass(N.active)
                                            .siblings("." + N.active)
                                            .removeClass(N.active),
                                        i.attr("aria-hidden", !0).eq(o.index()).attr("aria-hidden", !1);
                                });
                            })(),
                            T(),
                            y(),
                            (function () {
                                if (0 == e("#t4s-tab-visited").length || !isStorageSpdLocalAll) return;
                                let t = localStorage.getItem("nt_recent");
                                if (null == t) return;
                                let n = t.split(",").toString().replace(/,/g, " OR "),
                                    i = encodeURI(n),
                                    o = e(".t4s-tab-visited-empty"),
                                    a = e(".t4s-tab-visited-skeleton");
                                o.hide(),
                                    a.show(),
                                    T4SThemeSP.getToFetchSection(null, "text", m + "/?section_id=mini_cart_visited&type=product&options[unavailable_products]=show&q=" + i).then((t) => {
                                        a.hide(), "NVT_94" != t && (a.after(e(t).html()), s.trigger("currency:update"), T4SThemeSP.Wishlist.updateAll(), T4SThemeSP.Tooltip());
                                    });
                            })(),
                            i.on("update:mini_cart:wishlist", S),
                            i.trigger("update:mini_cart:wishlist"));
                }
                function o(e = !1) {
                    T4SThemeSP.getToFetchSection("?sections=" + L, "json").then((t) => {
                        "NVT_94" != t && r(t, e);
                    });
                }
                function r(t, n = !1) {
                    var o = t.cart_data,
                        r = t.mini_cart || t[$],
                        d = e(r),
                        u = e(b),
                        m = e(x),
                        f = e(C),
                        h = f.find(_),
                        g = f.find(P),
                        v = e(k);
                    if (((o = o.split("[t4s_split1]")[1]), (0 != (o = o.split("[t4s_split2]"))[0] && !T4SThemeSP.isATCSuccess) || "cart" != p)) {
                        !T4SThemeSP.isATCSuccess && n && (T4SThemeSP.isATCSuccess = n),
                            u.html(d.find(b).html()),
                            m.html(d.find(x).html()),
                            f.attr(D, d.find(C).attr(D)),
                            h.replaceWith(d.find(_).wrap()),
                            g.attr("style", d.find(P).attr("style")),
                            v.html(d.find(k).html());
                        var S = parseFloat(o[0]);
                        e("[data-cart-count]").html(S),
                            e("[data-cart-ttcount]").html(S < 2 ? l.item_cart[S] : l.item_cart[2]),
                            e("[data-cart-tt-price]").html(o[1]),
                            "1" == o[2] ? (e(".t4s-mini_cart-tool__content.is--gift.is--opend [data-cart-tool_close]").trigger("click"), e("[data-toogle-gift]").hide()) : e("[data-toogle-gift]").show(),
                            0 == o[0] ? a.addClass("t4s-cart-count-0") : (a.removeClass("t4s-cart-count-0"), U && (y(), (U = !1))),
                            document.dispatchEvent(new CustomEvent("cart:update:count", { detail: { count: o[0] }, bubbles: !0, cancelable: !0 })),
                            T4SThemeSP.Tooltip(),
                            s.trigger("currency:update"),
                            "0" != R && T4SThemeSP.isATCSuccess && c(),
                            i.trigger("cart:updated"),
                            T();
                    } else c();
                }
                function c() {
                    (T4SThemeSP.isATCSuccess = !1),
                        "1" == R ||
                            "2" == R ||
                            ("3" == R ? (T4SThemeSP.cartTabActive || e("[data-is-tab-cart]").trigger("click"), T4SThemeSP.Drawer.opend(e("#t4s-mini_cart"))) : (document.location.href = "5" == R ? T4SThemeSP.root_url + "checkout" : H));
                }
                function d(t) {
                    var n = new Headers({ "Content-Type": "application/json" }),
                        i = (function (t) {
                            return "string" != typeof t && "undefined" == (t += "") && (t = ""), e.trim(t);
                        })(t),
                        o = { method: "POST", headers: n, body: JSON.stringify({ note: i }) };
                    fetch(H + "/update.js", o)
                        .then(function (e) {
                            return e.json();
                        })
                        .then(function (t) {
                            i.length > 0
                                ? (e('[data-id="note"].is--editNote, .t4s-txt_edit_note').removeClass(N.none), e('[data-id="note"].is--addNote, .t4s-txt_add_note').addClass(N.none))
                                : (e('[data-id="note"].is--editNote, .t4s-txt_edit_note').addClass(N.none), e('[data-id="note"].is--addNote, .t4s-txt_add_note').removeClass(N.none));
                        })
                        .catch(function (e) {
                            console.log("cart update error: ", e);
                        });
                }
                function u() {
                    e('textarea[name="note"]').on("change", function () {
                        d(e(this).val());
                    });
                }
                function f() {
                    if (isStorageSpdLocal) {
                        var t = e("#CartDiscountcode"),
                            n = e("#CartDiscountcode, [data-cart-discount]"),
                            i = localStorage.getItem("CartDiscountcode");
                        n.val(i).trigger("keyup"),
                            e('[data-action="save-discountcode"]').click(function (i) {
                                var o = e.trim(t.val());
                                localStorage.setItem("CartDiscountcode", o), n.val(o).trigger("keyup"), "" != o && window.fetch(window.Shopify.routes.root + "discount/" + o);
                            });
                    }
                }
                function g() {
                    let t,
                        n = e("#CartDiscountcode");
                    n[0] &&
                        n.keyup(function () {
                            clearTimeout(t),
                                (t = setTimeout(function () {
                                    n.val().length ? n.attr("name", "discount") : n.removeAttr("name");
                                }, 300));
                        });
                }
                function v() {
                    var t = e("[data-estimate-shipping-wrap]");
                    t[0] &&
                        ((t[0].langRates = JSON.parse(t.find("template[data-lang-rates]").html() || "{}")),
                        (function (e) {
                            Shopify && new Shopify.CountryProvinceSelector(`ShippingCountry_${e}`, `ShippingProvince_${e}`, { hideElement: `ShippingProvinceContainer_${e}` });
                        })(t.data("id")),
                        t.on(
                            "click",
                            '[data-action="estimate-shipping"]',
                            function (t) {
                                t.preventDefault(), t.stopPropagation();
                                var n = this,
                                    i = e(n),
                                    o = i.find("[data-response-rates]"),
                                    a = {},
                                    r = e(t.currentTarget);
                                r.addClass(N.loading),
                                    document.dispatchEvent(new CustomEvent("theme:loading:start")),
                                    (a.country = i.find('[name="country"]').val() || ""),
                                    (a.province = i.find('[name="province"]').val() || ""),
                                    (a.zip = i.find('[name="zip"]').val() || ""),
                                    fetch(H + "/shipping_rates.json?" + e.param({ shipping_address: a }), { credentials: "same-origin", method: "GET" }).then(function (t) {
                                        document.dispatchEvent(new CustomEvent("theme:loading:end")),
                                            r.removeClass(N.loading),
                                            t.json().then(function (i) {
                                                !(function (t, n, i, o, a) {
                                                    t
                                                        ? (function (t, n, i, o) {
                                                              var a = "",
                                                                  r = "",
                                                                  l = "";
                                                              n.zip && (a += n.zip + ", ");
                                                              n.province && (a += n.province + ", ");
                                                              if (((a += n.country), t.length > 1)) {
                                                                  var c = T4SThemeSP.Currency.formatMoney(t[0].price);
                                                                  r = o.multiple_rates.replace("[number_of_rates]", t.length).replace("[address]", a).replace("[rate]", c);
                                                              } else r = 1 === t.length ? o.one_rate.replace("[address]", a) : o.no_rates;
                                                              l = "";
                                                              e.each(t, function (e, t) {
                                                                  var n = T4SThemeSP.Currency.formatMoney(t.price),
                                                                      i = o.rate_value.replace("[rate_title]", t.name).replace("[rate]", n);
                                                                  l += "<li>" + i + "</li>";
                                                              }),
                                                                  i
                                                                      .html(
                                                                          '<div class="t4s-mess__rates is--rates-success">' +
                                                                              r +
                                                                              '</div><div class="t4s-results__rates"><ul>' +
                                                                              l.toString().replace(/<\/li>,<li>/g, "</li><li>") +
                                                                              "</ul></div>"
                                                                      )
                                                                      .fadeIn(),
                                                                  s.trigger("currency:update");
                                                          })(n.shipping_rates, i, o, a)
                                                        : (function (e, t, n) {
                                                              var i = "";
                                                              Object.keys(e).forEach(function (t) {
                                                                  i += "<li><span class='t4s-key__rate'>".concat(t, "</span> ").concat(e[t], "</li>");
                                                              }),
                                                                  "country is not supported." === i && (i = `<li>${n.no_rates}</li>`);
                                                              t.html(`<p>${n.errors}</p><ul class="t4s-mess__rates is--rates-error">${i}</ul>`).fadeIn();
                                                          })(n, o, a);
                                                })(t.ok, i, a, o, n.langRates);
                                            });
                                    });
                            }.bind(t[0])
                        ));
                }
                function T() {
                    if (!h) return;
                    let t = e("[data-cart-ship-done]").length;
                    t > 0 && A ? (T4SThemeSP.CanvasConfetti(), (A = !1), (M = !1)) : e(C).length > 0 && M ? (T4SThemeSP.CanvasConfetti(), (M = !1)) : 0 == t && ((M = !1), (A = !0));
                }
                function y() {
                    let n = e(`[${I}]`);
                    if (0 == n.length) return;
                    let i = t(n.attr(I));
                    if (((i.product_id = e("[data-cart-items] [data-cart-item]:first").data("pid") || i.product_id || 19041994), F == i.product_id)) return;
                    F = i.product_id;
                    let o = `${i.baseurl}?section_id=${i.section_id}&product_id=${i.product_id}&limit=${i.limit}`;
                    T4SThemeSP.getToFetchSection(null, "text", o).then((t) => {
                        if ("NVT_94" == t) return void n.hide();
                        B.flickityt4s && B.flickityt4s.destroy(), n.html(e(t).html()), s.trigger("currency:update"), T4SThemeSP.Tooltip();
                        let i = n.find(".flickityt4s")[0];
                        i &&
                            ((B.flickityt4s = new T4SThemeSP.Carousel(i)),
                            setTimeout(function () {
                                e(i).flickityt4s("resize");
                            }, 150),
                            setTimeout(function () {
                                e(i).flickityt4s("resize");
                            }, 450));
                    });
                }
                function S() {
                    let t = e("#t4s-tab-wishlist"),
                        n = T4SThemeSP.linkWishlist || "";
                    if (0 == t.length || n.indexOf("id:") < 0) return;
                    let i = e(".t4s-tab-wishlist-empty"),
                        o = e(".t4s-tab-wishlist-skeleton"),
                        a = n.replace("view=wishlist", "section_id=mini_cart_wishlist");
                    i.hide(),
                        o.show(),
                        T4SThemeSP.getToFetchSection(null, "text", a).then((t) => {
                            o.hide(), "NVT_94" != t && (o.siblings(".t4s-widget__pr").remove(), o.after(e(t).html()), s.trigger("currency:update"), T4SThemeSP.Wishlist.updateAll(), T4SThemeSP.Tooltip());
                        });
                }
                function w() {
                    !(function () {
                        if ("cart" == p) return u(), g(), f(), v(), T4SThemeSP.agreeForm(), T(), void y();
                        IsDesignMode
                            ? n()
                            : E ||
                              T4SThemeSP.getToFetchSection("?section_id=mini_cart").then((t) => {
                                  "NVT_94" != t &&
                                      T4SThemeSP.Helpers.promiseStylesheet(T4Sconfigs.stylesheet1).then(function () {
                                          e("#t4s-mini_cart").html(e(t).html()), n();
                                      });
                              });
                    })(),
                        document.addEventListener("cart:refresh", function (e) {
                            o(!1);
                        }),
                        document.addEventListener("cart:refresh:opend", function (e) {
                            o(!0);
                        }),
                        i.on("add:cart:upsell", function (e) {
                            U = !0;
                        });
                }
                var b = "[data-cart-items]",
                    x = "[data-cart-prices]",
                    C = "[data-cart-calc-shipping]",
                    _ = "[data-cart-ship-text]",
                    P = "[data-cart-ship-bar]",
                    k = "[data-cart-discounts]",
                    I = "data-cart-upsell-options",
                    D = "data-t4s-percent",
                    A = !0,
                    M = !0,
                    E = "disable" == T4Sconfigs.cartType,
                    R = "cart" != p ? T4Sconfigs.afterActionATC : "4",
                    O = E ? "cart_data" : "cart_data,mini_cart",
                    N = { loading: "is--loading", none: "t4s-d-none", active: "is--active" },
                    $ = window.cartT4SectionID,
                    L = "cart" != p ? O : `cart_data,${$}`,
                    F = 19041994,
                    U = !1,
                    B = {},
                    H = window.T4Sroutes.cart_url;
                return { renderContents: r, getToFetch: o, init: w };
            })()),
            (T4SThemeSP.Login = (function () {
                function t() {
                    var t = e("#t4s-login-sidebar");
                    if (0 != t.length) {
                        var i = g + "timeLoginT4s",
                            o = g + "dataLoginT4s",
                            a = isStorageSpSession ? sessionStorage.getItem(i) || 0 : 0;
                        (a = parseInt(a)) > 0 && a >= Date.now()
                            ? T4SThemeSP.Helpers.promiseStylesheet(T4Sconfigs.stylesheet3).then(function () {
                                  t.html(sessionStorage.getItem(o)), n();
                              })
                            : T4SThemeSP.getToFetchSection("?section_id=login-sidebar").then((s) => {
                                  "NVT_94" != s &&
                                      T4SThemeSP.Helpers.promiseStylesheet(T4Sconfigs.stylesheet3).then(function () {
                                          t.html(e(s).html()), n(), isStorageSpSession && ((a = Date.now() + 24e6), sessionStorage.setItem(i, a), sessionStorage.setItem(o, e(s).html()));
                                      });
                              });
                    }
                }
                function n() {
                    var t = e("#t4s-login-sidebar");
                    T4SThemeSP.Drawer.remove("t4s-login-sidebar"),
                        t.on("click", "[" + i + "]", function (n) {
                            n.preventDefault();
                            var o = e(this).attr(i);
                            e("#t4s-login-sidebar .t4s-content-login-sidebar.is--" + o)
                                .attr("aria-hidden", "false")
                                .siblings()
                                .attr("aria-hidden", "true"),
                                e("#t4s-login-sidebar .t4s-drawer__header .is--" + o)
                                    .attr("aria-hidden", "false")
                                    .siblings()
                                    .attr("aria-hidden", "true"),
                                t.attr("data-target", o);
                        });
                }
                var i = "data-login-sidebar";
                return function () {
                    IsDesignMode ? n() : t();
                };
            })()),
            (T4SThemeSP.Compare = (function () {
                function t(e, t, n) {
                    return n.indexOf(e) === t;
                }
                function n() {
                    var e = localStorage.getItem(b);
                    if (null != e) {
                        d = e.split(",");
                        var t = e.replace(/,/g, " OR "),
                            n = encodeURI(t);
                        A = D + n;
                    }
                }
                function i() {
                    if (isStorageSpdLocalAll && !p) {
                        var t = localStorage.getItem(b);
                        if (null != t) {
                            var n = t.replace(/id:/g, "");
                            (d = n.split(",")),
                                (I = "" == t ? 0 : d.length),
                                d.forEach(function (e, t) {
                                    o(e.replace("id:", ""));
                                }),
                                e(T).html(window.countComparePage || I);
                        }
                    }
                }
                function o(t, n) {
                    var i = e(g + '[data-id="' + t + '"]:not(.' + C + ")");
                    i.addClass(C).removeClass(x).find(".t4s-text-pr").text(P), i.find(".t4s-svg-pr-icon").html(E), n && n.trigger("updateTooltip");
                }
                function a(t, n = !1) {
                    R &&
                        (void 0 == T4Sconfigs.compePopupDes || "canvas" == T4Sconfigs.compePopupDes
                            ? T4SThemeSP.getToFetchSection(null, "text", t.replace("view=compare", "section_id=compare-popup")).then((t) => {
                                  "NVT_94" != t &&
                                      (n && u && u.remove(),
                                      T4SThemeSP.$appendComponent.after(t),
                                      (u = e(".t4s_section__compare-popup")),
                                      n &&
                                          setTimeout(function () {
                                              u.addClass(_);
                                          }, 20),
                                      T4SThemeSP.Tooltip());
                              })
                            : n &&
                              "modal" == T4Sconfigs.compePopupDes &&
                              T4SThemeSP.getToFetchSection(null, "text", t.replace("view=compare", "section_id=compare-modal")).then((e) => {
                                  "NVT_94" != e && (n && u && u.remove(), T4SThemeSP.NTpopupInline(e, "", r, "t4s-opening-cp"), s.trigger("modalt4s:opened"), T4SThemeSP.Tooltip());
                              }));
                }
                function r() {
                    T4SThemeSP.Wishlist.updateAll(), T4SThemeSP.Compare.updateAll(), T4SThemeSP.ProductItem.reloadReview(), T4SThemeSP.Tooltip(), s.trigger("currency:update");
                }
                function c() {
                    isStorageSpdLocalAll &&
                        !p &&
                        (history.replaceState && O && window.history.replaceState({}, document.title, m + "/?view=compare"),
                        n(),
                        O &&
                            (window.isEmtyCompare && window.isComparePerformed
                                ? localStorage.removeItem(b)
                                : (window.countComparePage != d.length && window.isComparePerformed && (e(dt_count_wishlist).html(window.countComparePage), localStorage.setItem(t4s_wis, window.listIDPrs)),
                                  !window.isEmtyCompare || window.isComparePerformed || "" == d.toString() || IsDesignMode || (window.location.href = A))),
                        s.on("click", g + "." + C, function (e) {
                            e.preventDefault(),
                                e.stopPropagation(),
                                R ? (void 0 == T4Sconfigs.compePopupDes || "canvas" == T4Sconfigs.compePopupDes ? u.addClass(_) : "modal" == T4Sconfigs.compePopupDes && a(A, !0)) : (window.location.href = A);
                        }),
                        s.on("click", h, function (e) {
                            e.preventDefault(), (window.location.href = A);
                        }),
                        s.on("click", S, function (t) {
                            t.preventDefault(), void 0 == T4Sconfigs.compePopupDes || "canvas" == T4Sconfigs.compePopupDes ? u.removeClass(_) : "modal" == T4Sconfigs.compePopupDes && s.trigger("modalt4s:closed");
                            let i = d.length;
                            for (let t = 0; t < i; t++) {
                                let n = d[t].replace("id:", "");
                                e(g + '[data-id="' + n + '"]')
                                    .removeClass(C)
                                    .find(".t4s-text-pr")
                                    .text(k),
                                    e(g + '[data-id="' + n + '"]')
                                        .find(".t4s-svg-pr-icon")
                                        .html(M);
                            }
                            (d = []), localStorage.setItem(b, d.toString()), (I = 0), e(T).html(I), e(y).html(I < 2 ? l.item_compare[I] : l.item_compare[2]), n();
                        }),
                        s.on("click", w, function (e) {
                            e.preventDefault(), u.removeClass(_);
                        }),
                        null != localStorage.getItem(b) && "" != d.toString() && a(A),
                        s.on("click", g + ":not(." + C + ")", function (s) {
                            s.preventDefault(), s.stopPropagation();
                            var r = e(this),
                                c = r.data("id") || "",
                                d = "id:" + c,
                                u = localStorage.getItem(b),
                                p = !1;
                            if ("" != c) {
                                if ((r.addClass(x), null != u && u.length > 0)) (m = u.split(",")).unshift(d);
                                else {
                                    var m = new Array();
                                    m.unshift(d);
                                }
                                if (((m = m.filter(t)).length > f && ((m = m.splice(0, f)), (p = !0)), localStorage.setItem(b, m.toString()), (I = m.length), p)) {
                                    var h = e(g + C);
                                    h.removeClass(C).find(".t4s-text-pr").text(k), h.find(".t4s-svg-pr-icon").html(M), i();
                                } else o(c, r);
                                e(T).html(I), e(y).html(I < 2 ? l.item_compare[I] : l.item_compare[2]), n(), a(A, !0), O && (window.location.href = A);
                            }
                        }),
                        s.on("click", v, function (t) {
                            t.preventDefault(), t.stopPropagation();
                            var i = e(this),
                                o = i.data("id"),
                                a = "id:" + o,
                                r = localStorage.getItem(b);
                            i.addClass(x);
                            var c = (d = r.split(",")).indexOf(a);
                            c > -1 ? (d = d.splice(0, f + 1)).splice(c, 1) : (d = d.splice(0, f)),
                                localStorage.setItem(b, d.toString()),
                                i.removeClass(x),
                                i.trigger("destroyTooltip"),
                                e(".t4s_compare_id_" + o).remove(),
                                e(g + '[data-id="' + o + '"]')
                                    .removeClass(C)
                                    .find(".t4s-text-pr")
                                    .text(k),
                                e(g + '[data-id="' + o + '"]')
                                    .find(".t4s-svg-pr-icon")
                                    .html(M),
                                (I = d.length),
                                e(T).html(I),
                                e(y).html(I < 2 ? l.item_compare[I] : l.item_compare[2]),
                                n(),
                                O && "" == d.toString() && (e(".t4s_compare_table").fadeTo(300, 0), (window.location.href = A)),
                                0 == I &&
                                    (R ? (void 0 == T4Sconfigs.compePopupDes || "canvas" == T4Sconfigs.compePopupDes ? u.removeClass(_) : "modal" == T4Sconfigs.compePopupDes && s.trigger("modalt4s:closed")) : (window.location.href = A));
                        }));
                }
                var d,
                    u,
                    p = !T4Sconfigs.enable_compare,
                    f = 6,
                    h = "[data-link-compare]",
                    g = "[data-action-compare]",
                    v = "[data-remove-compare]",
                    T = "[data-count-compare]",
                    y = "[data-ttcount-compare]",
                    S = "[data-clear-compare]",
                    w = "[data-close-compare]",
                    b = "t4s_cp",
                    x = "is--pe-none",
                    C = "is--added",
                    _ = "is--activate",
                    P = T4SProductStrings.added_text_cp,
                    k = T4SProductStrings.compare,
                    I = 0,
                    D = m + "/?view=compare&type=product&options[unavailable_products]=last&q=",
                    A = "",
                    M = T4Sconfigs.cp_icon,
                    E = T4Sconfigs.cp_icon_added,
                    R = T4Sconfigs.enableCompePopup,
                    O = window.isPageCompare;
                return { init: c, updateAll: i };
            })()),
            (T4SThemeSP.Wishlist = (function () {
                function t(e, t, n) {
                    return n.indexOf(e) === t;
                }
                function n() {
                    s.on("click", w + ":not(." + k + ")", function (n) {
                        n.preventDefault(),
                            n.stopPropagation(),
                            h
                                ? (function (n) {
                                      var i = n.data("id") || "",
                                          o = "id:" + i,
                                          a = localStorage.getItem(_),
                                          s = !1;
                                      if ("" == i) return;
                                      if ((n.addClass(P), null != a && a.length > 0)) (l = a.split(",")).unshift(o);
                                      else {
                                          var l = new Array();
                                          l.unshift(o);
                                      }
                                      (l = l.filter(t)).length > T && ((l = l.splice(0, T)), (s = !0));
                                      if ((localStorage.setItem(_, l.toString()), (E = l.length), s)) {
                                          var u = e(w + k);
                                          u.removeClass(k).find(".t4s-text-pr").text(A), u.find(".t4s-svg-pr-icon").html($), c();
                                      } else d(i, n);
                                      e(C).html(E), r(), W && (window.location.href = O);
                                  })(e(this))
                                : (function (t) {
                                      var n = t.attr("data-id") || "",
                                          i = t.attr("data-handle") || "ntt4s" + n;
                                      if ("" == n) return;
                                      t.addClass(U + " " + P),
                                          fetch(B, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ product_id: n, product_handle: i, action: "add" }) })
                                              .then(function (e) {
                                                  return e.json();
                                              })
                                              .then(function (t) {
                                                  "success" == t.status
                                                      ? ((H = JSON.parse(t.response.metafield.value).the4_ids), Array.isArray(H) || (H = H.split(",")), d(n), (E = H.length), e(C).html(E), l(), W && (window.location.href = O))
                                                      : console.error(t.message || "Unknow error");
                                              })
                                              .catch(function (e) {
                                                  console.log("Error: " + e);
                                              })
                                              .finally(() => {
                                                  t.removeClass(U + " " + P);
                                              });
                                  })(e(this));
                    });
                }
                function o(t) {
                    var n = t.data("id"),
                        i = "id:" + n,
                        o = localStorage.getItem(_);
                    t.addClass(P);
                    var a = (N = o.split(",")).indexOf(i);
                    a > -1 ? (N = N.splice(0, T + 1)).splice(a, 1) : (N = N.splice(0, T)), localStorage.setItem(_, N.toString()), t.removeClass(P), t.trigger("destroyTooltip");
                    var s = e(".t4s-products-wishlist .t4s-products");
                    if (s.length > 0) {
                        let i = t.closest(".t4s-product");
                        (i = i[0] ? i : e(`[data-remove-wishlist][data-id="${n}"]`).closest(".t4s-product")), s.hasClass("isotopet4s-enabled") ? s.isotopet4s("remove", i[0]).isotopet4s("layout") : i.remove();
                    }
                    e(w + '[data-id="' + n + '"]')
                        .removeClass(k)
                        .find(".t4s-text-pr")
                        .text(A),
                        e(w + '[data-id="' + n + '"]')
                            .find(".t4s-svg-pr-icon")
                            .html($),
                        (E = N.length),
                        e(C).html(E),
                        r(),
                        W && ("" == N.toString() || j) && (e(".t4s-products-wishlist").fadeTo(300, 0), (window.location.href = O));
                }
                function a(t) {
                    var n = t.attr("data-id") || "",
                        i = t.attr("data-handle") || "ntt4s" + n;
                    t.addClass(U + " " + P),
                        fetch(B, { method: "DELETE", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ product_id: n, product_handle: i, action: "add", _method: "DELETE" }) })
                            .then(function (e) {
                                return e.json();
                            })
                            .then(function (i) {
                                if ("success" == i.status) {
                                    (N = JSON.parse(i.response.metafield.value).the4_ids), (H = N), Array.isArray(H) || (H = H.split(",")), t.trigger("destroyTooltip");
                                    var o = e(".t4s-products-wishlist .t4s-products");
                                    if (o.length > 0) {
                                        let i = t.closest(".t4s-product");
                                        (i = i[0] ? i : e(`[data-remove-wishlist][data-id="${n}"]`).closest(".t4s-product")), o.hasClass("isotopet4s-enabled") ? o.isotopet4s("remove", i[0]).isotopet4s("layout") : i.remove();
                                    }
                                    e(w + '[data-id="' + n + '"]')
                                        .removeClass(k)
                                        .find(".t4s-text-pr")
                                        .text(A),
                                        e(w + '[data-id="' + n + '"]')
                                            .find(".t4s-svg-pr-icon")
                                            .html($),
                                        (E = H.length),
                                        e(C).html(E),
                                        l(),
                                        W && ("" == N.toString() || j) && (e(".t4s-products-wishlist").fadeTo(300, 0), (window.location.href = R));
                                } else console.error(i.message || "Unknow error");
                            })
                            .catch(function (e) {
                                console.log("Error: " + e);
                            })
                            .finally(() => {
                                t.removeClass(U + " " + P);
                            });
                }
                function r() {
                    var e = localStorage.getItem(_);
                    if (null != e) {
                        N = e.split(",");
                        var t = e.replace(/,/g, " OR "),
                            n = encodeURI(t);
                        (O = R + n), (T4SThemeSP.linkWishlist = O), i.trigger("update:mini_cart:wishlist");
                    }
                }
                function l() {
                    if (0 != (N = H).length) {
                        var e = "id:" + N.join(" OR id:"),
                            t = encodeURI(e);
                        (O = R + t), (T4SThemeSP.linkWishlist = O), i.trigger("update:mini_cart:wishlist");
                    }
                }
                function c() {
                    if (!((!isStorageSpdLocalAll && h) || v)) {
                        if (h) {
                            var t = localStorage.getItem(_);
                            if (null == t) return;
                            var n = t.replace(/id:/g, "");
                            (N = n.split(",")), (E = "" == t ? 0 : N.length);
                        } else {
                            if ("" == (N = H).toString()) return;
                            E = N.length;
                        }
                        if (
                            (N.forEach(function (e, t) {
                                d(e.replace("id:", ""));
                            }),
                            W)
                        ) {
                            var i = e(".t4s-products-wishlist " + w);
                            i.removeClass(k).removeAttr(S, "").attr(b, "").find(".t4s-text-pr").html(D), i.find(".t4s-svg-pr-icon").html(L);
                        }
                        e(C).html(E || window.countWishlistPage);
                    }
                }
                function d(t, n) {
                    var i = e(w + '[data-id="' + t + '"]:not(.' + k + ")");
                    i.addClass(k).removeClass(P).find(".t4s-text-pr").text(M), i.find(".t4s-svg-pr-icon").html(F), n && i.trigger("updateTooltip");
                }
                function u() {
                    (!isStorageSpdLocalAll && h) ||
                        v ||
                        (history.replaceState && W && window.history.replaceState({}, document.title, m + "/?view=wishlist"),
                        h ? r() : l(),
                        W &&
                            (window.isEmtyWishlist && window.isWishlistPerformed
                                ? localStorage.removeItem(_)
                                : (window.countWishlistPage != N.length && window.isWishlistPerformed && (e(C).html(window.countWishlistPage), localStorage.setItem(_, window.listIDPrs)),
                                  !window.isEmtyWishlist || window.isWishlistPerformed || "" == N.toString() || IsDesignMode || (window.location.href = O))),
                        s.on("click", w + "." + k, function (t) {
                            t.preventDefault(), t.stopPropagation(), f ? (h ? o(e(this)) : a(e(this))) : (window.location.href = O);
                        }),
                        s.on("click", y, function (e) {
                            0 != O.length && (e.preventDefault(), (window.location.href = O));
                        }),
                        n(),
                        s.on("click", x, function (t) {
                            t.preventDefault(), t.stopPropagation(), h ? o(e(this)) : a(e(this));
                        }));
                }
                var p = T4Sconfigs.wishlist_mode,
                    f = "2" == T4Sconfigs.wis_atc_added,
                    h = "1" == p,
                    g = "2" == p,
                    v = !(h || g),
                    T = 50,
                    y = "[data-link-wishlist]",
                    S = "data-action-wishlist",
                    w = "[" + S + "]",
                    b = "data-remove-wishlist",
                    x = "[" + b + "]",
                    C = "[data-count-wishlist]",
                    _ = "t4s_wis",
                    P = "is--pe-none",
                    k = "is--added",
                    I = T4SProductStrings.browse_wishlist,
                    D = T4SProductStrings.remove_wishlist,
                    A = T4SProductStrings.add_to_wishlist,
                    M = f ? D : I,
                    E = 0,
                    R = m + "/?view=wishlist&type=product&options[unavailable_products]=last&q=",
                    O = "",
                    N = "",
                    $ = T4Sconfigs.wis_icon,
                    L = T4Sconfigs.wis_icon_remove,
                    F = T4Sconfigs.wis_icon_added,
                    U = "is--loading",
                    B = "/tools/the4/wishlist",
                    H = "",
                    W = window.isPageWishlist,
                    j = window.hasPaginateWishlist;
                if (g)
                    var z = e("#wis_t4s_list").html() || "",
                        H = z.length > 0 ? z.split(" ") : [];
                return { init: u, updateAll: c };
            })());
        let b = location.search.indexOf("customer_posted=true") > -1 || location.search.indexOf("newsletter&form_type=customer") > -1;
        (T4SThemeSP.PopupPro = (function () {
            function o() {
                e.magnificPopupT4s.open({
                    items: { src: _.popup },
                    type: "inline",
                    closeOnBgClick: !1,
                    closeBtnInside: !1,
                    showCloseBtn: !1,
                    enableEscapeKey: !1,
                    removalDelay: 500,
                    tClose: T,
                    callbacks: {
                        beforeOpen: function () {
                            a.addClass(S), (this.st.mainClass = "mfp-move-horizontal t4s-age_pp_wrapper");
                        },
                        open: function () {
                            _.$popup.find(".t4s-age_verify_allowed").on(_.click, function () {
                                if (_.date_of_birth) {
                                    var t = parseInt(e("#ageyear").val()),
                                        n = parseInt(e("#agemonth").val()),
                                        i = parseInt(e("#ageday").val()),
                                        o = new Date(t + _.age_limit, n, i);
                                    new Date().getTime() - o.getTime() < 0
                                        ? (_.$popup.addClass("t4s-animated t4s-shake"),
                                          window.setTimeout(function () {
                                              _.$popup.removeClass("t4s-animated t4s-shake");
                                          }, 1e3))
                                        : (CookiesT4.set(_.CookiesName, "confirmed", { expires: parseInt(_.day_next), path: "/" }), e.magnificPopupT4s.close());
                                } else CookiesT4.set(_.CookiesName, "confirmed", { expires: parseInt(_.day_next), path: "/" }), e.magnificPopupT4s.close();
                            }),
                                _.$popup.find(".t4s-age_verify_forbidden").on(_.click, function () {
                                    _.$popup.addClass("active_forbidden");
                                });
                        },
                        beforeClose: function () {},
                        close: function () {
                            _.$popup.find(".t4s-age_verify_allowed, .t4s-age_verify_forbidden").off(_.click);
                        },
                        afterClose: function () {
                            a.removeClass(S);
                        },
                    },
                });
            }
            function r() {
                e.magnificPopupT4s.open({
                    items: { src: P.popup },
                    type: "inline",
                    removalDelay: 500,
                    tClose: T,
                    callbacks: {
                        beforeOpen: function () {
                            a.addClass(S), (this.st.mainClass = "mfp-move-horizontal t4s-exit_pp_wrapper");
                        },
                        open: function () {
                            if ((e(".t4s-exit_pp_wrapper .t4s-product").length > 0 && T4SThemeSP.reinitProductGridItem(), e(".t4s-exit_pp_wrapper .flickityt4s").length > 0)) {
                                var t = e(".t4s-exit_pp_wrapper .flickityt4s")[0];
                                t.flickityt4s = new T4SThemeSP.Carousel(t);
                            }
                            s.trigger("t4s:hideTooltip"), s.trigger("currency:update");
                        },
                        beforeClose: function () {},
                        close: function () {
                            i.off(P.mouseleave), CookiesT4.set(P.CookiesName, "shown", { expires: P.day_next, path: "/" });
                        },
                        afterClose: function () {
                            a.removeClass(S);
                        },
                    },
                });
            }
            function c(t, n) {
                1 === t
                    ? e.magnificPopupT4s.open({
                          items: { src: k.popup },
                          type: "inline",
                          removalDelay: 500,
                          tClose: T,
                          callbacks: {
                              beforeOpen: function () {
                                  a.addClass(S), (this.st.mainClass = "mfp-move-horizontal t4s-newsletter_pp_wrapper");
                              },
                              open: function () {
                                  s.on("mail.subscribe.success", function (e) {
                                      CookiesT4.set(k.CookiesName, "shown", { expires: k.day_next, path: "/" });
                                  });
                              },
                              beforeClose: function () {
                                  (e("[data-checked-newsletter]:checked").length > 0 || !e("[data-checked-newsletter]")[0]) && CookiesT4.set(k.CookiesName, "shown", { expires: k.day_next, path: "/" });
                              },
                              close: function () {},
                              afterClose: function () {
                                  a.removeClass(S);
                              },
                          },
                      })
                    : n
                    ? (k.$content.addClass("on--show").removeClass("on--shown"),
                      setTimeout(() => {
                          k.$content.removeClass("on--show");
                      }, 500),
                      (e("[data-checked-newsletter]:checked").length > 0 || !e("[data-checked-newsletter]")[0]) && CookiesT4.set(k.CookiesName, "shown", { expires: k.day_next, path: "/" }))
                    : (k.$content.addClass("on--show"),
                      setTimeout(() => {
                          k.$content.removeClass("on--show").addClass("on--shown");
                      }, 100));
            }
            function d() {
                I.$popup.removeClass("on--hide").addClass("on--show"),
                    I.$popup.on(I.click, ".t4s-pp_cookies__accept-btn", function (e) {
                        e.preventDefault(),
                            window.Shopify.customerPrivacy.setTrackingConsent(!0, u),
                            document.addEventListener("trackingConsentAccepted", function () {
                                CookiesT4.set(I.CookiesName, "accepted", { expires: I.day_next, path: "/" });
                            }),
                            D && CookiesT4.set(I.CookiesName, "accepted", { expires: I.day_next, path: "/" });
                    }),
                    I.$popup.on(I.click, ".t4s-pp_cookies__decline-btn", function (e) {
                        e.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, u);
                    });
            }
            function u() {
                I.$popup.addClass("on--hide").removeClass("on--show");
            }
            function p() {
                (I.$popup = e(I.popup)),
                    0 != I.$popup.length &&
                        ((I.stts = I.$popup.data("stt")),
                        (I.day_next = I.stts.day_next || 60),
                        (I.pp_version = I.stts.pp_version || 1994),
                        (I.CookiesName = `${y}_cookies_${I.pp_version}`),
                        (D = "1" == I.stts.show),
                        "accepted" == CookiesT4.get(I.CookiesName) ||
                            I.$popup.hasClass(C) ||
                            (I.$popup.addClass(C),
                            window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (t) {
                                if (t) throw t;
                                !(function () {
                                    const t = window.Shopify.customerPrivacy.userCanBeTracked(),
                                        n = window.Shopify.customerPrivacy.getTrackingConsent();
                                    ((!t && "no_interaction" === n) || IsDesignMode || D) &&
                                        (IsDesignMode
                                            ? I.$popup
                                                  .on(w, function () {
                                                      (I.$popup = e(I.popup)), d();
                                                  })
                                                  .on(x, function () {
                                                      u();
                                                  })
                                            : d());
                                })();
                            })));
            }
            function m(e, t) {
                return Math.floor(Math.random() * (t - e + 1)) + e;
            }
            function f(e) {
                var t = A.imageArray[e],
                    n = T4SThemeSP.Images.getNewImageUrl(t, 65),
                    i = T4SThemeSP.Images.getNewImageUrl(t, 130);
                A.$temp.find("[data-img-sale]").attr("src", n).attr("srcset", `${n} 1x, ${i} 2x`),
                    A.$temp.find("[data-title-sale]").text(A.titleArray[e]),
                    A.$temp.find("[data-href-sale]").attr("href", A.urlArray[e]),
                    A.$temp.find("[data-action-quickview]").attr("data-id", A.idArray[e]),
                    A.$temp.find("[data-location-sale]").text(A.locationArray[m(A.min, A.max2)]),
                    A.$temp.find("[data-ago-sale]").text(A.timeArray[m(A.min, A.max3)]);
            }
            function h() {
                s.trigger("t4s:hideTooltip"), A.$temp && A.$temp.removeClass(A.classUp).addClass(A.classDown).off("mouseenter mouseleave");
            }
            function g() {
                h(),
                    (A.starTimeout = setTimeout(function () {
                        A.$temp && A.$temp.remove(),
                            T4SThemeSP.$appendComponent.after(A.temp),
                            T4SThemeSP.Tooltip(),
                            (A.$temp = e(".t4s-popup__sales")),
                            "1" == A.ppType ? (f(A.index), ++A.index, A.index > A.max && (A.index = 0)) : f(m(A.min, A.max)),
                            (A.time.START = new Date().getTime()),
                            (A.time.END = A.time.START + A.stayTime),
                            (A.stayTimeout = setTimeout(function () {
                                clearTimeout(A.stayTimeout), g();
                            }, A.stayTime)),
                            (A.$progressbarSpan = e(".t4s-pp-slpr-progressbar>span")),
                            A.pauseOnHover &&
                                A.$temp
                                    .on("mouseenter", function (e) {
                                        A.resetOnHover ? A.$progressbarSpan.css("animation-name", "none") : (A.time.REMAINING = A.time.END - new Date().getTime()), clearTimeout(A.stayTimeout);
                                    })
                                    .on("mouseleave", function (e) {
                                        A.resetOnHover ? ((A.time.REMAINING = A.stayTime), A.$progressbarSpan.css("animation-name", "t4s-ani-w")) : (A.time.END = new Date().getTime() + A.time.REMAINING),
                                            (A.stayTimeout = setTimeout(function () {
                                                g();
                                            }, A.time.REMAINING));
                                    }),
                            A.$temp.find(A.close).on("click", function (e) {
                                e.preventDefault(), h(), s.trigger("t4s:hideTooltip"), A.$temp.off("mouseenter mouseleave"), clearTimeout(A.stayTimeout), clearTimeout(A.starTimeout);
                            });
                    }, A.starTime));
            }
            function v() {
                p(),
                    (function () {
                        k.$content = e(e(k.popup).length > 0 ? k.popup : k.canvas);
                        var t = `${y}_shown_pages`,
                            o = CookiesT4.get(t),
                            a = e(k.popup).length > 0 ? 1 : 2;
                        if ((o || (o = 0), 0 == k.$content.length)) return o++, void CookiesT4.set(t, o, { expires: 194, path: "/" });
                        if (
                            ((k.stts = k.$content.data("stt")),
                            (k.pp_version = k.stts.pp_version),
                            (k.CookiesName = k.CookiesName + k.pp_version),
                            !((!IsDesignMode && "shown" == CookiesT4.get(k.CookiesName)) || (!k.stts.isMobile && n.width() < 768) || k.$content.hasClass(C)))
                        ) {
                            var r = "1" == k.pp_version ? "2" : "1",
                                l = `${y}_newsletter${r}`;
                            if (("shown" == CookiesT4.get(l) && CookiesT4.remove(l), k.$content.addClass(C), (k.day_next = k.stts.day_next), (k.scroll_delay = k.stts.scroll_delay), (k.after = k.stts.after), b)) {
                                let e = k.$content.find(".t4s-newsletter__success").length,
                                    t = k.$content.find(".t4s-newsletter__error").length;
                                (e > 0 || t > 0) && (e > 0 && CookiesT4.set(k.CookiesName, "shown", { expires: k.day_next, path: "/" }), (k.after = "auto"), (k.stts.time_delay = 500));
                            }
                            if (IsDesignMode)
                                1 === a
                                    ? k.$content
                                          .on(w, function () {
                                              e.magnificPopupT4s.instance.isOpen
                                                  ? (e.magnificPopupT4s.close(),
                                                    setTimeout(function () {
                                                        k.$content.off(w).off(x),
                                                            (k.$content = e(k.popup)),
                                                            c(a),
                                                            k.$content
                                                                .on(w, function () {
                                                                    c(a);
                                                                })
                                                                .on(x, function () {
                                                                    e.magnificPopupT4s.close();
                                                                });
                                                    }, e.magnificPopupT4s.instance.st.removalDelay + 10))
                                                  : c(a);
                                          })
                                          .on(x, function () {
                                              e.magnificPopupT4s.close();
                                          })
                                    : (k.$content.on("shopify:block:select", function (e) {
                                          c(a);
                                      }),
                                      k.$content.on("shopify:block:deselect", function (e) {
                                          c(a, "close");
                                      }));
                            else {
                                var d = k.stts.number_pages;
                                if (o < d) return o++, CookiesT4.set(t, o, { expires: 194, path: "/" }), !1;
                                CookiesT4.set(t, d, { expires: 194, path: "/" }),
                                    "scroll" == k.after
                                        ? n.on(k.scroll, function () {
                                              i.scrollTop() < k.scroll_delay || (c(a), n.off(k.scroll));
                                          })
                                        : setTimeout(function () {
                                              c(a);
                                          }, k.stts.time_delay),
                                    e(document)
                                        .on("click", "[data-triger-newsletter]", function (e) {
                                            e.preventDefault(), c(a);
                                        })
                                        .on("click", "[data-t4s-dismiss]", function (e) {
                                            e.preventDefault(), c(a, "close");
                                        }),
                                    s.on("mail.subscribe.success", function (e) {
                                        c(a), CookiesT4.set(k.CookiesName, "shown", { expires: k.day_next, path: "/" });
                                    });
                            }
                        }
                    })(),
                    (P.$popup = e(P.popup)),
                    0 != P.$popup.length &&
                        ((!IsDesignMode && "shown" == CookiesT4.get(P.CookiesName)) ||
                            P.$popup.hasClass(C) ||
                            ((P.stts = P.$popup.data("stt")),
                            (P.day_next = P.stts.day_next),
                            P.$popup.addClass(C),
                            IsDesignMode
                                ? P.$popup
                                      .on(w, function () {
                                          e.magnificPopupT4s.instance.isOpen
                                              ? (e.magnificPopupT4s.close(),
                                                setTimeout(function () {
                                                    P.$popup.off(w).off(x),
                                                        (P.$popup = e(P.popup)),
                                                        r(),
                                                        P.$popup
                                                            .on(w, function () {
                                                                r();
                                                            })
                                                            .on(x, function () {
                                                                e.magnificPopupT4s.close();
                                                            });
                                                }, e.magnificPopupT4s.instance.st.removalDelay + 10))
                                              : r();
                                      })
                                      .on(x, function () {
                                          e.magnificPopupT4s.close();
                                      })
                                : i.on(P.mouseleave, function (t) {
                                      t.clientY < 60 && 0 == e(".mfp-content").length && r();
                                  }))),
                    (_.$popup = e(_.popup)),
                    0 != _.$popup.length &&
                        ((!IsDesignMode && "confirmed" == CookiesT4.get(_.CookiesName)) ||
                            _.$popup.hasClass(C) ||
                            ((_.stts = _.$popup.data("stt")),
                            (_.age_limit = _.stts.age_limit),
                            (_.date_of_birth = _.stts.date_of_birth),
                            (_.day_next = _.stts.day_next),
                            _.$popup.addClass(C),
                            IsDesignMode
                                ? _.$popup
                                      .on(w, function () {
                                          e.magnificPopupT4s.instance.isOpen
                                              ? (e.magnificPopupT4s.close(),
                                                setTimeout(function () {
                                                    _.$popup.off(w).off(x),
                                                        (_.$popup = e(_.popup)),
                                                        o(),
                                                        _.$popup
                                                            .on(w, function () {
                                                                o();
                                                            })
                                                            .on(x, function () {
                                                                e.magnificPopupT4s.close();
                                                            });
                                                }, e.magnificPopupT4s.instance.st.removalDelay + 10))
                                              : o();
                                      })
                                      .on(x, function () {
                                          e.magnificPopupT4s.close();
                                      })
                                : o())),
                    (function () {
                        if (((A.$popup = e(A.popup)), 0 == A.$popup.length)) return;
                        let i = e("#t4s-popup__sales-JSON");
                        (A.stts = t(i.html())),
                            i.remove(),
                            (!A.stts.isMobile && n.width() < 768) ||
                                A.$popup.hasClass(C) ||
                                (A.$popup.addClass(C),
                                (A.temp = A.$popup.html()),
                                (A.starTime = A.stts.starTime * A.stts.starTimeUnit),
                                (A.stayTime = A.stts.stayTime * A.stts.stayTimeUnit),
                                (A.index = 0),
                                (A.limit = A.stts.limit),
                                (A.max = A.stts.max),
                                (A.min = 0),
                                (A.classUp = A.stts.classUp),
                                (A.classDown = A.stts.classDown[A.classUp]),
                                (A.ppType = A.stts.ppType),
                                (A.pauseOnHover = A.stts.pauseOnHover),
                                (A.resetOnHover = A.stts.resetOnHover),
                                (A.idArray = A.stts.idArray),
                                (A.titleArray = A.stts.titleArray),
                                (A.urlArray = A.stts.urlArray),
                                (A.locationArray = A.stts.locationArray),
                                (A.timeArray = A.stts.timeArray),
                                (A.imageArray = A.stts.imageArray),
                                (A.max = A.urlArray.length - 1),
                                (A.max2 = A.locationArray.length - 1),
                                (A.max3 = A.timeArray.length - 1),
                                A.starTimeout,
                                A.stayTimeout,
                                (A.time = {}),
                                IsDesignMode
                                    ? (T4SThemeSP.$appendComponent.after(A.temp),
                                      (A.$temp = e(".t4s-popup__sales")),
                                      A.$temp.hide(),
                                      T4SThemeSP.Tooltip(),
                                      e(A.close).on("click", function (e) {
                                          e.preventDefault(), h();
                                      }),
                                      A.$popup
                                          .on(w, function () {
                                              A.$temp.show(), A.$temp.addClass(A.classUp).removeClass(A.classDown);
                                          })
                                          .on(x, function () {
                                              h();
                                          }))
                                    : (A.$popup.remove(), g()));
                    })();
            }
            var T = l.mfp_close,
                y = (l.mfp_loading, T4Sconfigs.theme),
                S = "is-opening-mfp",
                w = "open.popup",
                x = "close.popup",
                C = "is--loaded",
                _ = { click: "click.age", popup: "#t4s-popup__age", CookiesName: `${y}_age_verify` },
                P = { mouseleave: "mouseleave.exit", click: "click.exit", popup: "#t4s-popup__exit", CookiesName: `${y}_exit` },
                k = { scroll: "scroll.newsletter", click: "click.newsletter", popup: "#t4s-popup__newsletter", canvas: ".t4s-newsletter_canvas", CookiesName: `${y}_newsletter` },
                I = { popup: "#t4s-popup__cookies-law", click: "click.cookies" },
                D = !0,
                A = { popup: "#t4s-popup__sales-tmp", close: "[data-close-sale]" };
            return v;
        })()),
            (T4SThemeSP.PopupFetch = function () {
                let e = T4Srequest.path,
                    t = ("/" != e ? e : "") + "/?section_id=popups";
                b && (t = t + "&" + location.href.split("/?")[1]),
                    T4SThemeSP.getToFetchSection(null, "text", t).then((e) => {
                        "NVT_94" != e && (T4SThemeSP.$appendComponent.after(e), T4SThemeSP.PopupPro(), T4SThemeSP.PlatFormMail(), T4SThemeSP.PopupMFP());
                    });
            }),
            (T4SThemeSP.PlatFormMail = (function () {
                function t() {
                    "4" == f &&
                        e(`[data-t4s-mailChimp-ajax]:not(.${n.enabled})`)
                            .addClass(n.enabled)
                            .submit(function (t) {
                                t.preventDefault();
                                var i = e(this),
                                    o = i.find("[data-new-response-form]"),
                                    a = i.find("[data-t4s-mailChimp-submit]"),
                                    r = o.find("[data-new-response-success]"),
                                    l = o.find("[data-new-response-error]");
                                a.addClass(n.loading),
                                    e.ajax({
                                        type: "GET",
                                        url: i.attr("action"),
                                        data: i.serialize(),
                                        cache: !1,
                                        dataType: "jsonp",
                                        jsonp: "c",
                                        contentType: "application/json; charset=utf-8",
                                        error: function (e) {
                                            a.removeClass(n.loading);
                                            try {
                                                var t = e.replace("0 - ", "").replace("1 - ", "").replace("2 - ", "");
                                                l.html(t).slideDown(100);
                                            } catch (e) {}
                                        },
                                        success: function (e) {
                                            a.removeClass(n.loading);
                                            try {
                                                var t = e.msg.replace("0 - ", "").replace("1 - ", "").replace("2 - ", "");
                                                "success" != e.result ? (r.slideUp(100), l.html(t).slideDown(100)) : (s.trigger("mail.subscribe.success"), l.slideUp(100), r.slideDown(100));
                                            } catch (e) {}
                                        },
                                    });
                            }),
                        "3" == f &&
                            $script("//www.klaviyo.com/media/js/public/klaviyo_subscribe.js", function () {
                                e.each(e(`[data-t4s-klaviyo-ajax]:not(.${n.enabled})`), function () {
                                    var t = e(this),
                                        o = t.attr("data-brand") || "Kalles Klaviyo";
                                    KlaviyoSubscribe.attachToForms("#" + t.attr("id"), {
                                        custom_success_message: !0,
                                        extra_properties: { $source: "Newsletter Popup", Brand: o },
                                        success: function (e) {
                                            s.trigger("mail.subscribe.success"), e.find(i.klaviyo).removeClass(n.loading);
                                        },
                                    }),
                                        t.addClass(n.enabled).submit(function (t) {
                                            e(this).find(i.klaviyo).addClass(n.loading);
                                        });
                                }),
                                    s.on("klaviyo.subscribe.success", function (e) {
                                        s.trigger("mail.subscribe.success");
                                    }),
                                    s.on("klaviyo.subscribe.success klaviyo.subscribe.error", function (t) {
                                        e(t.target).find(i.klaviyo).removeClass(n.loading);
                                    });
                            }),
                        0 != e(a).length &&
                            (e("[data-agreeMail-btn]")
                                .off(o.click)
                                .on(o.click, function (t) {
                                    var i = e(this).closest("form");
                                    i.find(`[type="checkbox"]${a}`).is(":checked") || (t.preventDefault(), t.stopPropagation(), i.addClass(n.errorCheckbox), i.find('[type="email"]').val().length < 1 && i.addClass(n.errorEmail));
                                }),
                            e(a)
                                .off(o.click)
                                .on(o.click, function (t) {
                                    e(this).is(":checked") && e(this).closest("form").removeClass(n.errorCheckbox);
                                }),
                            e('[data-form-mail-agree] [type="email"]')
                                .off(o.keyup)
                                .on(o.keyup, function (t) {
                                    var i = e(this).closest("form");
                                    e(this).val().length < 1 ? i.addClass(n.errorEmail) : i.removeClass(n.errorEmail);
                                })),
                        "?contact%5Btags%5D=newsletter&form_type=customer" == location.search && e("[data-new-response-form]").html(`<div class="t4s-newsletter__error">${l.error_exist}</div>`).slideDown(100);
                }
                var n = { loading: "is--loading", enabled: "is--enabled", errorCheckbox: "is--error-checkbox", errorEmail: "is--error-email" },
                    i = { klaviyo: "[data-t4s-klaviyo-submit]" },
                    o = { click: "click.mail", keyup: "keyup.mail" },
                    a = "[data-agreeMail-checkbox]";
                return t;
            })());
        var x = (function () {
            function t(t) {
                (this.$form = e(t)), (this.$totalPrice = this.$form.find(n)), (this.ArrayPrice = []), (this.ArrayComparePrice = []);
                let o = this;
                this.$form.find(i).each(function (e) {
                    o._updateItemPrice(this, e);
                }),
                    o._updateTotalPrice(),
                    o._eventListeners();
            }
            var n = "[data-groups-total-price]",
                i = "[data-groups-pr-item]",
                o = { change: "change.groups" },
                a = { checked: "is--checked" };
            return (
                (t.prototype = Object.assign({}, t.prototype, {
                    _eventListeners: function () {
                        let t = this;
                        this.$form.on(o.change, "select[data-groups-pr-sl]", function () {
                            t._updateItem(this);
                        }),
                            this.$form.on(o.change, "[data-groups-pr-ck]", function () {
                                let n = e(this).closest(i),
                                    o = n.index(),
                                    s = t.$form.find(`[data-groups-img="${o}"]`),
                                    r = n.find('[name*="items[]"]');
                                this.checked
                                    ? (n.addClass(a.checked), t._updateItemPrice(n, o), s.fadeIn(300), r.prop("disabled", !1))
                                    : (n.removeClass(a.checked), (t.ArrayPrice[o] = 0), (t.ArrayComparePrice[o] = 0), s.fadeOut(300), r.prop("disabled", !0)),
                                    t._updateTotalPrice();
                            }),
                            this.$form.on(o.change, "[data-groups-qty-value]", function () {
                                let n = e(this).closest(i),
                                    o = n.index();
                                t._updateItemPrice(n[0], o), t._updateTotalPrice();
                            });
                    },
                    _updateItemPrice: function (t, n) {
                        let i = e(t),
                            o = i.find("[data-groups-pr-sl]"),
                            a = parseInt(i.find("[data-groups-qty-value]").val()),
                            s = parseInt(o.attr("data-price")),
                            r = parseInt(o.attr("data-cpprice"));
                        (s *= a), (r *= a), (this.ArrayPrice[n] = s), (this.ArrayComparePrice[n] = r > s ? r : s);
                    },
                    _updateItem: function (t) {
                        let n = e(t),
                            o = n.find(":selected"),
                            a = n.closest(i),
                            s = a.data("index"),
                            r = void 0 === s ? a.index() : s,
                            l = o.data("img"),
                            c = o.data("max"),
                            d = a.find("[data-groups-qty-value]"),
                            u = d.val(),
                            p = this.$form.find(`[data-groups-img="${r}"] img`),
                            m = parseInt(o.data("price")),
                            f = parseInt(o.data("cpprice")),
                            h = a.find("[data-groups-item-price]");
                        d.attr("max", c), p.attr("data-orginal") != l && p.attr({ "data-src": l, "data-orginal": l }).removeClass("lazyloadt4sed").addClass("lazyloadt4s"), (f = f > m ? f : m);
                        let g = 0 == u ? m : u * m,
                            v = 0 == u ? f : u * f;
                        (m *= u),
                            (f *= u),
                            v > g
                                ? void 0 !== T4SProductStrings.price_template
                                    ? h.html(T4SProductStrings.price_template.replace("INS", T4SThemeSP.Currency.formatMoney(g)).replace("DEL", T4SThemeSP.Currency.formatMoney(v)))
                                    : h.html("<del>" + T4SThemeSP.Currency.formatMoney(v) + "</del> <ins>" + T4SThemeSP.Currency.formatMoney(g) + "</ins>")
                                : h.html(T4SThemeSP.Currency.formatMoney(g)),
                            n.attr({ "data-price": g, "data-cpprice": v }),
                            (this.ArrayPrice[r] == m && this.ArrayComparePrice[r] == f) || ((this.ArrayPrice[r] = m), (this.ArrayComparePrice[r] = f), this._updateTotalPrice());
                    },
                    _updateTotalPrice: function () {
                        let e = this.ArrayPrice.reduce((e, t) => e + t, 0),
                            t = this.ArrayComparePrice.reduce((e, t) => e + t, 0);
                        t > e
                            ? void 0 !== T4SProductStrings.price_template
                                ? this.$totalPrice.html(T4SProductStrings.price_template.replace("INS", T4SThemeSP.Currency.formatMoney(e)).replace("DEL", T4SThemeSP.Currency.formatMoney(t)))
                                : this.$totalPrice.html("<del>" + T4SThemeSP.Currency.formatMoney(t) + "</del> <ins>" + T4SThemeSP.Currency.formatMoney(e) + "</ins>")
                            : this.$totalPrice.html(T4SThemeSP.Currency.formatMoney(e)),
                            s.trigger("currency:update");
                    },
                })),
                t
            );
        })();
        (T4SThemeSP.initGroupsProduct = function () {
            0 != e("[data-groups-pr-form]:not(.is--enabled)").length &&
                e("[data-groups-pr-form]:not(.is--enabled)").each(function (t) {
                    e(this).addClass("is--enabled"), new x(this);
                });
        }),
            (T4SThemeSP.goToID = (function () {
                var t,
                    n,
                    i = "[data-go-id]",
                    o = (e("html,body"), 0);
                return function () {
                    0 != (t = e(i)).length &&
                        t.click(function (t) {
                            t.preventDefault(), t.stopPropagation();
                            let i = e(this),
                                a = i.data("go-id") || i.attr("href"),
                                s = e(a),
                                r = i.data("offset") || 100;
                            0 != s.length &&
                                (s.is(":hidden") && (e(`[data-t4s-tab-item][href="${a}"]:visible`).trigger("click"), (o = 100)),
                                clearTimeout(n),
                                (n = setTimeout(function () {
                                    window.scrollTo({ behavior: "smooth", top: s.offset().top - r });
                                }, o)));
                        });
                };
            })()),
            (T4SThemeSP.CanvasConfetti = (function () {
                function e(e) {
                    (this.x = Math.random() * l),
                        (this.y = Math.random() * c - c),
                        (this.r = (function (e, t) {
                            return Math.floor(Math.random() * (t - e + 1) + e);
                        })(10, 30)),
                        (this.d = Math.random() * p + 10),
                        (this.color = e),
                        (this.tilt = Math.floor(10 * Math.random()) - 10),
                        (this.tiltAngleIncremental = 0.07 * Math.random() + 0.05),
                        (this.tiltAngle = 0),
                        (this.draw = function () {
                            return r.beginPath(), (r.lineWidth = this.r / 2), (r.strokeStyle = this.color), r.moveTo(this.x + this.tilt + this.r / 4, this.y), r.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 4), r.stroke();
                        });
                }
                function t() {
                    if (T)
                        return (
                            o(),
                            a(),
                            (d = setTimeout(function () {
                                (g = !0),
                                    (v = !1),
                                    (function () {
                                        (s.style.display = "block"), (m = []), (v = !1);
                                        for (var t = 0; t < p; t++) {
                                            var n = y.getColor();
                                            m.push(new e(n));
                                        }
                                        (l = window.innerWidth),
                                            (c = window.innerHeight),
                                            (s.width = l),
                                            (s.height = c),
                                            (function e() {
                                                return v
                                                    ? null
                                                    : ((u = requestAnimFrameT4(e)),
                                                      (function () {
                                                          r.clearRect(0, 0, l, c);
                                                          for (var e = [], t = 0; t < p; t++)
                                                              !(function (t) {
                                                                  e.push(m[t].draw());
                                                              })(t);
                                                          return (
                                                              (function () {
                                                                  var e,
                                                                      t = 0;
                                                                  (f += 0.01), (h += 0.1);
                                                                  for (var n = 0; n < p; n++) {
                                                                      if (((e = m[n]), v)) return;
                                                                      !g && e.y < -15
                                                                          ? (e.y = c + 100)
                                                                          : ((function (e, t) {
                                                                                (e.tiltAngle += e.tiltAngleIncremental), (e.y += (Math.cos(f + e.d) + 3 + e.r / 2) / 2), (e.x += Math.sin(f)), (e.tilt = 15 * Math.sin(e.tiltAngle - t / 3));
                                                                            })(e, n),
                                                                            e.y <= c && t++,
                                                                            (function (e, t) {
                                                                                (e.x > l + 20 || e.x < -20 || e.y > c) &&
                                                                                    g &&
                                                                                    (t % 5 > 0 || t % 2 == 0
                                                                                        ? i(e, Math.random() * l, -10, Math.floor(10 * Math.random()) - 10)
                                                                                        : Math.sin(f) > 0
                                                                                        ? i(e, -5, Math.random() * c, Math.floor(10 * Math.random()) - 10)
                                                                                        : i(e, l + 5, Math.random() * c, Math.floor(10 * Math.random()) - 10));
                                                                            })(e, n));
                                                                  }
                                                                  0 === t && a();
                                                              })(),
                                                              e
                                                          );
                                                      })());
                                            })();
                                    })();
                            }, 100)),
                            void setTimeout(function () {
                                (g = !1), o();
                            }, 3500)
                        );
                    T4SThemeSP.$appendComponent.after('<canvas id="confettiCanvas" style="position:fixed;top:0;left:0;display:none;z-index:9999;pointer-events: none;"></canvas>'),
                        (s = document.getElementById("confettiCanvas")),
                        (r = s.getContext("2d")),
                        (l = window.innerWidth),
                        (c = window.innerHeight),
                        (s.width = l),
                        (s.height = c),
                        n.resize(function () {
                            (l = window.innerWidth), (c = window.innerHeight), (s.width = l), (s.height = c);
                        }),
                        (T = !0);
                }
                function i(e, t, n, i) {
                    (e.x = t), (e.y = n), (e.tilt = i);
                }
                function o() {
                    clearTimeout(d), clearTimeout(u);
                }
                function a() {
                    (v = !0), void 0 != r && (r.clearRect(0, 0, l, c), (s.style.display = "none"));
                }
                var s,
                    r,
                    l,
                    c,
                    d,
                    u,
                    p = window.innerWidth < 988 ? 75 : 150,
                    m = [],
                    f = 0,
                    h = 0,
                    g = !0,
                    v = !0,
                    T = !1,
                    y = {
                        colorOptions: ["DodgerBlue", "OliveDrab", "Gold", "pink", "SlateBlue", "lightblue", "Violet", "PaleGreen", "SteelBlue", "SandyBrown", "Chocolate", "Crimson"],
                        colorIndex: 0,
                        colorIncrementer: 0,
                        colorThreshold: 10,
                        getColor: function () {
                            return (
                                this.colorIncrementer >= 10 && ((this.colorIncrementer = 0), this.colorIndex++, this.colorIndex >= this.colorOptions.length && (this.colorIndex = 0)),
                                this.colorIncrementer++,
                                this.colorOptions[this.colorIndex]
                            );
                        },
                    };
                return (
                    (window.requestAnimFrameT4 =
                        window.requestAnimationFrame ||
                        window.webkitRequestAnimationFrame ||
                        window.mozRequestAnimationFrame ||
                        window.oRequestAnimationFrame ||
                        window.msRequestAnimationFrame ||
                        function (e) {
                            return window.setTimeout(e, 1e3 / 60);
                        }),
                    t
                );
            })()),
            (T4SThemeSP.ToggleClass = void e(document).on("click", "[data-toggle-class]", function (t) {
                var n = e(this).attr("data-toggle-class"),
                    i = e(this).attr("data-toggle-trigger");
                e(this).toggleClass(n), e(i).toggleClass(n);
            }));
    })(jQuery_T4NT),
    jQuery_T4NT(document).ready(function () {
        T4SThemeSP.Hover(),
            T4SThemeSP.Header.stickyInit(),
            T4SThemeSP.MobileNav(),
            T4SThemeSP.Cart.init(),
            T4SThemeSP.agreeForm(),
            T4SThemeSP.Login(),
            T4SThemeSP.Compare.init(),
            T4SThemeSP.Wishlist.init(),
            T4SThemeSP.recentlyViewed(),
            T4SThemeSP.productRecommendations(),
            T4SThemeSP.ProductItem.init(),
            T4SThemeSP.ProductItem.loadjsRevew(),
            T4SThemeSP.Tooltip(),
            T4SThemeSP.ProductItem.clickMoreSwatches(),
            T4SThemeSP.ProductItem.swatchesClickHover(),
            T4SThemeSP.ProductItem.resizeObserver(),
            T4SThemeSP.ProductItem.initQuickVS(),
            T4SThemeSP.RenderRefresh(),
            T4SThemeSP.ProductAjax.init(),
            T4SThemeSP._initBundlePrs(),
            T4SThemeSP.T4sQuantityAdjust(),
            T4SThemeSP.PhotoSwipe.gallery(),
            T4SThemeSP.PhotoSwipe.images(),
            T4SThemeSP.PhotoSwipe.image(),
            T4SThemeSP.Video.initPoster(),
            T4SThemeSP.initLoadMore(),
            (jQuery_T4NT(".t4s-section-main [data-ntajax-container]").length > 0 || IsDesignMode) && $script(T4Sconfigs.script7, "t4s:facets"),
            T4SThemeSP.instagram(),
            T4SThemeSP.sideBarInit(),
            T4SThemeSP.LookBook(),
            T4SThemeSP.initGroupsProduct(),
            IsDesignMode
                ? T4SThemeSP.PopupPro()
                : setTimeout(function () {
                      T4SThemeSP.PopupFetch();
                  }, 686),
            setTimeout(function () {
                T4SThemeSP.PlatFormMail(), T4SThemeSP.goToID();
            }, 500),
            T4SThemeSP.isHover && jQuery_T4NT("[data-zoom-options]").length > 0 && $script(T4Sconfigs.script5, "t4s:zoom"),
            document.addEventListener("theme:hover", function (e) {
                jQuery_T4NT("[data-zoom-options]").length > 0 && $script(T4Sconfigs.script5, "t4s:zoom");
            }),
            T4SThemeSP.BackToTop(),
            T4SThemeSP.Header.init(),
            T4SThemeSP.currencyForm(),
            "2" == T4Sconfigs.currency_type && $script(T4Sconfigs.script12a),
            "none" != T4Sconfigs.script11 && $script(T4Sconfigs.script11, "t4s:customjs");
    }),
    jQuery_T4NT(window).resize(function () {
        T4SThemeSP.ProductItem.recalculateSwatches(!0);
    });
